var _copyToClipboard,
  copyToClipboard_fn,
  __accessCheck = (e, t, i) => {
    if (!t.has(e)) throw TypeError('Cannot ' + i);
  },
  __privateGet = (e, t, i) => (__accessCheck(e, t, 'read from private field'), i ? i.call(e) : t.get(e)),
  __privateAdd = (e, t, i) => {
    if (t.has(e)) throw TypeError('Cannot add the same private member more than once');
    t instanceof WeakSet ? t.add(e) : t.set(e, i);
  },
  __privateSet = (e, t, i, n) => (__accessCheck(e, t, 'write to private field'), n ? n.call(e, i) : t.set(e, i), i),
  __privateMethod = (e, t, i) => (__accessCheck(e, t, 'access private method'), i),
  ConfirmButton = class extends HTMLButtonElement {
    constructor() {
      (super(),
        this.addEventListener('click', (e) => {
          window.confirm(this.getAttribute('data-message') ?? 'Once confirmed, this action cannot be undone.') ||
            e.preventDefault();
        }));
    }
  };
window.customElements.get('confirm-button') ||
  window.customElements.define('confirm-button', ConfirmButton, { extends: 'button' });
var _showSystemShare,
  showSystemShare_fn,
  CopyButton = class extends HTMLButtonElement {
    constructor() {
      (super(),
        __privateAdd(this, _copyToClipboard),
        this.addEventListener('click', __privateMethod(this, _copyToClipboard, copyToClipboard_fn)));
    }
  };
((_copyToClipboard = new WeakSet()),
  (copyToClipboard_fn = async function () {
    if (
      navigator.clipboard &&
      (await navigator.clipboard.writeText(this.getAttribute('data-text') ?? ''),
      this.hasAttribute('data-success-message'))
    ) {
      const e = this.textContent;
      ((this.textContent = this.getAttribute('data-success-message')),
        setTimeout(() => {
          this.textContent = e;
        }, 1500));
    }
  }),
  window.customElements.get('copy-button') ||
    window.customElements.define('copy-button', CopyButton, { extends: 'button' }));
var _currentAnimation,
  _direction,
  direction_get,
  _scroller,
  scroller_get,
  _initialize,
  initialize_fn,
  ShareButton = class extends HTMLButtonElement {
    constructor() {
      (super(),
        __privateAdd(this, _showSystemShare),
        navigator.share &&
          ((this.hidden = !1),
          this.addEventListener('click', __privateMethod(this, _showSystemShare, showSystemShare_fn))));
    }
  };
((_showSystemShare = new WeakSet()),
  (showSystemShare_fn = function () {
    navigator.share({
      title: this.hasAttribute('share-title') ? this.getAttribute('share-title') : document.title,
      url: this.hasAttribute('share-url') ? this.getAttribute('share-url') : window.location.href,
    });
  }),
  window.customElements.get('share-button') ||
    window.customElements.define('share-button', ShareButton, { extends: 'button' }));
import { inView, animate } from 'vendor';
var _domElement,
  _thresholdDistance,
  _thresholdTime,
  _signal,
  _firstClientX,
  _tracking,
  _start,
  _touchStart,
  touchStart_fn,
  _preventTouch,
  preventTouch_fn,
  _gestureStart,
  gestureStart_fn,
  _gestureMove,
  gestureMove_fn,
  _gestureEnd,
  gestureEnd_fn,
  MarqueeText = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _direction),
        __privateAdd(this, _scroller),
        __privateAdd(this, _initialize),
        __privateAdd(this, _currentAnimation, void 0),
        inView(this, __privateMethod(this, _initialize, initialize_fn).bind(this), { margin: '400px' }),
        this.hasAttribute('pause-on-hover') &&
          (this.addEventListener('pointerenter', () => __privateGet(this, _currentAnimation)?.pause()),
          this.addEventListener('pointerleave', () => __privateGet(this, _currentAnimation)?.play())));
    }
  };
((_currentAnimation = new WeakMap()),
  (_direction = new WeakSet()),
  (direction_get = function () {
    return 'right' === this.getAttribute('direction') ? 1 : -1;
  }),
  (_scroller = new WeakSet()),
  (scroller_get = function () {
    return this.shadowRoot.querySelector('[part="scroller"]');
  }),
  (_initialize = new WeakSet()),
  (initialize_fn = function () {
    this.attachShadow({ mode: 'open' }).appendChild(
      document.createRange().createContextualFragment('\n      <slot part="scroller"></slot>\n    '),
    );
    const e = document.createDocumentFragment();
    for (let t = 1; t <= 5; ++t) {
      const i = this.firstElementChild.cloneNode(!0);
      (i.setAttribute('aria-hidden', 'true'),
        (i.style.cssText = `position: absolute; inset-inline-start: ${100 * t * -__privateGet(this, _direction, direction_get)}%;`),
        e.appendChild(i));
    }
    (this.append(e),
      __privateSet(
        this,
        _currentAnimation,
        animate(
          __privateGet(this, _scroller, scroller_get),
          {
            transform: [
              'translateX(0)',
              `translateX(calc(var(--transform-logical-flip) * ${100 * __privateGet(this, _direction, direction_get)}%))`,
            ],
          },
          {
            duration:
              (1 / parseFloat(this.getAttribute('speed'))) *
              (__privateGet(this, _scroller, scroller_get).clientWidth / 300),
            easing: 'linear',
            repeat: 1 / 0,
          },
        ),
      ));
  }),
  window.customElements.get('marquee-text') || window.customElements.define('marquee-text', MarqueeText));
var _onCountryChangedListener,
  _onCountryChanged,
  onCountryChanged_fn,
  GestureArea = class {
    constructor(e, { thresholdDistance: t = 80, thresholdTime: i = 500, signal: n = null } = {}) {
      (__privateAdd(this, _touchStart),
        __privateAdd(this, _preventTouch),
        __privateAdd(this, _gestureStart),
        __privateAdd(this, _gestureMove),
        __privateAdd(this, _gestureEnd),
        __privateAdd(this, _domElement, void 0),
        __privateAdd(this, _thresholdDistance, void 0),
        __privateAdd(this, _thresholdTime, void 0),
        __privateAdd(this, _signal, void 0),
        __privateAdd(this, _firstClientX, void 0),
        __privateAdd(this, _tracking, !1),
        __privateAdd(this, _start, {}),
        __privateSet(this, _domElement, e),
        __privateSet(this, _thresholdDistance, t),
        __privateSet(this, _thresholdTime, i),
        __privateSet(this, _signal, n ?? new AbortController().signal),
        __privateGet(this, _domElement).addEventListener(
          'touchstart',
          __privateMethod(this, _touchStart, touchStart_fn).bind(this),
          { passive: !0, signal: __privateGet(this, _signal) },
        ),
        __privateGet(this, _domElement).addEventListener(
          'touchmove',
          __privateMethod(this, _preventTouch, preventTouch_fn).bind(this),
          { passive: !1, signal: __privateGet(this, _signal) },
        ),
        __privateGet(this, _domElement).addEventListener(
          'pointerdown',
          __privateMethod(this, _gestureStart, gestureStart_fn).bind(this),
          { signal: __privateGet(this, _signal) },
        ),
        __privateGet(this, _domElement).addEventListener(
          'pointermove',
          __privateMethod(this, _gestureMove, gestureMove_fn).bind(this),
          { passive: !1, signal: __privateGet(this, _signal) },
        ),
        __privateGet(this, _domElement).addEventListener(
          'pointerup',
          __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this),
          { signal: __privateGet(this, _signal) },
        ),
        __privateGet(this, _domElement).addEventListener(
          'pointerleave',
          __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this),
          { signal: __privateGet(this, _signal) },
        ),
        __privateGet(this, _domElement).addEventListener(
          'pointercancel',
          __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this),
          { signal: __privateGet(this, _signal) },
        ));
    }
  };
((_domElement = new WeakMap()),
  (_thresholdDistance = new WeakMap()),
  (_thresholdTime = new WeakMap()),
  (_signal = new WeakMap()),
  (_firstClientX = new WeakMap()),
  (_tracking = new WeakMap()),
  (_start = new WeakMap()),
  (_touchStart = new WeakSet()),
  (touchStart_fn = function (e) {
    __privateSet(this, _firstClientX, e.touches[0].clientX);
  }),
  (_preventTouch = new WeakSet()),
  (preventTouch_fn = function (e) {
    Math.abs(e.touches[0].clientX - __privateGet(this, _firstClientX)) > 10 && e.preventDefault();
  }),
  (_gestureStart = new WeakSet()),
  (gestureStart_fn = function (e) {
    (__privateSet(this, _tracking, !0),
      __privateSet(this, _start, { time: new Date().getTime(), x: e.clientX, y: e.clientY }));
  }),
  (_gestureMove = new WeakSet()),
  (gestureMove_fn = function (e) {
    __privateGet(this, _tracking) && e.preventDefault();
  }),
  (_gestureEnd = new WeakSet()),
  (gestureEnd_fn = function (e) {
    if (!__privateGet(this, _tracking)) return;
    __privateSet(this, _tracking, !1);
    const t = new Date().getTime() - __privateGet(this, _start).time,
      i = e.clientX - __privateGet(this, _start).x,
      n = e.clientY - __privateGet(this, _start).y;
    if (t > __privateGet(this, _thresholdTime)) return;
    let a;
    (0 === i && 0 === n
      ? (a = 'tap')
      : i > __privateGet(this, _thresholdDistance) && Math.abs(n) < __privateGet(this, _thresholdDistance)
        ? (a = 'swiperight')
        : -i > __privateGet(this, _thresholdDistance) && Math.abs(n) < __privateGet(this, _thresholdDistance)
          ? (a = 'swipeleft')
          : n > __privateGet(this, _thresholdDistance) && Math.abs(i) < __privateGet(this, _thresholdDistance)
            ? (a = 'swipedown')
            : -n > __privateGet(this, _thresholdDistance) &&
              Math.abs(i) < __privateGet(this, _thresholdDistance) &&
              (a = 'swipeup'),
      a &&
        __privateGet(this, _domElement).dispatchEvent(
          new CustomEvent(a, { bubbles: !0, composed: !0, detail: { originalEvent: e } }),
        ));
  }));
var CountrySelector = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onCountryChanged),
      __privateAdd(
        this,
        _onCountryChangedListener,
        __privateMethod(this, _onCountryChanged, onCountryChanged_fn).bind(this),
      ));
  }
  connectedCallback() {
    ((this.countryElement = this.querySelector('[name="address[country]"]')),
      (this.provinceElement = this.querySelector('[name="address[province]"]')),
      this.countryElement.addEventListener('change', __privateGet(this, _onCountryChangedListener)),
      this.hasAttribute('country') &&
        '' !== this.getAttribute('country') &&
        (this.countryElement.selectedIndex = Math.max(
          0,
          Array.from(this.countryElement.options).findIndex((e) => e.textContent === this.getAttribute('country')),
        )),
      this.countryElement.dispatchEvent(new Event('change')));
  }
  disconnectedCallback() {
    this.countryElement.removeEventListener('change', __privateGet(this, _onCountryChangedListener));
  }
};
function formatMoney(e, t = '') {
  'string' == typeof e && (e = e.replace('.', ''));
  const i = /\{\{\s*(\w+)\s*\}\}/,
    n = t || window.themeVariables.settings.moneyFormat;
  function a(e, t) {
    return null == e || e != e ? t : e;
  }
  function r(e, t, i, n) {
    if (((t = a(t, 2)), (i = a(i, ',')), (n = a(n, '.')), isNaN(e) || null == e)) return 0;
    let r = (e = (e / 100).toFixed(t)).split('.');
    return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + i) + (r[1] ? n + r[1] : '');
  }
  let o = '';
  switch (n.match(i)[1]) {
    case 'amount':
    default:
      o = r(e, 2);
      break;
    case 'amount_no_decimals':
      o = r(e, 0);
      break;
    case 'amount_with_space_separator':
      o = r(e, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      o = r(e, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      o = r(e, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      o = r(e, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      o = r(e, 0, ' ');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      o = r(e, 0, "'");
  }
  return (n.indexOf('with_comma_separator'), n.replace(i, o));
}
((_onCountryChangedListener = new WeakMap()),
  (_onCountryChanged = new WeakSet()),
  (onCountryChanged_fn = function () {
    const e = this.countryElement.options[this.countryElement.selectedIndex],
      t = JSON.parse(e.getAttribute('data-provinces'));
    ((this.provinceElement.parentElement.hidden = 0 === t.length),
      0 !== t.length &&
        ((this.provinceElement.innerHTML = ''),
        t.forEach((e) => {
          const t = e[1] === this.getAttribute('province') || e[0] === this.getAttribute('province');
          this.provinceElement.options.add(new Option(e[1], e[0], t, t));
        })));
  }),
  window.customElements.get('country-selector') || window.customElements.define('country-selector', CountrySelector));
var _callback,
  _duration,
  _remainingTime,
  _startTime,
  _timer,
  _state,
  _onVisibilityChangeListener,
  _mustResumeOnVisibility,
  _onVisibilityChange,
  onVisibilityChange_fn,
  cachedMap = new Map();
function cachedFetch(e, t) {
  const i = e;
  return cachedMap.has(i)
    ? Promise.resolve(new Response(new Blob([cachedMap.get(i)])))
    : fetch(e, t).then((e) => {
        if (200 === e.status) {
          const t = e.headers.get('Content-Type');
          t &&
            (t.match(/application\/json/i) || t.match(/text\//i)) &&
            e
              .clone()
              .text()
              .then((e) => {
                cachedMap.set(i, e);
              });
        }
        return e;
      });
}
function extractSectionId(e) {
  return (e = e.classList.contains('shopify-section') ? e : e.closest('.shopify-section')).id.replace(
    'shopify-section-',
    '',
  );
}
function throttle(e) {
  let t,
    i = null;
  const n = (...n) => {
    var a;
    ((t = n),
      null === i &&
        (i = requestAnimationFrame(
          ((a = this),
          () => {
            ((i = null), e.apply(a, t));
          }),
        )));
  };
  return (
    (n.cancel = () => {
      (cancelAnimationFrame(i), (i = null));
    }),
    n
  );
}
function debounce(e, t) {
  let i = null;
  return (...n) => {
    (clearTimeout(i),
      (i = setTimeout(() => {
        e.apply(this, n);
      }, t)));
  };
}
function waitForEvent(e, t) {
  return new Promise((i) => {
    const n = (a) => {
      a.target === e && (e.removeEventListener(t, n), i(a));
    };
    e.addEventListener(t, n);
  });
}
function videoLoaded(e) {
  return e
    ? ((e = e instanceof Element ? [e] : Array.from(e)),
      Promise.all(
        e.map(
          (e) =>
            new Promise((t) => {
              ('VIDEO' === e.tagName && e.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) ||
              !e.offsetParent ||
              e.parentNode.hasAttribute('suspended')
                ? t()
                : (e.oncanplay = () => t());
            }),
        ),
      ))
    : Promise.resolve();
}
function imageLoaded(e) {
  return e
    ? ((e = e instanceof Element ? [e] : Array.from(e)),
      Promise.all(
        e.map(
          (e) =>
            new Promise((t) => {
              ('IMG' === e.tagName && e.complete) || !e.offsetParent ? t() : (e.onload = () => t());
            }),
        ),
      ))
    : Promise.resolve();
}
function generateSrcset(e, t = []) {
  let i, n;
  return (
    'string' == typeof e
      ? ((i = new URL(e.startsWith('//') ? `https:${e}` : e)), (n = parseInt(i.searchParams.get('width'))))
      : ((i = new URL(e.src)), (n = e.width)),
    t
      .filter((e) => e <= n)
      .map((e) => (i.searchParams.set('width', e.toString()), `${i.href} ${e}w`))
      .join(', ')
  );
}
function createMediaImg(e, t = [], i = {}) {
  const n = new Image(e.preview_image.width, e.preview_image.height),
    a = new URL(e.preview_image.src);
  for (const e in i) n.setAttribute(e, i[e]);
  return ((n.alt = e.alt || ''), (n.src = a.href), (n.srcset = generateSrcset(e.preview_image, t)), n);
}
function matchesMediaQuery(e) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(e)) throw `Media query ${e} does not exist`;
  return window.matchMedia(window.themeVariables.mediaQueries[e]).matches;
}
function mediaQueryListener(e, t) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(e)) throw `Media query ${e} does not exist`;
  return window.matchMedia(window.themeVariables.mediaQueries[e]).addEventListener('change', t);
}
var Player = class extends EventTarget {
  constructor(e, t = !0) {
    (super(),
      __privateAdd(this, _onVisibilityChange),
      __privateAdd(this, _callback, void 0),
      __privateAdd(this, _duration, void 0),
      __privateAdd(this, _remainingTime, void 0),
      __privateAdd(this, _startTime, void 0),
      __privateAdd(this, _timer, void 0),
      __privateAdd(this, _state, 'paused'),
      __privateAdd(
        this,
        _onVisibilityChangeListener,
        __privateMethod(this, _onVisibilityChange, onVisibilityChange_fn).bind(this),
      ),
      __privateAdd(this, _mustResumeOnVisibility, !0),
      __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent('player:end'))),
      __privateSet(this, _duration, __privateSet(this, _remainingTime, 1e3 * e)),
      t && document.addEventListener('visibilitychange', __privateGet(this, _onVisibilityChangeListener)));
  }
  pause() {
    'started' === __privateGet(this, _state) &&
      (clearTimeout(__privateGet(this, _timer)),
      __privateSet(this, _state, 'paused'),
      __privateSet(
        this,
        _remainingTime,
        __privateGet(this, _remainingTime) - (new Date().getTime() - __privateGet(this, _startTime)),
      ),
      this.dispatchEvent(new CustomEvent('player:pause')));
  }
  resume(e = !1) {
    'stopped' !== __privateGet(this, _state) &&
      (e
        ? this.start()
        : (clearTimeout(__privateGet(this, _timer)),
          __privateSet(this, _startTime, new Date().getTime()),
          __privateSet(this, _state, 'started'),
          __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime))),
          this.dispatchEvent(new CustomEvent('player:resume'))));
  }
  start() {
    (clearTimeout(__privateGet(this, _timer)),
      __privateSet(this, _startTime, new Date().getTime()),
      __privateSet(this, _state, 'started'),
      __privateSet(this, _remainingTime, __privateGet(this, _duration)),
      __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime))),
      this.dispatchEvent(new CustomEvent('player:start')));
  }
  stop() {
    (clearTimeout(__privateGet(this, _timer)),
      __privateSet(this, _state, 'stopped'),
      this.dispatchEvent(new CustomEvent('player:stop')));
  }
};
((_callback = new WeakMap()),
  (_duration = new WeakMap()),
  (_remainingTime = new WeakMap()),
  (_startTime = new WeakMap()),
  (_timer = new WeakMap()),
  (_state = new WeakMap()),
  (_onVisibilityChangeListener = new WeakMap()),
  (_mustResumeOnVisibility = new WeakMap()),
  (_onVisibilityChange = new WeakSet()),
  (onVisibilityChange_fn = function () {
    'hidden' === document.visibilityState
      ? (__privateSet(this, _mustResumeOnVisibility, 'started' === __privateGet(this, _state)),
        this.pause(),
        this.dispatchEvent(new CustomEvent('player:visibility-pause')))
      : 'visible' === document.visibilityState &&
        __privateGet(this, _mustResumeOnVisibility) &&
        (this.resume(), this.dispatchEvent(new CustomEvent('player:visibility-resume')));
  }));
var _updateCustomProperties,
  updateCustomProperties_fn,
  QrCode = class extends HTMLElement {
    connectedCallback() {
      new window.QRCode(this, {
        text: this.getAttribute('identifier'),
        width: this.hasAttribute('width') ? parseInt(this.getAttribute('width')) : 200,
        height: this.hasAttribute('height') ? parseInt(this.getAttribute('height')) : 200,
      });
    }
  };
window.customElements.get('qr-code') || window.customElements.define('qr-code', QrCode);
var _onLoadingStart,
  onLoadingStart_fn,
  _onLoadingEnd,
  onLoadingEnd_fn,
  HeightObserver = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _updateCustomProperties),
        window.ResizeObserver &&
          new ResizeObserver(
            throttle(__privateMethod(this, _updateCustomProperties, updateCustomProperties_fn).bind(this)),
          ).observe(this));
    }
    connectedCallback() {
      window.ResizeObserver ||
        document.documentElement.style.setProperty(
          `--${this.getAttribute('variable')}-height`,
          `${this.clientHeight.toFixed(2)}px`,
        );
    }
  };
((_updateCustomProperties = new WeakSet()),
  (updateCustomProperties_fn = function (e) {
    e.forEach((e) => {
      if (e.target === this) {
        const t = e.borderBoxSize
          ? e.borderBoxSize.length > 0
            ? e.borderBoxSize[0].blockSize
            : e.borderBoxSize.blockSize
          : e.target.clientHeight;
        document.documentElement.style.setProperty(`--${this.getAttribute('variable')}-height`, `${t.toFixed(2)}px`);
      }
    });
  }),
  window.customElements.get('height-observer') || window.customElements.define('height-observer', HeightObserver));
import { animate as animate2 } from 'vendor';
var _resizeObserver,
  _checkPositionListener,
  _initialTop,
  _lastKnownY,
  _currentTop,
  _position,
  _recalculateStyles,
  recalculateStyles_fn,
  _checkPosition,
  checkPosition_fn,
  LoadingBar = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _onLoadingStart),
        __privateAdd(this, _onLoadingEnd),
        document.addEventListener(
          'theme:loading:start',
          __privateMethod(this, _onLoadingStart, onLoadingStart_fn).bind(this),
        ),
        document.addEventListener(
          'theme:loading:end',
          __privateMethod(this, _onLoadingEnd, onLoadingEnd_fn).bind(this),
        ));
    }
  };
((_onLoadingStart = new WeakSet()),
  (onLoadingStart_fn = function () {
    animate2(this, { opacity: [0, 1], transform: ['scaleX(0)', 'scaleX(0.4)'] }, { duration: 0.25 });
  }),
  (_onLoadingEnd = new WeakSet()),
  (onLoadingEnd_fn = async function () {
    (await animate2(this, { transform: [null, 'scaleX(1)'] }, { duration: 0.25 }).finished,
      animate2(this, { opacity: 0 }, { duration: 0.25 }));
  }),
  window.customElements.get('loading-bar') || window.customElements.define('loading-bar', LoadingBar));
import { inView as inView2 } from 'vendor';
var _abortController,
  _allItems,
  _onCarouselFilter,
  onCarouselFilter_fn,
  SafeSticky = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _recalculateStyles),
        __privateAdd(this, _checkPosition),
        __privateAdd(
          this,
          _resizeObserver,
          new ResizeObserver(__privateMethod(this, _recalculateStyles, recalculateStyles_fn).bind(this)),
        ),
        __privateAdd(
          this,
          _checkPositionListener,
          throttle(__privateMethod(this, _checkPosition, checkPosition_fn).bind(this)),
        ),
        __privateAdd(this, _initialTop, 0),
        __privateAdd(this, _lastKnownY, 0),
        __privateAdd(this, _currentTop, 0),
        __privateAdd(this, _position, 'relative'));
    }
    connectedCallback() {
      inView2(
        this,
        () => (
          window.addEventListener('scroll', __privateGet(this, _checkPositionListener)),
          __privateGet(this, _resizeObserver).observe(this),
          () => {
            (window.removeEventListener('scroll', __privateGet(this, _checkPositionListener)),
              __privateGet(this, _resizeObserver).unobserve(this));
          }
        ),
        { margin: '500px' },
      );
    }
    disconnectedCallback() {
      (window.removeEventListener('scroll', __privateGet(this, _checkPositionListener)),
        __privateGet(this, _resizeObserver).unobserve(this));
    }
  };
((_resizeObserver = new WeakMap()),
  (_checkPositionListener = new WeakMap()),
  (_initialTop = new WeakMap()),
  (_lastKnownY = new WeakMap()),
  (_currentTop = new WeakMap()),
  (_position = new WeakMap()),
  (_recalculateStyles = new WeakSet()),
  (recalculateStyles_fn = function () {
    this.style.removeProperty('top');
    const e = getComputedStyle(this);
    (__privateSet(this, _initialTop, parseInt(e.top)),
      __privateSet(this, _position, e.position),
      __privateMethod(this, _checkPosition, checkPosition_fn).call(this));
  }),
  (_checkPosition = new WeakSet()),
  (checkPosition_fn = function () {
    if ('sticky' !== __privateGet(this, _position)) return this.style.removeProperty('top');
    let e = this.getBoundingClientRect().top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop),
      t = this.clientHeight - window.innerHeight + 20;
    (window.scrollY < __privateGet(this, _lastKnownY)
      ? __privateSet(
          this,
          _currentTop,
          __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY)),
        )
      : __privateSet(
          this,
          _currentTop,
          __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY),
        ),
      __privateSet(
        this,
        _currentTop,
        Math.min(Math.max(__privateGet(this, _currentTop), -t), e, __privateGet(this, _initialTop)),
      ),
      __privateSet(this, _lastKnownY, window.scrollY),
      (this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`));
  }),
  window.customElements.get('safe-sticky') || window.customElements.define('safe-sticky', SafeSticky));
var CarouselNavigation = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onCarouselFilter),
      __privateAdd(this, _abortController, void 0),
      __privateAdd(this, _allItems, []));
  }
  connectedCallback() {
    if (!this.carousel)
      throw 'Carousel navigation component requires an aria-controls attribute that refers to the controlled carousel.';
    (__privateSet(this, _abortController, new AbortController()),
      __privateSet(this, _allItems, Array.from(this.querySelectorAll('button'))),
      __privateGet(this, _allItems).forEach((e) =>
        e.addEventListener('click', () => this.onButtonClicked(this.items.indexOf(e)), {
          signal: __privateGet(this, _abortController).signal,
        }),
      ),
      this.carousel.addEventListener('carousel:change', (e) => this.onNavigationChange(e.detail.index), {
        signal: __privateGet(this, _abortController).signal,
      }),
      this.carousel.addEventListener(
        'carousel:filter',
        __privateMethod(this, _onCarouselFilter, onCarouselFilter_fn).bind(this),
        { signal: __privateGet(this, _abortController).signal },
      ));
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
  get items() {
    return __privateGet(this, _allItems).filter((e) => !e.hasAttribute('hidden'));
  }
  get carousel() {
    return document.getElementById(this.getAttribute('aria-controls'));
  }
  get selectedIndex() {
    return this.items.findIndex((e) => 'true' === e.getAttribute('aria-current'));
  }
  onButtonClicked(e) {
    (this.carousel.select(e), this.onNavigationChange(e));
  }
  onNavigationChange(e) {
    (this.items.forEach((t, i) => t.setAttribute('aria-current', e === i ? 'true' : 'false')),
      !this.hasAttribute('align-selected') ||
        (this.scrollWidth === this.clientWidth && this.scrollHeight === this.clientHeight) ||
        this.scrollTo({
          left: this.items[e].offsetLeft - this.clientWidth / 2 + this.items[e].clientWidth / 2,
          top: this.items[e].offsetTop - this.clientHeight / 2 + this.items[e].clientHeight / 2,
          behavior: matchesMediaQuery('motion-safe') ? 'smooth' : 'auto',
        }));
  }
};
((_abortController = new WeakMap()),
  (_allItems = new WeakMap()),
  (_onCarouselFilter = new WeakSet()),
  (onCarouselFilter_fn = function (e) {
    __privateGet(this, _allItems).forEach((t, i) => {
      t.toggleAttribute('hidden', (e.detail.filteredIndexes || []).includes(i));
    });
  }));
var _listenersAbortController,
  _gestureArea,
  _player,
  _targetIndex,
  _preventInitialTransition,
  _setupListeners,
  setupListeners_fn,
  _onKeyboardNavigation,
  onKeyboardNavigation_fn,
  _preloadImages,
  preloadImages_fn,
  CarouselPrevButton = class extends HTMLButtonElement {
    #e;
    connectedCallback() {
      if (!this.carousel)
        throw 'Carousel prev button component requires an aria-controls attribute that refers to the controlled carousel.';
      ((this.#e = new AbortController()),
        this.addEventListener('click', () => this.carousel.previous(), { signal: this.#e.signal }),
        this.carousel.addEventListener('scroll:edge-nearing', (e) => (this.disabled = 'start' === e.detail.position), {
          signal: this.#e.signal,
        }),
        this.carousel.addEventListener(
          'scroll:edge-leaving',
          (e) => (this.disabled = 'start' !== e.detail.position && this.disabled),
          { signal: this.#e.signal },
        ));
    }
    disconnectedCallback() {
      this.#e.abort();
    }
    get carousel() {
      return document.getElementById(this.getAttribute('aria-controls'));
    }
  },
  CarouselNextButton = class extends HTMLButtonElement {
    #e;
    connectedCallback() {
      if (!this.carousel)
        throw 'Carousel next button component requires an aria-controls attribute that refers to the controlled carousel.';
      ((this.#e = new AbortController()),
        this.addEventListener('click', () => this.carousel.next(), { signal: this.#e.signal }),
        this.carousel.addEventListener('scroll:edge-nearing', (e) => (this.disabled = 'end' === e.detail.position), {
          signal: this.#e.signal,
        }),
        this.carousel.addEventListener(
          'scroll:edge-leaving',
          (e) => (this.disabled = 'end' !== e.detail.position && this.disabled),
          { signal: this.#e.signal },
        ));
    }
    disconnectedCallback() {
      this.#e.abort();
    }
    get carousel() {
      return document.getElementById(this.getAttribute('aria-controls'));
    }
  };
(window.customElements.get('carousel-prev-button') ||
  window.customElements.define('carousel-prev-button', CarouselPrevButton, { extends: 'button' }),
  window.customElements.get('carousel-next-button') ||
    window.customElements.define('carousel-next-button', CarouselNextButton, { extends: 'button' }),
  window.customElements.get('carousel-navigation') ||
    window.customElements.define('carousel-navigation', CarouselNavigation));
import { animate as animate3, timeline, inView as inView3 } from 'vendor';
var _hasPendingProgrammaticScroll,
  _onMouseDownListener,
  _onMouseMoveListener,
  _onMouseClickListener,
  _onMouseUpListener,
  _targetIndex2,
  _forceChangeEvent,
  _dragPosition,
  _isDragging,
  _dispatchableScrollEvents,
  _scrollTimeout,
  _setupListeners2,
  setupListeners_fn2,
  _updateTargetIndex,
  updateTargetIndex_fn,
  _onScroll,
  onScroll_fn,
  _onScrollEnd,
  onScrollEnd_fn,
  _calculateLeftScroll,
  calculateLeftScroll_fn,
  _calculateClosestIndexToAlignment,
  calculateClosestIndexToAlignment_fn,
  _onMouseDown,
  onMouseDown_fn,
  _onMouseMove,
  onMouseMove_fn,
  _onMouseClick,
  onMouseClick_fn,
  _onMouseUp,
  onMouseUp_fn,
  _onResize,
  onResize_fn,
  _onMutate,
  onMutate_fn,
  _adaptHeight,
  adaptHeight_fn,
  _preloadImages2,
  preloadImages_fn2,
  EffectCarousel = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _setupListeners),
        __privateAdd(this, _onKeyboardNavigation),
        __privateAdd(this, _preloadImages),
        __privateAdd(this, _listenersAbortController, void 0),
        __privateAdd(this, _gestureArea, void 0),
        __privateAdd(this, _player, void 0),
        __privateAdd(this, _targetIndex, 0),
        __privateAdd(this, _preventInitialTransition, !1),
        __privateMethod(this, _setupListeners, setupListeners_fn).call(this),
        inView3(this, () => this.onBecameVisible()),
        this.addEventListener('carousel:settle', (e) => {
          this.allCells.forEach((t) => t.classList.toggle('is-selected', t === e.detail.cell));
        }));
    }
    connectedCallback() {
      (__privateSet(
        this,
        _targetIndex,
        Math.max(
          0,
          this.cells.findIndex((e) => e.classList.contains('is-selected')),
        ),
      ),
        inView3(this, () => __privateMethod(this, _preloadImages, preloadImages_fn).call(this)));
    }
    get allowSwipe() {
      return this.hasAttribute('allow-swipe');
    }
    get cellSelector() {
      return this.hasAttribute('cell-selector') ? this.getAttribute('cell-selector') : null;
    }
    get allCells() {
      return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
    }
    get cells() {
      return this.allCells.filter((e) => !e.hasAttribute('hidden'));
    }
    get selectedCell() {
      return this.cells[this.selectedIndex];
    }
    get selectedIndex() {
      return __privateGet(this, _targetIndex);
    }
    get player() {
      return __privateGet(this, _player);
    }
    previous({ instant: e = !1 } = {}) {
      return this.select((this.selectedIndex - 1 + this.cells.length) % this.cells.length, {
        instant: e,
        direction: 'previous',
      });
    }
    next({ instant: e = !1 } = {}) {
      return this.select((this.selectedIndex + 1 + this.cells.length) % this.cells.length, {
        instant: e,
        direction: 'next',
      });
    }
    async select(e, { instant: t = !1, direction: i = null } = {}) {
      if (!(e in this.cells)) return Promise.resolve();
      if (
        (this.dispatchEvent(new CustomEvent('carousel:select', { detail: { index: e, cell: this.cells[e] } })),
        e === this.selectedIndex)
      )
        return Promise.resolve();
      __privateGet(this, _player)?.pause();
      const [n, a] = [this.selectedCell, this.cells[e]];
      ((i ??= e > this.selectedIndex ? 'next' : 'previous'),
        __privateSet(this, _targetIndex, e),
        this.dispatchEvent(new CustomEvent('carousel:change', { detail: { index: e, cell: this.cells[e] } })));
      const r = this.createOnChangeAnimationControls(n, a, { direction: i });
      if ('leaveControls' in r && 'enterControls' in r) {
        const e = r.leaveControls();
        (t && e.finish(),
          await e.finished,
          __privateGet(this, _player)?.resume(!0),
          n.classList.remove('is-selected'),
          a.classList.add('is-selected'));
        const i = r.enterControls();
        (t && i.finish(), await i.finished);
      } else
        (t && r.finish(),
          __privateGet(this, _player)?.resume(!0),
          a.classList.add('is-selected'),
          await r.finished,
          n.classList.remove('is-selected'));
      this.dispatchEvent(new CustomEvent('carousel:settle', { detail: { index: e, cell: this.cells[e] } }));
    }
    filter(e = []) {
      (this.allCells.forEach((t, i) => {
        t.toggleAttribute('hidden', e.includes(i));
      }),
        this.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes: e } })));
    }
    async onBecameVisible() {
      const e = await this.createOnBecameVisibleAnimationControls(this.selectedCell);
      return (
        [this.selectedCell, ...this.selectedCell.querySelectorAll('[reveal-on-scroll]')].forEach((e) => {
          e.removeAttribute('reveal-on-scroll');
        }),
        __privateGet(this, _preventInitialTransition) && 'function' == typeof e.finish && e.finish(),
        e.finished.then(() => {
          (__privateGet(this, _player)?.resume(!0),
            this.dispatchEvent(
              new CustomEvent('carousel:settle', { detail: { index: this.selectedIndex, cell: this.selectedCell } }),
            ));
        })
      );
    }
    createOnBecameVisibleAnimationControls(e) {
      return animate3(e, {}, { duration: 0 });
    }
    createOnChangeAnimationControls(e, t, { direction: i } = {}) {
      return timeline([
        [e, { opacity: [1, 0] }, { duration: 0.3 }],
        [t, { opacity: [0, 1] }, { duration: 0.3, at: '<' }],
      ]);
    }
    cleanUpAnimations() {
      this.allCells.forEach((e) => {
        (e.style.removeProperty('opacity'), e.style.removeProperty('visibility'));
      });
    }
  };
((_listenersAbortController = new WeakMap()),
  (_gestureArea = new WeakMap()),
  (_player = new WeakMap()),
  (_targetIndex = new WeakMap()),
  (_preventInitialTransition = new WeakMap()),
  (_setupListeners = new WeakSet()),
  (setupListeners_fn = function () {
    if (
      this.hasAttribute('disabled-on') &&
      (mediaQueryListener(this.getAttribute('disabled-on'), (e) => {
        e.matches
          ? (__privateGet(this, _listenersAbortController)?.abort(), this.cleanUpAnimations())
          : __privateMethod(this, _setupListeners, setupListeners_fn).call(this);
      }),
      matchesMediaQuery(this.getAttribute('disabled-on')))
    )
      return;
    __privateSet(this, _listenersAbortController, new AbortController());
    const e = { signal: __privateGet(this, _listenersAbortController).signal };
    (Shopify.designMode &&
      this.closest('.shopify-section').addEventListener(
        'shopify:section:select',
        (e) => __privateSet(this, _preventInitialTransition, e.detail.load),
        e,
      ),
      this.allCells.length > 1 &&
        (this.addEventListener('carousel:change', __privateMethod(this, _preloadImages, preloadImages_fn)),
        this.allowSwipe &&
          (__privateSet(
            this,
            _gestureArea,
            new GestureArea(this, { signal: __privateGet(this, _listenersAbortController).signal }),
          ),
          this.addEventListener('swipeleft', this.next, e),
          this.addEventListener('swiperight', this.previous, e)),
        this.hasAttribute('disable-keyboard-navigation') ||
          ((this.tabIndex = 0),
          this.addEventListener('keydown', __privateMethod(this, _onKeyboardNavigation, onKeyboardNavigation_fn), e)),
        Shopify.designMode &&
          this.addEventListener(
            'shopify:block:select',
            (e) => this.select(this.cells.indexOf(e.target), { instant: e.detail.load }),
            e,
          ),
        this.hasAttribute('autoplay') &&
          (__privateGet(this, _player) ?? __privateSet(this, _player, new Player(this.getAttribute('autoplay') ?? 5)),
          __privateGet(this, _player).addEventListener('player:end', this.next.bind(this), e),
          Shopify.designMode &&
            (this.addEventListener('shopify:block:select', () => __privateGet(this, _player).stop(), e),
            this.addEventListener('shopify:block:deselect', () => __privateGet(this, _player).start(), e)))));
  }),
  (_onKeyboardNavigation = new WeakSet()),
  (onKeyboardNavigation_fn = function (e) {
    e.target === this && ('ArrowLeft' === e.code ? this.previous() : 'ArrowRight' === e.code && this.next());
  }),
  (_preloadImages = new WeakSet()),
  (preloadImages_fn = function () {
    const e = this.cells[(this.selectedIndex - 1 + this.cells.length) % this.cells.length],
      t = this.cells[(this.selectedIndex + 1 + this.cells.length) % this.cells.length];
    [e, this.selectedCell, t].forEach((e) => {
      (Array.from(e.querySelectorAll('img[loading="lazy"]')).forEach((e) => e.setAttribute('loading', 'eager')),
        Array.from(e.querySelectorAll('video[preload="none"]')).forEach((e) => e.setAttribute('preload', 'metadata')));
    });
  }),
  window.customElements.get('effect-carousel') || window.customElements.define('effect-carousel', EffectCarousel));
import { inView as inView4 } from 'vendor';
var ScrollCarousel = class extends HTMLElement {
  constructor() {
    (super(),
      __privateAdd(this, _setupListeners2),
      __privateAdd(this, _updateTargetIndex),
      __privateAdd(this, _onScroll),
      __privateAdd(this, _onScrollEnd),
      __privateAdd(this, _calculateLeftScroll),
      __privateAdd(this, _calculateClosestIndexToAlignment),
      __privateAdd(this, _onMouseDown),
      __privateAdd(this, _onMouseMove),
      __privateAdd(this, _onMouseClick),
      __privateAdd(this, _onMouseUp),
      __privateAdd(this, _onResize),
      __privateAdd(this, _onMutate),
      __privateAdd(this, _adaptHeight),
      __privateAdd(this, _preloadImages2),
      __privateAdd(this, _hasPendingProgrammaticScroll, !1),
      __privateAdd(this, _onMouseDownListener, __privateMethod(this, _onMouseDown, onMouseDown_fn).bind(this)),
      __privateAdd(this, _onMouseMoveListener, __privateMethod(this, _onMouseMove, onMouseMove_fn).bind(this)),
      __privateAdd(this, _onMouseClickListener, __privateMethod(this, _onMouseClick, onMouseClick_fn).bind(this)),
      __privateAdd(this, _onMouseUpListener, __privateMethod(this, _onMouseUp, onMouseUp_fn).bind(this)),
      __privateAdd(this, _targetIndex2, 0),
      __privateAdd(this, _forceChangeEvent, !1),
      __privateAdd(this, _dragPosition, {}),
      __privateAdd(this, _isDragging, !1),
      __privateAdd(this, _dispatchableScrollEvents, {
        nearingStart: !0,
        nearingEnd: !0,
        leavingStart: !0,
        leavingEnd: !0,
      }),
      __privateAdd(this, _scrollTimeout, void 0),
      __privateMethod(this, _setupListeners2, setupListeners_fn2).call(this),
      new ResizeObserver(__privateMethod(this, _onResize, onResize_fn).bind(this)).observe(this),
      new MutationObserver(__privateMethod(this, _onMutate, onMutate_fn).bind(this)).observe(this, {
        subtree: !0,
        attributes: !0,
        attributeFilter: ['hidden'],
      }));
  }
  connectedCallback() {
    (__privateSet(
      this,
      _targetIndex2,
      Math.max(
        0,
        this.cells.findIndex((e) => e.classList.contains('is-initial')),
      ),
    ),
      __privateGet(this, _targetIndex2) > 0 && this.select(__privateGet(this, _targetIndex2), { instant: !0 }),
      this.adaptiveHeight && __privateMethod(this, _adaptHeight, adaptHeight_fn).call(this),
      inView4(this, () => __privateMethod(this, _preloadImages2, preloadImages_fn2).call(this)));
  }
  disconnectedCallback() {
    (this.removeEventListener('mousemove', __privateGet(this, _onMouseMoveListener)),
      document.removeEventListener('mouseup', __privateGet(this, _onMouseUpListener)));
  }
  get cellSelector() {
    return this.hasAttribute('cell-selector') ? this.getAttribute('cell-selector') : null;
  }
  get allCells() {
    return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
  }
  get cells() {
    return this.allCells.filter((e) => !e.hasAttribute('hidden'));
  }
  get selectedCell() {
    return this.cells[this.selectedIndex];
  }
  get selectedIndex() {
    return __privateGet(this, _targetIndex2);
  }
  get cellAlign() {
    const e = getComputedStyle(this.cells[0]).scrollSnapAlign;
    return 'none' === e ? 'center' : e;
  }
  get groupCells() {
    if (this.hasAttribute('group-cells')) {
      const e = parseInt(this.getAttribute('group-cells'));
      return isNaN(e) ? Math.floor(this.clientWidth / this.cells[0].clientWidth) : e;
    }
    return 1;
  }
  get adaptiveHeight() {
    return this.hasAttribute('adaptive-height');
  }
  get isScrollable() {
    return this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight;
  }
  previous({ instant: e = !1 } = {}) {
    this.select(Math.max(__privateGet(this, _targetIndex2) - this.groupCells, 0), { instant: e });
  }
  next({ instant: e = !1 } = {}) {
    this.select(Math.min(__privateGet(this, _targetIndex2) + this.groupCells, this.cells.length - 1), { instant: e });
  }
  select(e, { instant: t = !1 } = {}) {
    if (e in this.cells)
      if (
        (this.dispatchEvent(new CustomEvent('carousel:select', { detail: { index: e, cell: this.cells[e] } })),
        ('checkVisibility' in this && this.checkVisibility()) || (this.offsetWidth > 0 && this.offsetHeight > 0))
      ) {
        const i = __privateMethod(this, _calculateLeftScroll, calculateLeftScroll_fn).call(this, this.cells[e]);
        this.scrollLeft !== i
          ? (__privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(this, e),
            __privateSet(this, _hasPendingProgrammaticScroll, !0),
            this.scrollTo({ left: i, behavior: t ? 'auto' : 'smooth' }))
          : __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(
              this,
              __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this),
            );
      } else (__privateSet(this, _targetIndex2, e), __privateSet(this, _forceChangeEvent, !0));
  }
  filter(e = []) {
    (this.allCells.forEach((t, i) => {
      t.toggleAttribute('hidden', e.includes(i));
    }),
      this.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes: e } })));
  }
};
((_hasPendingProgrammaticScroll = new WeakMap()),
  (_onMouseDownListener = new WeakMap()),
  (_onMouseMoveListener = new WeakMap()),
  (_onMouseClickListener = new WeakMap()),
  (_onMouseUpListener = new WeakMap()),
  (_targetIndex2 = new WeakMap()),
  (_forceChangeEvent = new WeakMap()),
  (_dragPosition = new WeakMap()),
  (_isDragging = new WeakMap()),
  (_dispatchableScrollEvents = new WeakMap()),
  (_scrollTimeout = new WeakMap()),
  (_setupListeners2 = new WeakSet()),
  (setupListeners_fn2 = function () {
    if (this.allCells.length > 1) {
      if (
        (this.addEventListener('carousel:change', __privateMethod(this, _preloadImages2, preloadImages_fn2)),
        this.addEventListener('scroll', throttle(__privateMethod(this, _onScroll, onScroll_fn).bind(this))),
        this.addEventListener('scrollend', __privateMethod(this, _onScrollEnd, onScrollEnd_fn)),
        this.hasAttribute('allow-drag'))
      ) {
        const e = window.matchMedia('screen and (pointer: fine)');
        (e.addEventListener('change', (e) => {
          e.matches
            ? this.addEventListener('mousedown', __privateGet(this, _onMouseDownListener))
            : this.removeEventListener('mousedown', __privateGet(this, _onMouseDownListener));
        }),
          e.matches && this.addEventListener('mousedown', __privateGet(this, _onMouseDownListener)));
      }
      (this.adaptiveHeight &&
        this.addEventListener('carousel:settle', __privateMethod(this, _adaptHeight, adaptHeight_fn)),
        Shopify.designMode &&
          this.addEventListener('shopify:block:select', (e) =>
            this.select(this.cells.indexOf(e.target), { instant: e.detail.load }),
          ));
    }
  }),
  (_updateTargetIndex = new WeakSet()),
  (updateTargetIndex_fn = function (e) {
    (e !== __privateGet(this, _targetIndex2) || __privateGet(this, _forceChangeEvent)) &&
      (__privateSet(this, _targetIndex2, e),
      __privateSet(this, _forceChangeEvent, !1),
      this.dispatchEvent(new CustomEvent('carousel:change', { detail: { index: e, cell: this.cells[e] } })));
  }),
  (_onScroll = new WeakSet()),
  (onScroll_fn = function () {
    const e = 100,
      t = Math.round(Math.abs(this.scrollLeft));
    (t < e &&
      __privateGet(this, _dispatchableScrollEvents).nearingStart &&
      (this.dispatchEvent(new CustomEvent('scroll:edge-nearing', { detail: { position: 'start' } })),
      (__privateGet(this, _dispatchableScrollEvents).nearingStart = !1),
      (__privateGet(this, _dispatchableScrollEvents).leavingStart = !0)),
      t >= e &&
        __privateGet(this, _dispatchableScrollEvents).leavingStart &&
        (this.dispatchEvent(new CustomEvent('scroll:edge-leaving', { detail: { position: 'start' } })),
        (__privateGet(this, _dispatchableScrollEvents).leavingStart = !1),
        (__privateGet(this, _dispatchableScrollEvents).nearingStart = !0)),
      this.scrollWidth - this.clientWidth < t + e &&
        __privateGet(this, _dispatchableScrollEvents).nearingEnd &&
        (this.dispatchEvent(new CustomEvent('scroll:edge-nearing', { detail: { position: 'end' } })),
        (__privateGet(this, _dispatchableScrollEvents).nearingEnd = !1),
        (__privateGet(this, _dispatchableScrollEvents).leavingEnd = !0)),
      this.scrollWidth - this.clientWidth >= t + e &&
        __privateGet(this, _dispatchableScrollEvents).leavingEnd &&
        (this.dispatchEvent(new CustomEvent('scroll:edge-leaving', { detail: { position: 'end' } })),
        (__privateGet(this, _dispatchableScrollEvents).leavingEnd = !1),
        (__privateGet(this, _dispatchableScrollEvents).nearingEnd = !0)),
      'onscrollend' in window ||
        (clearTimeout(__privateGet(this, _scrollTimeout)),
        __privateSet(
          this,
          _scrollTimeout,
          setTimeout(() => {
            this.dispatchEvent(new CustomEvent('scrollend', { bubbles: !0 }));
          }, 75),
        )),
      __privateGet(this, _hasPendingProgrammaticScroll) ||
        __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(
          this,
          __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this),
        ));
  }),
  (_onScrollEnd = new WeakSet()),
  (onScrollEnd_fn = function () {
    (__privateSet(this, _hasPendingProgrammaticScroll, !1),
      __privateGet(this, _isDragging) || this.style.removeProperty('scroll-snap-type'),
      __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(
        this,
        __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this),
      ),
      this.dispatchEvent(
        new CustomEvent('carousel:settle', { detail: { index: this.selectedIndex, cell: this.selectedCell } }),
      ));
  }),
  (_calculateLeftScroll = new WeakSet()),
  (calculateLeftScroll_fn = function (e) {
    let t;
    switch (this.cellAlign) {
      case 'start':
        t =
          'ltr' === document.dir
            ? e.offsetLeft - (parseInt(getComputedStyle(this).scrollPaddingInlineStart) || 0)
            : e.offsetLeft +
              e.offsetWidth -
              this.clientWidth +
              (parseInt(getComputedStyle(this).scrollPaddingInlineStart) || 0);
        break;
      case 'center':
        t = Math.round(e.offsetLeft - this.clientWidth / 2 + e.clientWidth / 2);
        break;
      case 'end':
        t =
          'ltr' === document.dir
            ? e.offsetLeft +
              e.offsetWidth -
              this.clientWidth +
              (parseInt(getComputedStyle(this).scrollPaddingInlineEnd) || 0)
            : e.offsetLeft - (parseInt(getComputedStyle(this).scrollPaddingInlineEnd) || 0);
    }
    return 'ltr' === document.dir
      ? Math.min(Math.max(t, 0), this.scrollWidth - this.clientWidth)
      : Math.min(Math.max(t, this.clientWidth - this.scrollWidth), 0);
  }),
  (_calculateClosestIndexToAlignment = new WeakSet()),
  (calculateClosestIndexToAlignment_fn = function () {
    let e,
      t,
      i = this.cellAlign;
    return (
      'center' === i
        ? ((e = this.cells.map((e) => Math.round(e.offsetLeft + e.clientWidth / 2))),
          (t = Math.round(this.scrollLeft + this.clientWidth / 2)))
        : ('start' === i && 'ltr' === document.dir) || ('end' === i && 'rtl' === document.dir)
          ? ((e = this.cells.map((e) => e.offsetLeft)), (t = this.scrollLeft))
          : ((e = this.cells.map((e) => e.offsetLeft + e.clientWidth)), (t = this.scrollLeft + this.clientWidth)),
      e.indexOf(e.reduce((e, i) => (Math.abs(i - t) < Math.abs(e - t) ? i : e)))
    );
  }),
  (_onMouseDown = new WeakSet()),
  (onMouseDown_fn = function (e) {
    (__privateSet(this, _dragPosition, { left: this.scrollLeft, top: this.scrollTop, x: e.clientX, y: e.clientY }),
      __privateSet(this, _isDragging, !0),
      this.style.setProperty('scroll-snap-type', 'none'),
      this.addEventListener('mousemove', __privateGet(this, _onMouseMoveListener)),
      this.addEventListener('click', __privateGet(this, _onMouseClickListener), { once: !0 }),
      document.addEventListener('mouseup', __privateGet(this, _onMouseUpListener)));
  }),
  (_onMouseMove = new WeakSet()),
  (onMouseMove_fn = function (e) {
    e.preventDefault();
    const [t, i] = [e.clientX - __privateGet(this, _dragPosition).x, e.clientY - __privateGet(this, _dragPosition).y];
    ((this.scrollTop = __privateGet(this, _dragPosition).top - i),
      (this.scrollLeft = __privateGet(this, _dragPosition).left - t));
  }),
  (_onMouseClick = new WeakSet()),
  (onMouseClick_fn = function (e) {
    e.clientX - __privateGet(this, _dragPosition).x != 0 && e.preventDefault();
  }),
  (_onMouseUp = new WeakSet()),
  (onMouseUp_fn = function (e) {
    (__privateSet(this, _isDragging, !1),
      e.clientX - __privateGet(this, _dragPosition).x == 0
        ? this.style.removeProperty('scroll-snap-type')
        : __privateGet(this, _hasPendingProgrammaticScroll) ||
          this.scrollTo({
            left: __privateMethod(this, _calculateLeftScroll, calculateLeftScroll_fn).call(this, this.selectedCell),
            behavior: 'smooth',
          }),
      this.removeEventListener('mousemove', __privateGet(this, _onMouseMoveListener)),
      document.removeEventListener('mouseup', __privateGet(this, _onMouseUpListener)));
  }),
  (_onResize = new WeakSet()),
  (onResize_fn = function () {
    (this.selectedIndex !==
      __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this) &&
      this.select(this.selectedIndex, { instant: !0 }),
      this.adaptiveHeight && __privateMethod(this, _adaptHeight, adaptHeight_fn).call(this),
      this.classList.toggle('is-scrollable', this.scrollWidth > this.clientWidth));
  }),
  (_onMutate = new WeakSet()),
  (onMutate_fn = function () {
    __privateSet(this, _forceChangeEvent, !0);
  }),
  (_adaptHeight = new WeakSet()),
  (adaptHeight_fn = function () {
    this.clientHeight !== this.selectedCell.clientHeight &&
      ((this.style.maxHeight = null),
      this.isScrollable && (this.style.maxHeight = `${this.selectedCell.clientHeight}px`));
  }),
  (_preloadImages2 = new WeakSet()),
  (preloadImages_fn2 = function () {
    const e = this.cells[Math.max(this.selectedIndex - 1, 0)],
      t = this.cells[Math.min(this.selectedIndex + 1, this.cells.length - 1)];
    [e, this.selectedCell, t]
      .filter((e) => null !== e)
      .forEach((e) => {
        (Array.from(e.querySelectorAll('img[loading="lazy"]')).forEach((e) => e.setAttribute('loading', 'eager')),
          Array.from(e.querySelectorAll('video[preload="none"]')).forEach((e) =>
            e.setAttribute('preload', 'metadata'),
          ));
      });
  }),
  window.customElements.get('scroll-carousel') || window.customElements.define('scroll-carousel', ScrollCarousel));
var _abortController2,
  _updateFromServer,
  updateFromServer_fn,
  createCartPromise = () =>
    new Promise(async (e) => {
      e(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
    }),
  fetchCart = createCartPromise();
(document.addEventListener('cart:change', (e) => {
  fetchCart = e.detail.cart;
}),
  window.addEventListener('pageshow', (e) => {
    e.persisted && (fetchCart = createCartPromise());
  }),
  document.addEventListener('cart:refresh', () => {
    fetchCart = createCartPromise();
  }));
var _abortController3,
  _updateFromServer2,
  updateFromServer_fn2,
  CartCount = class extends HTMLElement {
    constructor() {
      (super(...arguments), __privateAdd(this, _updateFromServer), __privateAdd(this, _abortController2, void 0));
    }
    connectedCallback() {
      (__privateSet(this, _abortController2, new AbortController()),
        document.addEventListener('cart:change', (e) => (this.itemCount = e.detail.cart.item_count), {
          signal: __privateGet(this, _abortController2).signal,
        }),
        document.addEventListener(
          'cart:refresh',
          __privateMethod(this, _updateFromServer, updateFromServer_fn).bind(this),
          { signal: __privateGet(this, _abortController2).signal },
        ),
        window.addEventListener('pageshow', __privateMethod(this, _updateFromServer, updateFromServer_fn).bind(this), {
          signal: __privateGet(this, _abortController2).signal,
        }));
    }
    disconnectedCallback() {
      __privateGet(this, _abortController2).abort();
    }
    set itemCount(e) {
      this.innerText = e;
    }
  };
((_abortController2 = new WeakMap()),
  (_updateFromServer = new WeakSet()),
  (updateFromServer_fn = async function () {
    this.itemCount = (await fetchCart).item_count;
  }),
  window.customElements.get('cart-count') || window.customElements.define('cart-count', CartCount));
var _onNoteChanged,
  onNoteChanged_fn,
  CartDot = class extends HTMLElement {
    constructor() {
      (super(...arguments), __privateAdd(this, _updateFromServer2), __privateAdd(this, _abortController3, void 0));
    }
    connectedCallback() {
      (__privateSet(this, _abortController3, new AbortController()),
        document.addEventListener(
          'cart:change',
          (e) => this.classList.toggle('is-visible', e.detail.cart.item_count > 0),
          { signal: __privateGet(this, _abortController3).signal },
        ),
        document.addEventListener(
          'cart:refresh',
          __privateMethod(this, _updateFromServer2, updateFromServer_fn2).bind(this),
          { signal: __privateGet(this, _abortController3).signal },
        ),
        window.addEventListener(
          'pageshow',
          __privateMethod(this, _updateFromServer2, updateFromServer_fn2).bind(this),
          { signal: __privateGet(this, _abortController3).signal },
        ));
    }
    disconnectedCallback() {
      __privateGet(this, _abortController3).abort();
    }
  };
((_abortController3 = new WeakMap()),
  (_updateFromServer2 = new WeakSet()),
  (updateFromServer_fn2 = async function () {
    this.classList.toggle('is-visible', (await fetchCart).item_count > 0);
  }),
  window.customElements.get('cart-dot') || window.customElements.define('cart-dot', CartDot));
var _onCartChangedListener,
  _threshold,
  _updateMessage,
  updateMessage_fn,
  _onCartChanged,
  onCartChanged_fn,
  CartNote = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _onNoteChanged),
        this.addEventListener('change', __privateMethod(this, _onNoteChanged, onNoteChanged_fn)));
    }
  };
((_onNoteChanged = new WeakSet()),
  (onNoteChanged_fn = function (e) {
    'note' === e.target.getAttribute('name') &&
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value }),
        keepalive: !0,
      });
  }),
  window.customElements.get('cart-note') || window.customElements.define('cart-note', CartNote));
var _delegate,
  _onQuantityChanged,
  onQuantityChanged_fn,
  _onChangeLinkClicked,
  onChangeLinkClicked_fn,
  _changeLineItemQuantity,
  changeLineItemQuantity_fn,
  FreeShippingBar = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _updateMessage),
        __privateAdd(this, _onCartChanged),
        __privateAdd(this, _onCartChangedListener, __privateMethod(this, _onCartChanged, onCartChanged_fn).bind(this)),
        __privateAdd(this, _threshold, void 0),
        __privateSet(this, _threshold, 100 * parseFloat(this.getAttribute('threshold').replace(/[^0-9.]/g, ''))),
        this.setAttribute('threshold', __privateGet(this, _threshold)));
    }
    static get observedAttributes() {
      return ['threshold', 'total-price'];
    }
    connectedCallback() {
      document.addEventListener('cart:change', __privateGet(this, _onCartChangedListener));
    }
    disconnectedCallback() {
      document.removeEventListener('cart:change', __privateGet(this, _onCartChangedListener));
    }
    get totalPrice() {
      return parseFloat(this.getAttribute('total-price'));
    }
    set totalPrice(e) {
      this.setAttribute('total-price', e);
    }
    attributeChangedCallback() {
      __privateMethod(this, _updateMessage, updateMessage_fn).call(this);
    }
  };
((_onCartChangedListener = new WeakMap()),
  (_threshold = new WeakMap()),
  (_updateMessage = new WeakSet()),
  (updateMessage_fn = function () {
    const e = this.querySelector('span');
    if (this.totalPrice >= __privateGet(this, _threshold)) e.innerHTML = this.getAttribute('reached-message');
    else {
      const t = `${formatMoney(__privateGet(this, _threshold) - this.totalPrice).replace(/\$/g, '$$$$')}`;
      e.innerHTML = this.getAttribute('unreached-message').replace(new RegExp('({{.*}})', 'g'), t);
    }
  }),
  (_onCartChanged = new WeakSet()),
  (onCartChanged_fn = function (e) {
    const t = e.detail.cart.items.filter((e) => e.requires_shipping).reduce((e, t) => e + t.final_line_price, 0),
      i = e.detail.cart.cart_level_discount_applications.reduce((e, t) => e + t.total_allocated_amount, 0);
    this.totalPrice = t - i;
  }),
  window.customElements.get('free-shipping-bar') || window.customElements.define('free-shipping-bar', FreeShippingBar));
import { Delegate } from 'vendor';
var _estimateShippingListener,
  _estimateShipping,
  estimateShipping_fn,
  _getAsyncShippingRates,
  getAsyncShippingRates_fn,
  _formatShippingRates,
  formatShippingRates_fn,
  _formatError,
  formatError_fn,
  LineItemQuantity = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _onQuantityChanged),
        __privateAdd(this, _onChangeLinkClicked),
        __privateAdd(this, _changeLineItemQuantity),
        __privateAdd(this, _delegate, new Delegate(this)),
        __privateGet(this, _delegate).on(
          'change',
          '[data-line-key]',
          __privateMethod(this, _onQuantityChanged, onQuantityChanged_fn).bind(this),
        ),
        __privateGet(this, _delegate).on(
          'click',
          '[href*="/cart/change"]',
          __privateMethod(this, _onChangeLinkClicked, onChangeLinkClicked_fn).bind(this),
        ));
    }
  };
((_delegate = new WeakMap()),
  (_onQuantityChanged = new WeakSet()),
  (onQuantityChanged_fn = function (e, t) {
    __privateMethod(this, _changeLineItemQuantity, changeLineItemQuantity_fn).call(
      this,
      t.getAttribute('data-line-key'),
      parseInt(t.value),
    );
  }),
  (_onChangeLinkClicked = new WeakSet()),
  (onChangeLinkClicked_fn = function (e, t) {
    e.preventDefault();
    const i = new URL(t.href);
    __privateMethod(this, _changeLineItemQuantity, changeLineItemQuantity_fn).call(
      this,
      i.searchParams.get('id'),
      parseInt(i.searchParams.get('quantity')),
    );
  }),
  (_changeLineItemQuantity = new WeakSet()),
  (changeLineItemQuantity_fn = async function (e, t) {
    if ('cart' === window.themeVariables.settings.pageType)
      window.location.href = `${Shopify.routes.root}cart/change?id=${e}&quantity=${t}`;
    else {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: !0 }));
      const i = this.closest('line-item');
      i?.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: !0, detail: { targetQuantity: t } }));
      let n = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: !0, detail: { sections: n } }),
      );
      const a = await (
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: e, quantity: t, sections: n.join(',') }),
        })
      ).json();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: !0 }));
      const r = a.items.filter((t) => t.key === e);
      (i?.dispatchEvent(
        new CustomEvent('line-item:change', {
          bubbles: !0,
          detail: { quantity: 0 === r.length ? 0 : r[0].quantity, cart: a },
        }),
      ),
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: !0, detail: { baseEvent: 'line-item:change', cart: a } }),
        ));
    }
  }),
  window.customElements.get('line-item-quantity') ||
    window.customElements.define('line-item-quantity', LineItemQuantity));
var _isDirty,
  _buildUrl,
  buildUrl_fn,
  _onFormChanged,
  onFormChanged_fn,
  _onFormSubmitted,
  onFormSubmitted_fn,
  ShippingEstimator = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _estimateShipping),
        __privateAdd(this, _getAsyncShippingRates),
        __privateAdd(this, _formatShippingRates),
        __privateAdd(this, _formatError),
        __privateAdd(
          this,
          _estimateShippingListener,
          __privateMethod(this, _estimateShipping, estimateShipping_fn).bind(this),
        ));
    }
    connectedCallback() {
      ((this.submitButton = this.querySelector('[type="button"]')),
        (this.resultsElement = this.querySelector('[aria-live="polite"]')),
        this.submitButton.addEventListener('click', __privateGet(this, _estimateShippingListener)));
    }
    disconnectedCallback() {
      this.submitButton.removeEventListener('click', __privateGet(this, _estimateShippingListener));
    }
  };
((_estimateShippingListener = new WeakMap()),
  (_estimateShipping = new WeakSet()),
  (estimateShipping_fn = async function (e) {
    e.preventDefault();
    const t = this.querySelector('[name="address[zip]"]').value,
      i = this.querySelector('[name="address[country]"]').value,
      n = this.querySelector('[name="address[province]"]').value;
    (this.submitButton.setAttribute('aria-busy', 'true'),
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: !0 })));
    const a = await fetch(
      `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${t}&shipping_address[country]=${i}&shipping_address[province]=${n}`,
      { method: 'POST' },
    );
    if ((document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: !0 })), a.ok)) {
      const e = await __privateMethod(this, _getAsyncShippingRates, getAsyncShippingRates_fn).call(this, t, i, n);
      __privateMethod(this, _formatShippingRates, formatShippingRates_fn).call(this, e);
    } else {
      const e = await a.json();
      __privateMethod(this, _formatError, formatError_fn).call(this, e);
    }
    ((this.resultsElement.hidden = !1), this.submitButton.removeAttribute('aria-busy'));
  }),
  (_getAsyncShippingRates = new WeakSet()),
  (getAsyncShippingRates_fn = async function (e, t, i) {
    const n = await fetch(
        `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`,
      ),
      a = await n.text();
    return 'null' === a
      ? __privateMethod(this, _getAsyncShippingRates, getAsyncShippingRates_fn).call(this, e, t, i)
      : JSON.parse(a).shipping_rates;
  }),
  (_formatShippingRates = new WeakSet()),
  (formatShippingRates_fn = function (e) {
    let t = e.map((e) => `<li>${e.presentment_name}: ${e.currency} ${e.price}</li>`);
    this.resultsElement.innerHTML = `\n      <div class="v-stack gap-2">\n        <p>${0 === e.length ? window.themeVariables.strings.shippingEstimatorNoResults : 1 === e.length ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>\n        ${'' === t ? '' : `<ul class="list-disc" role="list">${t}</ul>`}\n      </div>\n    `;
  }),
  (_formatError = new WeakSet()),
  (formatError_fn = function (e) {
    let t = Object.keys(e).map((t) => `<li>${e[t]}</li>`);
    this.resultsElement.innerHTML = `\n      <div class="v-stack gap-2">\n        <p>${window.themeVariables.strings.shippingEstimatorError}</p>\n        <ul class="list-disc" role="list">${t}</ul>\n      </div>\n    `;
  }),
  window.customElements.get('shipping-estimator') ||
    window.customElements.define('shipping-estimator', ShippingEstimator));
var FacetsForm = class extends HTMLFormElement {
  constructor() {
    (super(),
      __privateAdd(this, _buildUrl),
      __privateAdd(this, _onFormChanged),
      __privateAdd(this, _onFormSubmitted),
      __privateAdd(this, _isDirty, !1),
      this.addEventListener('change', __privateMethod(this, _onFormChanged, onFormChanged_fn)),
      this.addEventListener('submit', __privateMethod(this, _onFormSubmitted, onFormSubmitted_fn)));
  }
};
((_isDirty = new WeakMap()),
  (_buildUrl = new WeakSet()),
  (buildUrl_fn = function () {
    const e = new URLSearchParams(new FormData(this)),
      t = new URL(this.action);
    return (
      (t.search = ''),
      e.forEach((e, i) => t.searchParams.append(i, e)),
      ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((e) => {
        '' === t.searchParams.get(e) && t.searchParams.delete(e);
      }),
      t.searchParams.set('section_id', this.getAttribute('section-id')),
      t
    );
  }),
  (_onFormChanged = new WeakSet()),
  (onFormChanged_fn = function () {
    (__privateSet(this, _isDirty, !0),
      this.hasAttribute('update-on-change')
        ? HTMLFormElement.prototype.requestSubmit
          ? this.requestSubmit()
          : this.dispatchEvent(new Event('submit', { cancelable: !0 }))
        : cachedFetch(__privateMethod(this, _buildUrl, buildUrl_fn).call(this).toString()));
  }),
  (_onFormSubmitted = new WeakSet()),
  (onFormSubmitted_fn = function (e) {
    (e.preventDefault(),
      __privateGet(this, _isDirty) &&
        (this.dispatchEvent(
          new CustomEvent('facet:update', {
            bubbles: !0,
            detail: { url: __privateMethod(this, _buildUrl, buildUrl_fn).call(this) },
          }),
        ),
        __privateSet(this, _isDirty, !1)));
  }),
  window.customElements.get('facets-form') ||
    window.customElements.define('facets-form', FacetsForm, { extends: 'form' }));
import { animate as animate4, FocusTrap, Delegate as Delegate2 } from 'vendor';
var _isLocked,
  _delegate2,
  _abortController4,
  _focusTrap,
  _originalParentBeforeAppend,
  _allowOutsideClick,
  allowOutsideClick_fn,
  _allowOutsideClickTouch,
  allowOutsideClickTouch_fn,
  _allowOutsideClickMouse,
  allowOutsideClickMouse_fn,
  _onToggleClicked,
  onToggleClicked_fn,
  _updateSlotVisibility,
  updateSlotVisibility_fn,
  lockLayerCount = 0,
  DialogElement = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _allowOutsideClick),
        __privateAdd(this, _allowOutsideClickTouch),
        __privateAdd(this, _allowOutsideClickMouse),
        __privateAdd(this, _onToggleClicked),
        __privateAdd(this, _updateSlotVisibility),
        __privateAdd(this, _isLocked, !1),
        __privateAdd(this, _delegate2, new Delegate2(document.body)),
        __privateAdd(this, _abortController4, void 0),
        __privateAdd(this, _focusTrap, void 0),
        __privateAdd(this, _originalParentBeforeAppend, void 0),
        this.shadowDomTemplate &&
          (this.attachShadow({ mode: 'open' }).appendChild(
            document.getElementById(this.shadowDomTemplate).content.cloneNode(!0),
          ),
          this.shadowRoot.addEventListener('slotchange', (e) =>
            __privateMethod(this, _updateSlotVisibility, updateSlotVisibility_fn).call(this, e.target),
          )),
        this.addEventListener('dialog:force-close', (e) => {
          (this.hide(), e.stopPropagation());
        }));
    }
    static get observedAttributes() {
      return ['id', 'open'];
    }
    connectedCallback() {
      (this.id &&
        __privateGet(this, _delegate2)
          .off()
          .on(
            'click',
            `[aria-controls="${this.id}"]`,
            __privateMethod(this, _onToggleClicked, onToggleClicked_fn).bind(this),
          ),
        __privateSet(this, _abortController4, new AbortController()),
        this.setAttribute('role', 'dialog'),
        this.shadowDomTemplate &&
          (this.getShadowPartByName('overlay')?.addEventListener('click', this.hide.bind(this), {
            signal: this.abortController.signal,
          }),
          Array.from(this.shadowRoot.querySelectorAll('slot')).forEach((e) =>
            __privateMethod(this, _updateSlotVisibility, updateSlotVisibility_fn).call(this, e),
          )),
        Shopify.designMode &&
          (this.addEventListener('shopify:block:select', (e) => this.show(!e.detail.load), {
            signal: this.abortController.signal,
          }),
          this.addEventListener('shopify:block:deselect', this.hide, { signal: this.abortController.signal }),
          (this._shopifySection = this._shopifySection || this.closest('.shopify-section')),
          this._shopifySection &&
            (this.hasAttribute('handle-editor-events') &&
              (this._shopifySection.addEventListener('shopify:section:select', (e) => this.show(!e.detail.load), {
                signal: this.abortController.signal,
              }),
              this._shopifySection.addEventListener('shopify:section:deselect', this.hide.bind(this), {
                signal: this.abortController.signal,
              })),
            this._shopifySection.addEventListener('shopify:section:unload', () => this.remove(), {
              signal: this.abortController.signal,
            }))));
    }
    disconnectedCallback() {
      (__privateGet(this, _delegate2).off(),
        this.abortController.abort(),
        this.focusTrap?.deactivate({ onDeactivate: () => {} }),
        __privateGet(this, _isLocked) &&
          (__privateSet(this, _isLocked, !1), document.documentElement.classList.toggle('lock', --lockLayerCount > 0)));
    }
    show(e = !0) {
      return this.open
        ? Promise.resolve()
        : (this.setAttribute('open', e ? '' : 'immediate'), waitForEvent(this, 'dialog:after-show'));
    }
    hide() {
      return this.open ? (this.removeAttribute('open'), waitForEvent(this, 'dialog:after-hide')) : Promise.resolve();
    }
    get abortController() {
      return __privateGet(this, _abortController4);
    }
    get controls() {
      return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`));
    }
    get open() {
      return this.hasAttribute('open');
    }
    get shouldTrapFocus() {
      return !0;
    }
    get shouldLock() {
      return !1;
    }
    get clickOutsideDeactivates() {
      return !0;
    }
    get shouldAppendToBody() {
      return !1;
    }
    get initialFocus() {
      return this.hasAttribute('initial-focus')
        ? 'false' !== this.getAttribute('initial-focus') && this.querySelector(this.getAttribute('initial-focus'))
        : this.hasAttribute('tabindex')
          ? this
          : this.querySelector('input:not([type="hidden"])') || !1;
    }
    get preventScrollWhenTrapped() {
      return !0;
    }
    get focusTrap() {
      return __privateSet(
        this,
        _focusTrap,
        __privateGet(this, _focusTrap) ||
          new FocusTrap.createFocusTrap([this, this.shadowRoot], {
            onDeactivate: this.hide.bind(this),
            allowOutsideClick:
              !!this.clickOutsideDeactivates &&
              __privateMethod(this, _allowOutsideClick, allowOutsideClick_fn).bind(this),
            initialFocus: !!matchesMediaQuery('supports-hover') && this.initialFocus,
            fallbackFocus: this,
            preventScroll: this.preventScrollWhenTrapped,
          }),
      );
    }
    get shadowDomTemplate() {
      return this.getAttribute('template');
    }
    getShadowPartByName(e) {
      return this.shadowRoot?.querySelector(`[part="${e}"]`);
    }
    attributeChangedCallback(e, t, i) {
      switch (e) {
        case 'id':
          i &&
            __privateGet(this, _delegate2)
              .off()
              .on(
                'click',
                `[aria-controls="${this.id}"]`,
                __privateMethod(this, _onToggleClicked, onToggleClicked_fn).bind(this),
              );
          break;
        case 'open':
          if (
            (this.controls.forEach((e) => e.setAttribute('aria-expanded', null === i ? 'false' : 'true')),
            null !== t || ('' !== i && 'immediate' !== i))
          ) {
            if (null !== t && null === i) {
              this.dispatchEvent(new CustomEvent('dialog:before-hide'));
              const e = this.createLeaveAnimationControls().finished;
              (e.then(() => {
                (this.parentElement === document.body &&
                  __privateGet(this, _originalParentBeforeAppend) &&
                  (__privateGet(this, _originalParentBeforeAppend).appendChild(this),
                  __privateSet(this, _originalParentBeforeAppend, null)),
                  this.style.setProperty('display', 'none'),
                  this.dispatchEvent(new CustomEvent('dialog:after-hide')));
              }),
                this.focusTrap?.deactivate({ checkCanReturnFocus: () => e }),
                this.shouldLock &&
                  (__privateSet(this, _isLocked, !1),
                  document.documentElement.classList.toggle('lock', --lockLayerCount > 0)));
            }
          } else {
            (__privateSet(this, _originalParentBeforeAppend, null),
              this.style.setProperty('display', 'block'),
              this.dispatchEvent(new CustomEvent('dialog:before-show')),
              this.shouldAppendToBody &&
                this.parentElement !== document.body &&
                (__privateSet(this, _originalParentBeforeAppend, this.parentElement), document.body.append(this)));
            const e = this.createEnterAnimationControls();
            ('immediate' === i && e.finish(),
              e.finished.then(() => {
                this.dispatchEvent(new CustomEvent('dialog:after-show'));
              }),
              this.shouldTrapFocus && this.focusTrap.activate({ checkCanFocusTrap: () => e.finished }),
              this.shouldLock &&
                ((lockLayerCount += 1),
                __privateSet(this, _isLocked, !0),
                document.documentElement.classList.add('lock')));
          }
          this.dispatchEvent(new CustomEvent('toggle', { bubbles: !0 }));
      }
    }
    createEnterAnimationControls() {
      return animate4(this, {}, { duration: 0 });
    }
    createLeaveAnimationControls() {
      return animate4(this, {}, { duration: 0 });
    }
    hideForOutsideClickTarget(e) {
      return !this.contains(e);
    }
    allowOutsideClickForTarget(e) {
      return !1;
    }
  };
((_isLocked = new WeakMap()),
  (_delegate2 = new WeakMap()),
  (_abortController4 = new WeakMap()),
  (_focusTrap = new WeakMap()),
  (_originalParentBeforeAppend = new WeakMap()),
  (_allowOutsideClick = new WeakSet()),
  (allowOutsideClick_fn = function (e) {
    return 'TouchEvent' in window && e instanceof TouchEvent
      ? __privateMethod(this, _allowOutsideClickTouch, allowOutsideClickTouch_fn).call(this, e)
      : __privateMethod(this, _allowOutsideClickMouse, allowOutsideClickMouse_fn).call(this, e);
  }),
  (_allowOutsideClickTouch = new WeakSet()),
  (allowOutsideClickTouch_fn = function (e) {
    return (
      e.target.addEventListener(
        'touchend',
        (e) => {
          const t = document.elementFromPoint(e.changedTouches.item(0).clientX, e.changedTouches.item(0).clientY);
          this.hideForOutsideClickTarget(t) && this.hide();
        },
        { once: !0, signal: this.abortController.signal },
      ),
      this.allowOutsideClickForTarget(e.target)
    );
  }),
  (_allowOutsideClickMouse = new WeakSet()),
  (allowOutsideClickMouse_fn = function (e) {
    if ('click' !== e.type) return !1;
    if ((this.hideForOutsideClickTarget(e.target) && this.hide(), this.allowOutsideClickForTarget(e.target))) return !0;
    let t = e.target,
      i = e.target.closest('[aria-controls]');
    return (i && i.getAttribute('aria-controls') === this.id && (t = i), this.id !== t.getAttribute('aria-controls'));
  }),
  (_onToggleClicked = new WeakSet()),
  (onToggleClicked_fn = function (e) {
    (e?.preventDefault(), this.open ? this.hide() : this.show());
  }),
  (_updateSlotVisibility = new WeakSet()),
  (updateSlotVisibility_fn = function (e) {
    ['header', 'footer'].includes(e.name) &&
      (e.parentElement.hidden = 0 === e.assignedElements({ flatten: !0 }).length);
  }));
var DialogCloseButton = class extends HTMLButtonElement {
  constructor() {
    (super(),
      this.addEventListener('click', () =>
        this.dispatchEvent(new CustomEvent('dialog:force-close', { bubbles: !0, cancelable: !0, composed: !0 })),
      ));
  }
};
(window.customElements.get('dialog-element') || window.customElements.define('dialog-element', DialogElement),
  window.customElements.get('dialog-close-button') ||
    window.customElements.define('dialog-close-button', DialogCloseButton, { extends: 'button' }));
import { timeline as timeline3 } from 'vendor';
import { animate as animate5, timeline as timeline2 } from 'vendor';
var Modal = class extends DialogElement {
  connectedCallback() {
    (super.connectedCallback(), this.setAttribute('aria-modal', 'true'));
  }
  get shadowDomTemplate() {
    return this.getAttribute('template') || 'modal-default-template';
  }
  get shouldLock() {
    return !0;
  }
  get shouldAppendToBody() {
    return !0;
  }
  createEnterAnimationControls() {
    return matchesMediaQuery('sm')
      ? animate5(this, { opacity: [0, 1] }, { duration: 0.2 })
      : timeline2([
          [
            this.getShadowPartByName('overlay'),
            { opacity: [0, 1] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
          ],
          [
            this.getShadowPartByName('content'),
            { transform: ['translateY(100%)', 'translateY(0)'] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: '<' },
          ],
        ]);
  }
  createLeaveAnimationControls() {
    return matchesMediaQuery('sm')
      ? animate5(this, { opacity: [1, 0] }, { duration: 0.2 })
      : timeline2([
          [
            this.getShadowPartByName('overlay'),
            { opacity: [1, 0] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
          ],
          [
            this.getShadowPartByName('content'),
            { transform: ['translateY(0)', 'translateY(100%)'] },
            { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: '<' },
          ],
        ]);
  }
};
window.customElements.get('x-modal') || window.customElements.define('x-modal', Modal);
var Drawer = class extends Modal {
  get shadowDomTemplate() {
    return this.getAttribute('template') || 'drawer-default-template';
  }
  get openFrom() {
    return this.getAttribute('open-from') || 'right';
  }
  createEnterAnimationControls() {
    return (
      (this.getShadowPartByName('content').style.marginInlineStart = 'right' === this.openFrom ? 'auto' : 0),
      timeline3([
        [this.getShadowPartByName('overlay'), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [
          this.getShadowPartByName('content'),
          {
            transform: [
              `translateX(calc(var(--transform-logical-flip) * ${'right' === this.openFrom ? '100%' : '-100%'}))`,
              'translateX(0)',
            ],
          },
          { duration: 0.3, at: '<', easing: [0.645, 0.045, 0.355, 1] },
        ],
      ])
    );
  }
  createLeaveAnimationControls() {
    return timeline3([
      [this.getShadowPartByName('overlay'), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [
        this.getShadowPartByName('content'),
        {
          transform: [
            'translateX(0)',
            `translateX(calc(var(--transform-logical-flip) * ${'right' === this.openFrom ? '100%' : '-100%'}))`,
          ],
        },
        { duration: 0.3, at: '<', easing: [0.645, 0.045, 0.355, 1] },
      ],
    ]);
  }
};
window.customElements.get('x-drawer') || window.customElements.define('x-drawer', Drawer);
import { animate as animate6 } from 'vendor';
var PopIn = class extends DialogElement {
  get shouldTrapFocus() {
    return !1;
  }
  createEnterAnimationControls() {
    return animate6(
      this,
      { opacity: [0, 1], transform: ['translateY(25px)', 'translateY(0)'] },
      { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] },
    );
  }
  createLeaveAnimationControls() {
    return animate6(
      this,
      { opacity: [1, 0], transform: ['translateY(0)', 'translateY(25px)'] },
      { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] },
    );
  }
};
window.customElements.get('pop-in') || window.customElements.define('pop-in', PopIn);
import { animate as animate7, timeline as timeline4 } from 'vendor';
var _updateFacets,
  updateFacets_fn,
  Popover = class extends DialogElement {
    connectedCallback() {
      (super.connectedCallback(),
        this.controls.forEach((e) => e.setAttribute('aria-haspopup', 'dialog')),
        this.hasAttribute('close-on-listbox-select') &&
          this.addEventListener('listbox:select', this.hide, { signal: this.abortController.signal }));
    }
    get shadowDomTemplate() {
      return this.getAttribute('template') || 'popover-default-template';
    }
    get shouldLock() {
      return matchesMediaQuery('md-max');
    }
    get shouldAppendToBody() {
      return matchesMediaQuery('md-max');
    }
    get preventScrollWhenTrapped() {
      return !0;
    }
    createEnterAnimationControls() {
      return matchesMediaQuery('md')
        ? animate7(this, { opacity: [0, 1] }, { duration: 0.2 })
        : timeline4([
            [
              this.getShadowPartByName('overlay'),
              { opacity: [0, 1] },
              { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
            ],
            [
              this.getShadowPartByName('content'),
              { transform: ['translateY(100%)', 'translateY(0)'] },
              { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: '<' },
            ],
          ]);
    }
    createLeaveAnimationControls() {
      return matchesMediaQuery('md')
        ? animate7(this, { opacity: [1, 0] }, { duration: 0.2 })
        : timeline4([
            [
              this.getShadowPartByName('overlay'),
              { opacity: [1, 0] },
              { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
            ],
            [
              this.getShadowPartByName('content'),
              { transform: ['translateY(0)', 'translateY(100%)'] },
              { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: '<' },
            ],
          ]);
    }
  };
window.customElements.get('x-popover') || window.customElements.define('x-popover', Popover);
var _onFacetUpdate,
  onFacetUpdate_fn,
  FacetsDrawer = class extends Drawer {
    constructor() {
      (super(),
        __privateAdd(this, _updateFacets),
        this.addEventListener('dialog:after-hide', __privateMethod(this, _updateFacets, updateFacets_fn)));
    }
  };
((_updateFacets = new WeakSet()),
  (updateFacets_fn = function () {
    const e = this.querySelector('[is="facets-form"]');
    HTMLFormElement.prototype.requestSubmit
      ? e?.requestSubmit()
      : e?.dispatchEvent(new Event('submit', { bubbles: !0, cancelable: !0 }));
  }),
  window.customElements.get('facets-drawer') || window.customElements.define('facets-drawer', FacetsDrawer));
var _onSortChange,
  onSortChange_fn,
  FacetLink = class extends HTMLAnchorElement {
    constructor() {
      (super(),
        __privateAdd(this, _onFacetUpdate),
        this.addEventListener('click', __privateMethod(this, _onFacetUpdate, onFacetUpdate_fn).bind(this)));
    }
  };
((_onFacetUpdate = new WeakSet()),
  (onFacetUpdate_fn = function (e) {
    e.preventDefault();
    const t = extractSectionId(e.target),
      i = new URL(this.href);
    (i.searchParams.set('section_id', t),
      this.dispatchEvent(new CustomEvent('facet:update', { bubbles: !0, detail: { url: i } })));
  }),
  window.customElements.get('facet-link') || window.customElements.define('facet-link', FacetLink, { extends: 'a' }));
var FacetsSortPopover = class extends Popover {
  constructor() {
    (super(),
      __privateAdd(this, _onSortChange),
      this.addEventListener('listbox:change', __privateMethod(this, _onSortChange, onSortChange_fn)));
  }
};
((_onSortChange = new WeakSet()),
  (onSortChange_fn = function (e) {
    const t = new URL(window.location.href);
    (t.searchParams.set('sort_by', e.detail.value),
      t.searchParams.delete('page'),
      t.searchParams.set('section_id', this.getAttribute('section-id')),
      this.dispatchEvent(new CustomEvent('facet:update', { bubbles: !0, detail: { url: t } })));
  }),
  window.customElements.get('facets-sort-popover') ||
    window.customElements.define('facets-sort-popover', FacetsSortPopover));
import { Delegate as Delegate3 } from 'vendor';
var _allowUpdatingProgress,
  _calculateProgressBar,
  calculateProgressBar_fn,
  abortController = null,
  delegate = new Delegate3(document.body),
  openDetailsValues = new Set(
    Array.from(document.querySelectorAll('[is="facets-form"] details[open] input[name*="filter."]'), (e) => e.name),
  );
(delegate.on(
  'toggle',
  '[is="facets-form"] details',
  (e, t) => {
    [...new Set(Array.from(t.querySelectorAll('input[name*="filter."]'), (e) => e.name))].forEach((e) => {
      t.open ? openDetailsValues.add(e) : openDetailsValues.delete(e);
    });
  },
  !0,
),
  document.addEventListener('facet:update', async (e) => {
    (abortController && abortController.abort(), (abortController = new AbortController()));
    const t = e.detail.url,
      i = document.getElementById(`shopify-section-${t.searchParams.get('section_id')}`),
      n = new URL(t);
    (n.searchParams.delete('section_id'), history.replaceState({}, '', n.toString()));
    try {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: !0 }));
      const e = new DOMParser().parseFromString(
        await (await cachedFetch(t.toString(), { signal: abortController.signal })).text(),
        'text/html',
      );
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: !0 }));
      (e
        .querySelector('.shopify-section')
        .querySelectorAll('[is="facets-form"] details')
        .forEach((e) => {
          [...new Set(Array.from(e.querySelectorAll('input[name*="filter."]'), (e) => e.name))].forEach((t) => {
            e.open = openDetailsValues.has(t);
          });
        }),
        i.replaceChildren(...document.importNode(e.querySelector('.shopify-section'), !0).childNodes));
      const n = () => i.querySelector('.collection').scrollIntoView({ block: 'start', behavior: 'smooth' });
      'requestIdleCallback' in window ? requestIdleCallback(n, { timeout: 500 }) : requestAnimationFrame(n);
    } catch (e) {}
  }));
import { inView as inView5 } from 'vendor';
var ProgressBar = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _calculateProgressBar),
      __privateAdd(this, _allowUpdatingProgress, !this.hasAttribute('animate-on-scroll')));
  }
  static get observedAttributes() {
    return ['aria-valuenow', 'aria-valuemax'];
  }
  connectedCallback() {
    this.hasAttribute('animate-on-scroll') &&
      inView5(
        this,
        () => {
          (__privateSet(this, _allowUpdatingProgress, !0),
            __privateMethod(this, _calculateProgressBar, calculateProgressBar_fn).call(this));
        },
        { margin: '-50px 0px' },
      );
  }
  get progress() {
    return Math.min(1, this.getAttribute('aria-valuenow') / this.getAttribute('aria-valuemax'));
  }
  set valueMax(e) {
    this.setAttribute('aria-valuemax', e);
  }
  set valueNow(e) {
    this.setAttribute('aria-valuenow', e);
  }
  attributeChangedCallback() {
    __privateGet(this, _allowUpdatingProgress) &&
      __privateMethod(this, _calculateProgressBar, calculateProgressBar_fn).call(this);
  }
};
((_allowUpdatingProgress = new WeakMap()),
  (_calculateProgressBar = new WeakSet()),
  (calculateProgressBar_fn = function () {
    this.style.setProperty('--progress', `${this.progress}`);
  }),
  window.customElements.get('progress-bar') || window.customElements.define('progress-bar', ProgressBar));
var _abortController5,
  _decreaseButton,
  _increaseButton,
  _inputElement,
  _onDecreaseQuantity,
  onDecreaseQuantity_fn,
  _onIncreaseQuantity,
  onIncreaseQuantity_fn,
  _onVariantChangedListener,
  onVariantChangedListener_fn,
  _updateUI,
  updateUI_fn,
  PriceRange = class extends HTMLElement {
    #e;
    connectedCallback() {
      this.#e = new AbortController();
      const e = this.querySelector('input[type="range"]:first-child'),
        t = this.querySelector('input[type="range"]:last-child'),
        i = this.querySelector('input[name="filter.v.price.gte"]'),
        n = this.querySelector('input[name="filter.v.price.lte"]');
      (i.addEventListener('focus', () => i.select(), { signal: this.#e.signal }),
        n.addEventListener('focus', () => n.select(), { signal: this.#e.signal }),
        i.addEventListener(
          'change',
          (t) => {
            (t.preventDefault(),
              (t.target.value = Math.max(
                Math.min(parseInt(t.target.value), parseInt(n.value || t.target.max) - 1),
                t.target.min,
              )),
              (e.value = t.target.value),
              e.parentElement.style.setProperty('--range-min', (parseInt(e.value) / parseInt(e.max)) * 100 + '%'));
          },
          { signal: this.#e.signal },
        ),
        n.addEventListener(
          'change',
          (e) => {
            (e.preventDefault(),
              (e.target.value = Math.min(
                Math.max(parseInt(e.target.value), parseInt(i.value || e.target.min) + 1),
                e.target.max,
              )),
              (t.value = e.target.value),
              t.parentElement.style.setProperty('--range-max', (parseInt(t.value) / parseInt(t.max)) * 100 + '%'));
          },
          { signal: this.#e.signal },
        ),
        e.addEventListener(
          'change',
          (e) => {
            (e.stopPropagation(), (i.value = e.target.value), i.dispatchEvent(new Event('change', { bubbles: !0 })));
          },
          { signal: this.#e.signal },
        ),
        t.addEventListener(
          'change',
          (e) => {
            (e.stopPropagation(), (n.value = e.target.value), n.dispatchEvent(new Event('change', { bubbles: !0 })));
          },
          { signal: this.#e.signal },
        ),
        e.addEventListener(
          'input',
          (e) => {
            ((e.target.value = Math.min(parseInt(e.target.value), parseInt(n.value || e.target.max) - 1)),
              e.target.parentElement.style.setProperty(
                '--range-min',
                (parseInt(e.target.value) / parseInt(e.target.max)) * 100 + '%',
              ),
              (i.value = e.target.value));
          },
          { signal: this.#e.signal },
        ),
        t.addEventListener(
          'input',
          (e) => {
            ((e.target.value = Math.max(parseInt(e.target.value), parseInt(i.value || e.target.min) + 1)),
              e.target.parentElement.style.setProperty(
                '--range-max',
                (parseInt(e.target.value) / parseInt(e.target.max)) * 100 + '%',
              ),
              (n.value = e.target.value));
          },
          { signal: this.#e.signal },
        ));
    }
    disconnectedCallback() {
      this.#e.abort();
    }
  };
window.customElements.get('price-range') || window.customElements.define('price-range', PriceRange);
var _onValueInput,
  onValueInput_fn,
  QuantitySelector = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onDecreaseQuantity),
        __privateAdd(this, _onIncreaseQuantity),
        __privateAdd(this, _onVariantChangedListener),
        __privateAdd(this, _updateUI),
        __privateAdd(this, _abortController5, void 0),
        __privateAdd(this, _decreaseButton, void 0),
        __privateAdd(this, _increaseButton, void 0),
        __privateAdd(this, _inputElement, void 0));
    }
    connectedCallback() {
      (__privateSet(this, _abortController5, new AbortController()),
        __privateSet(this, _decreaseButton, this.querySelector('button:first-of-type')),
        __privateSet(this, _increaseButton, this.querySelector('button:last-of-type')),
        __privateSet(this, _inputElement, this.querySelector('input')),
        __privateGet(this, _decreaseButton)?.addEventListener(
          'click',
          __privateMethod(this, _onDecreaseQuantity, onDecreaseQuantity_fn).bind(this),
          { signal: __privateGet(this, _abortController5).signal },
        ),
        __privateGet(this, _increaseButton)?.addEventListener(
          'click',
          __privateMethod(this, _onIncreaseQuantity, onIncreaseQuantity_fn).bind(this),
          { signal: __privateGet(this, _abortController5).signal },
        ),
        document.forms[this.getAttribute('form')]?.addEventListener(
          'variant:change',
          __privateMethod(this, _onVariantChangedListener, onVariantChangedListener_fn).bind(this),
          { signal: __privateGet(this, _abortController5).signal },
        ));
    }
    disconnectedCallback() {
      __privateGet(this, _abortController5).abort();
    }
  };
((_abortController5 = new WeakMap()),
  (_decreaseButton = new WeakMap()),
  (_increaseButton = new WeakMap()),
  (_inputElement = new WeakMap()),
  (_onDecreaseQuantity = new WeakSet()),
  (onDecreaseQuantity_fn = function () {
    (__privateGet(this, _inputElement).stepDown(), __privateMethod(this, _updateUI, updateUI_fn).call(this));
  }),
  (_onIncreaseQuantity = new WeakSet()),
  (onIncreaseQuantity_fn = function () {
    (__privateGet(this, _inputElement).stepUp(), __privateMethod(this, _updateUI, updateUI_fn).call(this));
  }),
  (_onVariantChangedListener = new WeakSet()),
  (onVariantChangedListener_fn = function (e) {
    __privateGet(this, _inputElement).updateVariantRule(e.detail.variant);
  }),
  (_updateUI = new WeakSet()),
  (updateUI_fn = function () {
    __privateGet(this, _decreaseButton).disabled = __privateGet(this, _inputElement).quantity <= 1;
  }));
var _onInput,
  onInput_fn,
  QuantityInput = class extends HTMLInputElement {
    constructor() {
      (super(),
        __privateAdd(this, _onValueInput),
        this.addEventListener('input', __privateMethod(this, _onValueInput, onValueInput_fn)),
        this.addEventListener('focus', this.select));
    }
    connectedCallback() {
      this.style.setProperty('--quantity-selector-character-count', `${this.value.length}ch`);
    }
    get quantity() {
      return parseInt(this.value);
    }
    updateVariantRule(e) {}
  };
((_onValueInput = new WeakSet()),
  (onValueInput_fn = function () {
    ('' === this.value && (this.value = this.min || 1),
      this.style.setProperty('--quantity-selector-character-count', `${this.value.length}ch`));
  }),
  window.customElements.get('quantity-selector') || window.customElements.define('quantity-selector', QuantitySelector),
  window.customElements.get('quantity-input') ||
    window.customElements.define('quantity-input', QuantityInput, { extends: 'input' }));
var _accessibilityInitialized,
  _hiddenInput,
  _setupAccessibility,
  setupAccessibility_fn,
  _onOptionClicked,
  onOptionClicked_fn,
  _onInputChanged,
  onInputChanged_fn,
  _onKeyDown,
  onKeyDown_fn,
  ResizableTextarea = class extends HTMLTextAreaElement {
    constructor() {
      (super(),
        __privateAdd(this, _onInput),
        this.addEventListener('input', __privateMethod(this, _onInput, onInput_fn)));
    }
  };
((_onInput = new WeakSet()),
  (onInput_fn = function () {
    ((this.style.height = 'auto'), (this.style.height = this.scrollHeight + 2 + 'px'));
  }),
  window.customElements.get('resizable-textarea') ||
    window.customElements.define('resizable-textarea', ResizableTextarea, { extends: 'textarea' }));
var _setupParallax,
  setupParallax_fn,
  _getFirstParent,
  getFirstParent_fn,
  Listbox = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _setupAccessibility),
        __privateAdd(this, _onOptionClicked),
        __privateAdd(this, _onInputChanged),
        __privateAdd(this, _onKeyDown),
        __privateAdd(this, _accessibilityInitialized, !1),
        __privateAdd(this, _hiddenInput, void 0),
        this.addEventListener('keydown', __privateMethod(this, _onKeyDown, onKeyDown_fn)));
    }
    static get observedAttributes() {
      return ['aria-activedescendant'];
    }
    connectedCallback() {
      (__privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]')),
        __privateGet(this, _hiddenInput)?.addEventListener(
          'change',
          __privateMethod(this, _onInputChanged, onInputChanged_fn).bind(this),
        ),
        __privateGet(this, _accessibilityInitialized) ||
          requestAnimationFrame(__privateMethod(this, _setupAccessibility, setupAccessibility_fn).bind(this)));
    }
    attributeChangedCallback(e, t, i) {
      'aria-activedescendant' === e &&
        null !== t &&
        i !== t &&
        Array.from(this.querySelectorAll('[role="option"]')).forEach((e) => {
          e.id === i
            ? (e.setAttribute('aria-selected', 'true'),
              __privateGet(this, _hiddenInput) &&
                __privateGet(this, _hiddenInput).value !== e.value &&
                ((__privateGet(this, _hiddenInput).value = e.value),
                __privateGet(this, _hiddenInput).dispatchEvent(new Event('change', { bubbles: !0 }))),
              this.hasAttribute('aria-owns') &&
                this.getAttribute('aria-owns')
                  .split(' ')
                  .forEach((t) => {
                    document.getElementById(t).textContent = e.getAttribute('title') || e.innerText || e.value;
                  }),
              e.dispatchEvent(new CustomEvent('listbox:change', { bubbles: !0, detail: { value: e.value } })))
            : e.setAttribute('aria-selected', 'false');
        });
    }
  };
((_accessibilityInitialized = new WeakMap()),
  (_hiddenInput = new WeakMap()),
  (_setupAccessibility = new WeakSet()),
  (setupAccessibility_fn = function () {
    (this.setAttribute('role', 'listbox'),
      Array.from(this.querySelectorAll('[role="option"]')).forEach((e) => {
        (e.addEventListener('click', __privateMethod(this, _onOptionClicked, onOptionClicked_fn).bind(this)),
          (e.id = 'option-' + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(1e4 * Math.random()))),
          'true' === e.getAttribute('aria-selected') && this.setAttribute('aria-activedescendant', e.id));
      }),
      __privateSet(this, _accessibilityInitialized, !0));
  }),
  (_onOptionClicked = new WeakSet()),
  (onOptionClicked_fn = function (e) {
    'submit' !== e.currentTarget.getAttribute('type') &&
      (this.setAttribute('aria-activedescendant', e.currentTarget.id),
      e.currentTarget.dispatchEvent(
        new CustomEvent('listbox:select', { bubbles: !0, detail: { value: e.currentTarget.value } }),
      ));
  }),
  (_onInputChanged = new WeakSet()),
  (onInputChanged_fn = function (e) {
    this.setAttribute(
      'aria-activedescendant',
      this.querySelector(`[role="option"][value="${CSS.escape(e.target.value)}"]`).id,
    );
  }),
  (_onKeyDown = new WeakSet()),
  (onKeyDown_fn = function (e) {
    'ArrowUp' === e.key
      ? (e.target.previousElementSibling?.focus(), e.preventDefault())
      : 'ArrowDown' === e.key && (e.target.nextElementSibling?.focus(), e.preventDefault());
  }),
  window.customElements.get('x-listbox') || window.customElements.define('x-listbox', Listbox));
import { scroll, animate as animate8 } from 'vendor';
var _recipientCheckbox,
  _recipientOtherProperties,
  _recipientSendOnProperty,
  _offsetProperty,
  _recipientFieldsContainer,
  _synchronizeProperties,
  synchronizeProperties_fn,
  _formatDate,
  formatDate_fn,
  ImageParallax = class extends HTMLImageElement {
    constructor() {
      (super(...arguments), __privateAdd(this, _setupParallax), __privateAdd(this, _getFirstParent));
    }
    connectedCallback() {
      window.matchMedia('(prefers-reduced-motion: no-preference)').matches &&
        __privateMethod(this, _setupParallax, setupParallax_fn).call(this);
    }
  };
((_setupParallax = new WeakSet()),
  (setupParallax_fn = function () {
    const [e, t] = [1.3, 15 / 1.3],
      i = this.closest('.shopify-section').matches(':first-child');
    window.ScrollTimeline
      ? this.animate(
          { transform: [`scale(${e}) translateY(-${t}%)`, `scale(${e}) translateY(${t}%)`] },
          {
            fill: 'forwards',
            timeline: new ViewTimeline({
              subject: __privateMethod(this, _getFirstParent, getFirstParent_fn).call(this, this),
              axis: 'block',
            }),
            rangeStart: i ? 'exit-crossing 0%' : 'cover 0%',
            rangeEnd: 'cover 100%',
          },
        )
      : scroll(
          animate8(
            this,
            { transform: [`scale(${e}) translateY(-${t}%)`, `scale(${e}) translateY(${t}%)`] },
            { easing: 'linear' },
          ),
          { target: this, offset: [i ? 'start start' : 'start end', 'end start'] },
        );
  }),
  (_getFirstParent = new WeakSet()),
  (getFirstParent_fn = function (e) {
    const t = e.parentElement;
    return t.clientHeight > 0 ? t : __privateMethod(this, _getFirstParent, getFirstParent_fn).call(this, t);
  }),
  window.customElements.get('image-parallax') ||
    window.customElements.define('image-parallax', ImageParallax, { extends: 'img' }));
var _delegate3,
  _onSwatchHovered,
  onSwatchHovered_fn,
  _onSwatchChanged,
  onSwatchChanged_fn,
  _createMediaImg,
  createMediaImg_fn,
  _getMatchingVariant,
  getMatchingVariant_fn,
  GiftCardRecipient = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _synchronizeProperties),
        __privateAdd(this, _formatDate),
        __privateAdd(this, _recipientCheckbox, void 0),
        __privateAdd(this, _recipientOtherProperties, []),
        __privateAdd(this, _recipientSendOnProperty, void 0),
        __privateAdd(this, _offsetProperty, void 0),
        __privateAdd(this, _recipientFieldsContainer, void 0));
    }
    connectedCallback() {
      const e = Array.from(this.querySelectorAll('[name*="properties"]')),
        t = 'properties[__shopify_send_gift_card_to_recipient]';
      (__privateSet(
        this,
        _recipientCheckbox,
        e.find((e) => e.name === t),
      ),
        __privateSet(
          this,
          _recipientOtherProperties,
          e.filter((e) => e.name !== t),
        ),
        __privateSet(this, _recipientFieldsContainer, this.querySelector('.gift-card-recipient__fields')),
        __privateSet(this, _offsetProperty, this.querySelector('[name="properties[__shopify_offset]"]')),
        __privateGet(this, _offsetProperty) &&
          (__privateGet(this, _offsetProperty).value = new Date().getTimezoneOffset().toString()),
        __privateSet(this, _recipientSendOnProperty, this.querySelector('[name="properties[Send on]"]')));
      const i = new Date(),
        n = new Date();
      (n.setDate(i.getDate() + 90),
        __privateGet(this, _recipientSendOnProperty)?.setAttribute(
          'min',
          __privateMethod(this, _formatDate, formatDate_fn).call(this, i),
        ),
        __privateGet(this, _recipientSendOnProperty)?.setAttribute(
          'max',
          __privateMethod(this, _formatDate, formatDate_fn).call(this, n),
        ),
        __privateGet(this, _recipientCheckbox)?.addEventListener(
          'change',
          __privateMethod(this, _synchronizeProperties, synchronizeProperties_fn).bind(this),
        ),
        __privateMethod(this, _synchronizeProperties, synchronizeProperties_fn).call(this));
    }
  };
((_recipientCheckbox = new WeakMap()),
  (_recipientOtherProperties = new WeakMap()),
  (_recipientSendOnProperty = new WeakMap()),
  (_offsetProperty = new WeakMap()),
  (_recipientFieldsContainer = new WeakMap()),
  (_synchronizeProperties = new WeakSet()),
  (synchronizeProperties_fn = function () {
    (__privateGet(this, _recipientOtherProperties).forEach(
      (e) => (e.disabled = !__privateGet(this, _recipientCheckbox).checked),
    ),
      __privateGet(this, _recipientFieldsContainer).classList.toggle(
        'js:hidden',
        !__privateGet(this, _recipientCheckbox).checked,
      ));
  }),
  (_formatDate = new WeakSet()),
  (formatDate_fn = function (e) {
    const t = e.getTimezoneOffset();
    return new Date(e.getTime() - 60 * t * 1e3).toISOString().split('T')[0];
  }),
  window.customElements.get('gift-card-recipient') ||
    window.customElements.define('gift-card-recipient', GiftCardRecipient));
import { Delegate as Delegate4 } from 'vendor';
var _onSubmit,
  onSubmit_fn,
  ProductCard = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _onSwatchHovered),
        __privateAdd(this, _onSwatchChanged),
        __privateAdd(this, _createMediaImg),
        __privateAdd(this, _getMatchingVariant),
        __privateAdd(this, _delegate3, new Delegate4(this)),
        this.querySelectorAll('[type="radio"]').length > 0 &&
          this.addEventListener('pointerover', () => ProductLoader.load(this.getAttribute('handle')), { once: !0 }));
    }
    connectedCallback() {
      (__privateGet(this, _delegate3).on(
        'change',
        '.product-card__info [type="radio"]',
        __privateMethod(this, _onSwatchChanged, onSwatchChanged_fn).bind(this),
      ),
        __privateGet(this, _delegate3).on(
          'pointerover',
          '.product-card__info [type="radio"] + label',
          __privateMethod(this, _onSwatchHovered, onSwatchHovered_fn).bind(this),
          !0,
        ));
    }
    disconnectedCallback() {
      __privateGet(this, _delegate3).off();
    }
  };
((_delegate3 = new WeakMap()),
  (_onSwatchHovered = new WeakSet()),
  (onSwatchHovered_fn = async function (e, t) {
    const i = await __privateMethod(this, _getMatchingVariant, getMatchingVariant_fn).call(this, t.control),
      n = this.querySelector('.product-card__image--primary');
    i.hasOwnProperty('featured_media') &&
      __privateMethod(this, _createMediaImg, createMediaImg_fn).call(this, i.featured_media, n.className, n.sizes);
  }),
  (_onSwatchChanged = new WeakSet()),
  (onSwatchChanged_fn = async function (e, t) {
    const i = await __privateMethod(this, _getMatchingVariant, getMatchingVariant_fn).call(this, t);
    if (
      (this.querySelectorAll(`a[href^="${this.product.url}"`).forEach((e) => {
        const t = new URL(e.href);
        (t.searchParams.set('variant', i.id), (e.href = `${t.pathname}${t.search}${t.hash}`));
      }),
      !i.hasOwnProperty('featured_media'))
    )
      return;
    const n = this.querySelector('.product-card__image--primary'),
      a = this.querySelector('.product-card__image--secondary'),
      r = __privateMethod(this, _createMediaImg, createMediaImg_fn).call(this, i.featured_media, n.className, n.sizes);
    n.src !== r.src &&
      (a &&
        a.replaceWith(
          __privateMethod(this, _createMediaImg, createMediaImg_fn).call(
            this,
            this.product.media[i.featured_media.position] || this.product.media[1],
            a.className,
            a.sizes,
          ),
        ),
      await n.animate({ opacity: [1, 0] }, { duration: 150, easing: 'ease-in', fill: 'forwards' }).finished,
      await new Promise((e) => (r.complete ? e() : (r.onload = () => e()))),
      n.replaceWith(r),
      r.animate({ opacity: [0, 1] }, { duration: 150, easing: 'ease-in' }));
  }),
  (_createMediaImg = new WeakSet()),
  (createMediaImg_fn = function (e, t, i) {
    return createMediaImg(e, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800], { class: t, sizes: i });
  }),
  (_getMatchingVariant = new WeakSet()),
  (getMatchingVariant_fn = async function (e) {
    return (
      (this.product = await ProductLoader.load(this.getAttribute('handle'))),
      this.product.variants.find(
        (t) => t[`option${e.closest('[data-option-position]').getAttribute('data-option-position')}`] === e.value,
      )
    );
  }),
  window.customElements.get('product-card') || window.customElements.define('product-card', ProductCard));
var _onVariantChangedListener2,
  _onVariantAddedListener,
  _onCartErrorListener,
  _onVariantChanged,
  onVariantChanged_fn,
  _onVariantAdded,
  onVariantAdded_fn,
  _onCartError,
  onCartError_fn,
  ProductForm = class extends HTMLFormElement {
    constructor() {
      (super(),
        __privateAdd(this, _onSubmit),
        this.addEventListener('submit', __privateMethod(this, _onSubmit, onSubmit_fn)));
    }
    connectedCallback() {
      this.id.disabled = !1;
    }
  };
((_onSubmit = new WeakSet()),
  (onSubmit_fn = async function (e) {
    if ((e.preventDefault(), !this.checkValidity())) return void this.reportValidity();
    const t = Array.from(this.elements).filter((e) => 'submit' === e.type);
    (t.forEach((e) => {
      (e.setAttribute('disabled', 'disabled'), e.setAttribute('aria-busy', 'true'));
    }),
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: !0 })));
    let i = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: !0, detail: { sections: i } }),
    );
    const n = new FormData(this);
    (n.set('sections', i.join(',')), n.set('sections_url', `${Shopify.routes.root}variants/${this.id.value}`));
    const a = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: n,
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    t.forEach((e) => {
      (e.removeAttribute('disabled'), e.removeAttribute('aria-busy'));
    });
    const r = await a.json();
    if ((document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: !0 })), a.ok)) {
      if ('page' === window.themeVariables.settings.cartType || 'cart' === window.themeVariables.settings.pageType)
        return (window.location.href = `${Shopify.routes.root}cart`);
      const e = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      ((e.sections = r.sections),
        this.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: !0,
            detail: { items: r.hasOwnProperty('items') ? r.items : [r], cart: e, onSuccessDo: n.get('on_success') },
          }),
        ),
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: !0,
            detail: { baseEvent: 'variant:add', onSuccessDo: n.get('on_success'), cart: e },
          }),
        ));
    } else
      (this.dispatchEvent(new CustomEvent('cart:error', { bubbles: !0, detail: { error: r.description } })),
        document.dispatchEvent(new CustomEvent('cart:refresh')));
  }),
  window.customElements.get('product-form') ||
    window.customElements.define('product-form', ProductForm, { extends: 'form' }));
var _onVariantChangedListener3,
  _sizesAttribute,
  _classAttribute,
  _widths,
  widths_get,
  _onVariantChanged2,
  onVariantChanged_fn2,
  BuyButtons = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged),
        __privateAdd(this, _onVariantAdded),
        __privateAdd(this, _onCartError),
        __privateAdd(
          this,
          _onVariantChangedListener2,
          __privateMethod(this, _onVariantChanged, onVariantChanged_fn).bind(this),
        ),
        __privateAdd(
          this,
          _onVariantAddedListener,
          __privateMethod(this, _onVariantAdded, onVariantAdded_fn).bind(this),
        ),
        __privateAdd(this, _onCartErrorListener, __privateMethod(this, _onCartError, onCartError_fn).bind(this)));
    }
    connectedCallback() {
      (document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener2),
      ),
        document.forms[this.getAttribute('form')]?.addEventListener(
          'cart:error',
          __privateGet(this, _onCartErrorListener),
        ),
        'message' === window.themeVariables.settings.cartType &&
          document.forms[this.getAttribute('form')]?.addEventListener(
            'variant:add',
            __privateGet(this, _onVariantAddedListener),
          ));
    }
    disconnectedCallback() {
      (document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener2),
      ),
        document.forms[this.getAttribute('form')]?.removeEventListener(
          'cart:error',
          __privateGet(this, _onCartErrorListener),
        ));
    }
  };
((_onVariantChangedListener2 = new WeakMap()),
  (_onVariantAddedListener = new WeakMap()),
  (_onCartErrorListener = new WeakMap()),
  (_onVariantChanged = new WeakSet()),
  (onVariantChanged_fn = function (e) {
    const t = this.querySelector('button[type="submit"]'),
      i = this.querySelector('.shopify-payment-button');
    ((t.disabled = !e.detail.variant || !e.detail.variant.available),
      e.detail.variant
        ? ((t.innerHTML = e.detail.variant.available
            ? this.getAttribute('template').includes('pre-order')
              ? window.themeVariables.strings.preOrderButton
              : window.themeVariables.strings.addToCartButton
            : window.themeVariables.strings.soldOutButton),
          i && (i.style.display = e.detail.variant.available ? 'block' : 'none'))
        : ((t.innerHTML = window.themeVariables.strings.unavailableButton), i && (i.style.display = 'none')));
  }),
  (_onVariantAdded = new WeakSet()),
  (onVariantAdded_fn = function (e) {
    const t = document
      .createRange()
      .createContextualFragment(
        `\n      <div class="banner banner--success" role="alert">\n        ${window.themeVariables.strings.addedToCart}\n      </div>\n    `,
      ).firstElementChild;
    (this.prepend(t),
      setTimeout(() => {
        t.remove();
      }, 2500));
  }),
  (_onCartError = new WeakSet()),
  (onCartError_fn = function (e) {
    const t = document
      .createRange()
      .createContextualFragment(
        `\n      <div class="banner banner--error" role="alert">\n        ${e.detail.error}\n      </div>\n    `,
      ).firstElementChild;
    (this.prepend(t),
      setTimeout(() => {
        t.remove();
      }, 2500));
  }),
  window.customElements.get('buy-buttons') || window.customElements.define('buy-buttons', BuyButtons));
var _onVariantChangedListener4,
  _onVariantChanged3,
  onVariantChanged_fn3,
  VariantMedia = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _widths),
        __privateAdd(this, _onVariantChanged2),
        __privateAdd(
          this,
          _onVariantChangedListener3,
          __privateMethod(this, _onVariantChanged2, onVariantChanged_fn2).bind(this),
        ),
        __privateAdd(this, _sizesAttribute, void 0),
        __privateAdd(this, _classAttribute, void 0));
    }
    connectedCallback() {
      (__privateSet(this, _sizesAttribute, this.querySelector('img').sizes),
        __privateSet(this, _classAttribute, this.querySelector('img').className),
        document.forms[this.getAttribute('form')]?.addEventListener(
          'variant:change',
          __privateGet(this, _onVariantChangedListener3),
        ));
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener3),
      );
    }
  };
((_onVariantChangedListener3 = new WeakMap()),
  (_sizesAttribute = new WeakMap()),
  (_classAttribute = new WeakMap()),
  (_widths = new WeakSet()),
  (widths_get = function () {
    return this.getAttribute('widths')
      .split(',')
      .map((e) => parseInt(e));
  }),
  (_onVariantChanged2 = new WeakSet()),
  (onVariantChanged_fn2 = function (e) {
    e.detail.variant &&
      e.detail.variant.featured_media &&
      this.replaceChildren(
        createMediaImg(e.detail.variant.featured_media, __privateGet(this, _widths, widths_get), {
          class: __privateGet(this, _classAttribute),
          sizes: __privateGet(this, _sizesAttribute),
        }),
      );
  }),
  window.customElements.get('variant-media') || window.customElements.define('variant-media', VariantMedia));
var _onVariantChangedListener5,
  _onVariantChanged4,
  onVariantChanged_fn4,
  PaymentTerms = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged3),
        __privateAdd(
          this,
          _onVariantChangedListener4,
          __privateMethod(this, _onVariantChanged3, onVariantChanged_fn3).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener4),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener4),
      );
    }
  };
((_onVariantChangedListener4 = new WeakMap()),
  (_onVariantChanged3 = new WeakSet()),
  (onVariantChanged_fn3 = function (e) {
    if (e.detail.variant) {
      const t = this.querySelector('[name="id"]');
      ((t.value = e.detail.variant.id), t.dispatchEvent(new Event('change', { bubbles: !0 })));
    }
  }),
  window.customElements.get('payment-terms') || window.customElements.define('payment-terms', PaymentTerms));
var PickupAvailability = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onVariantChanged4),
      __privateAdd(
        this,
        _onVariantChangedListener5,
        __privateMethod(this, _onVariantChanged4, onVariantChanged_fn4).bind(this),
      ));
  }
  connectedCallback() {
    document.forms[this.getAttribute('form')]?.addEventListener(
      'variant:change',
      __privateGet(this, _onVariantChangedListener5),
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute('form')]?.removeEventListener(
      'variant:change',
      __privateGet(this, _onVariantChangedListener5),
    );
  }
};
((_onVariantChangedListener5 = new WeakMap()),
  (_onVariantChanged4 = new WeakSet()),
  (onVariantChanged_fn4 = async function (e) {
    if (e.detail.variant) {
      const t = document.createElement('div');
      ((t.innerHTML = await (
        await fetch(`${Shopify.routes.root}variants/${e.detail.variant.id}?section_id=pickup-availability`)
      ).text()),
        this.replaceChildren(...t.querySelector('pickup-availability').childNodes));
    } else this.innerHTML = '';
  }),
  window.customElements.get('pickup-availability') ||
    window.customElements.define('pickup-availability', PickupAvailability));
var _onVariantChangedListener6,
  _onVariantChanged5,
  onVariantChanged_fn5,
  _onVariantChangedListener7,
  _onVariantChanged6,
  onVariantChanged_fn6,
  currencyFormat = window.themeVariables.settings.currencyCodeEnabled
    ? window.themeVariables.settings.moneyWithCurrencyFormat
    : window.themeVariables.settings.moneyFormat,
  SalePrice = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged5),
        __privateAdd(
          this,
          _onVariantChangedListener6,
          __privateMethod(this, _onVariantChanged5, onVariantChanged_fn5).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener6),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener6),
      );
    }
  };
((_onVariantChangedListener6 = new WeakMap()),
  (_onVariantChanged5 = new WeakSet()),
  (onVariantChanged_fn5 = function (e) {
    const t = e.detail.variant;
    (this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(t.price, currencyFormat))),
      this.classList.toggle('text-on-sale', t.compare_at_price > t.price));
  }));
var _onVariantChangedListener8,
  _onVariantChanged7,
  onVariantChanged_fn7,
  CompareAtPrice = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged6),
        __privateAdd(
          this,
          _onVariantChangedListener7,
          __privateMethod(this, _onVariantChanged6, onVariantChanged_fn6).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener7),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener7),
      );
    }
  };
((_onVariantChangedListener7 = new WeakMap()),
  (_onVariantChanged6 = new WeakSet()),
  (onVariantChanged_fn6 = function (e) {
    const t = e.detail.variant;
    (this.lastChild.replaceWith(
      document.createRange().createContextualFragment(formatMoney(t.compare_at_price, currencyFormat)),
    ),
      (this.hidden = !(t.compare_at_price > t.price)));
  }));
var _onVariantChangedListener9,
  _onVariantChanged8,
  onVariantChanged_fn8,
  UnitPrice = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged7),
        __privateAdd(
          this,
          _onVariantChangedListener8,
          __privateMethod(this, _onVariantChanged7, onVariantChanged_fn7).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener8),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener8),
      );
    }
  };
((_onVariantChangedListener8 = new WeakMap()),
  (_onVariantChanged7 = new WeakSet()),
  (onVariantChanged_fn7 = function (e) {
    const t = e.detail.variant;
    if (!t.unit_price) return (this.hidden = !0);
    const i = 1 !== t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_value : '',
      n = document
        .createRange()
        .createContextualFragment(`${formatMoney(t.unit_price)}/${i}${t.unit_price_measurement.reference_unit}`);
    (this.lastChild.replaceWith(n), (this.hidden = !1));
  }),
  window.customElements.get('sale-price') || window.customElements.define('sale-price', SalePrice),
  window.customElements.get('compare-at-price') || window.customElements.define('compare-at-price', CompareAtPrice),
  window.customElements.get('unit-price') || window.customElements.define('unit-price', UnitPrice));
var _onVariantChangedListener10,
  _onVariantChanged9,
  onVariantChanged_fn9,
  SoldOutBadge = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged8),
        __privateAdd(
          this,
          _onVariantChangedListener9,
          __privateMethod(this, _onVariantChanged8, onVariantChanged_fn8).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener9),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener9),
      );
    }
  };
((_onVariantChangedListener9 = new WeakMap()),
  (_onVariantChanged8 = new WeakSet()),
  (onVariantChanged_fn8 = function (e) {
    this.hidden = e.detail.variant.available;
  }));
var _onBadgeChange,
  onBadgeChange_fn,
  OnSaleBadge = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged9),
        __privateAdd(
          this,
          _onVariantChangedListener10,
          __privateMethod(this, _onVariantChanged9, onVariantChanged_fn9).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener10),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener10),
      );
    }
  };
((_onVariantChangedListener10 = new WeakMap()),
  (_onVariantChanged9 = new WeakSet()),
  (onVariantChanged_fn9 = function (e) {
    const t = e.detail.variant;
    if (t.compare_at_price > t.price) {
      if (((this.hidden = !1), this.hasAttribute('discount-mode'))) {
        const e =
          'percentage' === this.getAttribute('discount-mode')
            ? `${Math.round((100 * (t.compare_at_price - t.price)) / t.compare_at_price)}%`
            : formatMoney(t.compare_at_price - t.price);
        this.innerHTML = `${window.themeVariables.strings.discountBadge.replace('@@', e)}`;
      }
    } else this.hidden = !0;
  }));
var _onVariantChangedListener11,
  _inventoryElements,
  _progressBarElement,
  _onVariantChanged10,
  onVariantChanged_fn10,
  BadgeList = class extends HTMLElement {
    constructor() {
      (super(), __privateAdd(this, _onBadgeChange));
      const e = new MutationObserver(__privateMethod(this, _onBadgeChange, onBadgeChange_fn).bind(this));
      Array.from(this.children).forEach((t) => {
        e.observe(t, { attributes: !0, attributeFilter: ['hidden'] });
      });
    }
  };
((_onBadgeChange = new WeakSet()),
  (onBadgeChange_fn = function () {
    this.hidden = Array.from(this.children).every((e) => e.hasAttribute('hidden'));
  }),
  window.customElements.get('sold-out-badge') || window.customElements.define('sold-out-badge', SoldOutBadge),
  window.customElements.get('on-sale-badge') || window.customElements.define('on-sale-badge', OnSaleBadge),
  window.customElements.get('badge-list') || window.customElements.define('badge-list', BadgeList));
var _onVariantChangedListener12,
  _onVariantChanged11,
  onVariantChanged_fn11,
  VariantInventory = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged10),
        __privateAdd(
          this,
          _onVariantChangedListener11,
          __privateMethod(this, _onVariantChanged10, onVariantChanged_fn10).bind(this),
        ),
        __privateAdd(this, _inventoryElements, void 0),
        __privateAdd(this, _progressBarElement, void 0));
    }
    connectedCallback() {
      (document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener11),
      ),
        __privateSet(this, _inventoryElements, Array.from(this.querySelectorAll('[data-variant-id]'))),
        __privateSet(this, _progressBarElement, this.querySelector('progress-bar')));
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener11),
      );
    }
  };
((_onVariantChangedListener11 = new WeakMap()),
  (_inventoryElements = new WeakMap()),
  (_progressBarElement = new WeakMap()),
  (_onVariantChanged10 = new WeakSet()),
  (onVariantChanged_fn10 = function (e) {
    ((this.hidden = !e.detail.variant),
      e.detail.variant &&
        __privateGet(this, _inventoryElements).forEach((t) => {
          t.toggleAttribute('hidden', e.detail.variant.id !== parseInt(t.getAttribute('data-variant-id'))) ||
            ((this.className = `inventory text-${t.getAttribute('data-status')}`),
            __privateGet(this, _progressBarElement) &&
              (__privateGet(this, _progressBarElement).valueNow = t.getAttribute('data-quantity')));
        }));
  }),
  window.customElements.get('variant-inventory') ||
    window.customElements.define('variant-inventory', VariantInventory));
var _abortController6,
  _photoSwipeInstance,
  _onGestureChangedListener,
  _settledMedia,
  _registerLightboxUi,
  registerLightboxUi_fn,
  _onVariantChange,
  onVariantChange_fn,
  _onMediaChange,
  onMediaChange_fn,
  _onMediaSettle,
  onMediaSettle_fn,
  _onCarouselClick,
  onCarouselClick_fn,
  _getFilteredMediaIndexes,
  getFilteredMediaIndexes_fn,
  _onGestureStart,
  onGestureStart_fn,
  _onGestureChanged,
  onGestureChanged_fn,
  VariantSku = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onVariantChanged11),
        __privateAdd(
          this,
          _onVariantChangedListener12,
          __privateMethod(this, _onVariantChanged11, onVariantChanged_fn11).bind(this),
        ));
    }
    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener12),
      );
    }
    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener(
        'variant:change',
        __privateGet(this, _onVariantChangedListener12),
      );
    }
  };
((_onVariantChangedListener12 = new WeakMap()),
  (_onVariantChanged11 = new WeakSet()),
  (onVariantChanged_fn11 = function (e) {
    e.detail.variant
      ? ((this.innerText = `${window.themeVariables.strings.sku} ${e.detail.variant.sku}`),
        (this.hidden = !e.detail.variant.sku))
      : (this.hidden = !0);
  }),
  window.customElements.get('variant-sku') || window.customElements.define('variant-sku', VariantSku));
import { PhotoSwipeLightbox } from 'vendor';
var _intersectionObserver,
  _hasProgrammaticScroll,
  _scrollDirection,
  _lastScrollPosition,
  _onMediaObserve,
  onMediaObserve_fn,
  ProductGallery = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _registerLightboxUi),
        __privateAdd(this, _onVariantChange),
        __privateAdd(this, _onMediaChange),
        __privateAdd(this, _onMediaSettle),
        __privateAdd(this, _onCarouselClick),
        __privateAdd(this, _getFilteredMediaIndexes),
        __privateAdd(this, _onGestureStart),
        __privateAdd(this, _onGestureChanged),
        __privateAdd(this, _abortController6, void 0),
        __privateAdd(this, _photoSwipeInstance, void 0),
        __privateAdd(
          this,
          _onGestureChangedListener,
          __privateMethod(this, _onGestureChanged, onGestureChanged_fn).bind(this),
        ),
        __privateAdd(this, _settledMedia, void 0),
        this.addEventListener('lightbox:open', (e) => this.openLightBox(e?.detail?.index)));
    }
    connectedCallback() {
      (__privateSet(this, _abortController6, new AbortController()),
        this.carousel &&
          (document.forms[this.getAttribute('form')]?.addEventListener(
            'variant:change',
            __privateMethod(this, _onVariantChange, onVariantChange_fn).bind(this),
            { signal: __privateGet(this, _abortController6).signal },
          ),
          this.carousel.addEventListener(
            'carousel:change',
            __privateMethod(this, _onMediaChange, onMediaChange_fn).bind(this),
            { signal: __privateGet(this, _abortController6).signal },
          ),
          this.carousel.addEventListener(
            'carousel:settle',
            __privateMethod(this, _onMediaSettle, onMediaSettle_fn).bind(this),
            { signal: __privateGet(this, _abortController6).signal },
          ),
          this.carousel.addEventListener(
            'click',
            __privateMethod(this, _onCarouselClick, onCarouselClick_fn).bind(this),
            { signal: __privateGet(this, _abortController6).signal },
          ),
          this.hasAttribute('allow-zoom') &&
            this.carousel.addEventListener(
              'gesturestart',
              __privateMethod(this, _onGestureStart, onGestureStart_fn).bind(this),
              { capture: !1, signal: __privateGet(this, _abortController6).signal },
            ),
          __privateMethod(this, _onMediaChange, onMediaChange_fn).call(this)));
    }
    disconnectedCallback() {
      __privateGet(this, _abortController6).abort();
    }
    get viewInSpaceButton() {
      return this.querySelector('[data-shopify-xr]');
    }
    get carousel() {
      return this.querySelector('.product-gallery__carousel');
    }
    get lightBox() {
      return (
        __privateGet(this, _photoSwipeInstance) ||
          (__privateSet(
            this,
            _photoSwipeInstance,
            new PhotoSwipeLightbox({
              pswpModule: () => import('photoswipe'),
              bgOpacity: 1,
              maxZoomLevel: parseInt(this.getAttribute('allow-zoom')) || 3,
              closeTitle: window.themeVariables.strings.closeGallery,
              zoomTitle: window.themeVariables.strings.zoomGallery,
              errorMsg: window.themeVariables.strings.errorGallery,
              arrowPrev: !1,
              arrowNext: !1,
              counter: !1,
              close: !1,
              zoom: !1,
            }),
          ),
          __privateGet(this, _photoSwipeInstance).on(
            'uiRegister',
            __privateMethod(this, _registerLightboxUi, registerLightboxUi_fn).bind(this),
          ),
          __privateGet(this, _photoSwipeInstance).addFilter('thumbEl', (e, t) => t.thumbnailElement),
          __privateGet(this, _photoSwipeInstance).init()),
        __privateGet(this, _photoSwipeInstance)
      );
    }
    openLightBox(e) {
      const t = this.carousel.cells
          .flatMap((e) => Array.from(e.querySelectorAll(':scope > img')))
          .map((e) => ({
            thumbnailElement: e,
            src: e.src,
            srcset: e.srcset,
            msrc: e.currentSrc || e.src,
            width: parseInt(e.getAttribute('width')),
            height: parseInt(e.getAttribute('height')),
            alt: e.alt,
            thumbCropped: !0,
          })),
        i = this.carousel.cells.filter((e) => 'image' === e.getAttribute('data-media-type'));
      this.lightBox.loadAndOpen(e ?? i.indexOf(this.carousel.selectedCell), t);
    }
  };
((_abortController6 = new WeakMap()),
  (_photoSwipeInstance = new WeakMap()),
  (_onGestureChangedListener = new WeakMap()),
  (_settledMedia = new WeakMap()),
  (_registerLightboxUi = new WeakSet()),
  (registerLightboxUi_fn = function () {
    (__privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
      name: 'close-button',
      className: 'circle-button circle-button--xl hover:animate-icon-block',
      ariaLabel: window.themeVariables.strings.closeGallery,
      order: 2,
      isButton: !0,
      html: '\n        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">\n          <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/>\n        </svg>\n      ',
      onClick: () => {
        __privateGet(this, _photoSwipeInstance).pswp.close();
      },
    }),
      __privateGet(this, _photoSwipeInstance).pswp.options.dataSource.length > 1 &&
        (__privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
          name: 'previous-button',
          className: 'circle-button hover:animate-icon-inline',
          ariaLabel: window.themeVariables.strings.previous,
          order: 1,
          isButton: !0,
          html: '\n        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">\n          <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/>\n        </svg>\n      ',
          onClick: () => {
            __privateGet(this, _photoSwipeInstance).pswp.prev();
          },
        }),
        __privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
          name: 'next-button',
          className: 'circle-button hover:animate-icon-inline',
          ariaLabel: window.themeVariables.strings.next,
          order: 3,
          isButton: !0,
          html: '\n        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">\n          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/>\n        </svg>\n      ',
          onClick: () => {
            __privateGet(this, _photoSwipeInstance).pswp.next();
          },
        })));
  }),
  (_onVariantChange = new WeakSet()),
  (onVariantChange_fn = function (e) {
    const t = __privateMethod(this, _getFilteredMediaIndexes, getFilteredMediaIndexes_fn).call(
      this,
      e.detail.product,
      e.detail.variant,
    );
    if (
      (this.carousel.filter(t),
      e.detail.variant.featured_media &&
        e.detail.previousVariant.featured_media?.id !== e.detail.variant.featured_media.id)
    ) {
      const i = e.detail.variant.featured_media.position - 1,
        n = t.filter((e) => e < i);
      this.carousel.isScrollable
        ? this.carousel.select(i - n.length, { instant: !0 })
        : this.querySelector(`[data-media-id="${e.detail.variant.featured_media.id}"]`)?.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
          });
    }
  }),
  (_onMediaChange = new WeakSet()),
  (onMediaChange_fn = function () {
    if (__privateGet(this, _settledMedia))
      switch (__privateGet(this, _settledMedia).getAttribute('data-media-type')) {
        case 'external_video':
        case 'video':
        case 'model':
          __privateGet(this, _settledMedia).firstElementChild.pause();
      }
  }),
  (_onMediaSettle = new WeakSet()),
  (onMediaSettle_fn = function (e) {
    const t = e ? e.detail.cell : this.carousel.selectedCell,
      i = this.querySelector('.product-gallery__zoom-button');
    switch (t.getAttribute('data-media-type')) {
      case 'image':
        (this.viewInSpaceButton?.setAttribute(
          'data-shopify-model3d-id',
          this.viewInSpaceButton?.getAttribute('data-shopify-model3d-default-id'),
        ),
          i?.classList.remove('product-gallery__zoom-button--hidden'));
        break;
      case 'external_video':
      case 'video':
        (this.viewInSpaceButton?.setAttribute(
          'data-shopify-model3d-id',
          this.viewInSpaceButton?.getAttribute('data-shopify-model3d-default-id'),
        ),
          i?.classList.add('product-gallery__zoom-button--hidden'),
          this.hasAttribute('autoplay-media') && t.firstElementChild.play());
        break;
      case 'model':
        (matchesMediaQuery('md') && t.firstElementChild.play(),
          this.viewInSpaceButton?.setAttribute('data-shopify-model3d-id', e.detail.cell.getAttribute('data-media-id')),
          i?.classList.add('product-gallery__zoom-button--hidden'));
    }
    __privateSet(this, _settledMedia, t);
  }),
  (_onCarouselClick = new WeakSet()),
  (onCarouselClick_fn = function (e) {
    if (!this.hasAttribute('allow-zoom') || !matchesMediaQuery('md') || 'IMG' !== e.target.tagName) return;
    const t = e.target.closest('.product-gallery__media'),
      i = this.carousel.cells.filter((e) => 'image' === e.getAttribute('data-media-type'));
    this.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: !0, detail: { index: i.indexOf(t) } }));
  }),
  (_getFilteredMediaIndexes = new WeakSet()),
  (getFilteredMediaIndexes_fn = function (e, t) {
    const i = [];
    return (
      e.media.forEach((n) => {
        let a = t.featured_media && n.position === t.featured_media.position;
        if (n.alt?.includes('#') && n.alt !== e.title && !a) {
          const a = n.alt.split('#').pop().split('_');
          e.options.forEach((e) => {
            e.name.toLowerCase() === a[0].toLowerCase() &&
              t.options[e.position - 1].toLowerCase() !== a[1].trim().toLowerCase() &&
              i.push(n.position - 1);
          });
        }
      }),
      i
    );
  }),
  (_onGestureStart = new WeakSet()),
  (onGestureStart_fn = function (e) {
    (e.preventDefault(),
      this.carousel.addEventListener('gesturechange', __privateGet(this, _onGestureChangedListener), {
        capture: !1,
        signal: __privateGet(this, _abortController6).signal,
      }));
  }),
  (_onGestureChanged = new WeakSet()),
  (onGestureChanged_fn = function (e) {
    (e.preventDefault(),
      e.scale > 1.5 &&
        (this.dispatchEvent(
          new CustomEvent('lightbox:open', { bubbles: !0, detail: { index: this.carousel.selectedIndex } }),
        ),
        this.removeEventListener('gesturechange', __privateGet(this, _onGestureChangedListener))));
  }));
var ProductGalleryNavigation = class extends CarouselNavigation {
  constructor() {
    (super(),
      __privateAdd(this, _onMediaObserve),
      __privateAdd(
        this,
        _intersectionObserver,
        new IntersectionObserver(__privateMethod(this, _onMediaObserve, onMediaObserve_fn).bind(this), {
          threshold: [0, 0.5, 1],
        }),
      ),
      __privateAdd(this, _hasProgrammaticScroll, !1),
      __privateAdd(this, _scrollDirection, 'bottom'),
      __privateAdd(this, _lastScrollPosition, void 0),
      window.addEventListener('scroll', () => {
        (window.scrollY > __privateGet(this, _lastScrollPosition)
          ? __privateSet(this, _scrollDirection, 'bottom')
          : __privateSet(this, _scrollDirection, 'top'),
          __privateSet(this, _lastScrollPosition, window.scrollY));
      }));
  }
  connectedCallback() {
    (super.connectedCallback(),
      this.carousel.allCells.forEach((e) => __privateGet(this, _intersectionObserver).observe(e)));
  }
  onButtonClicked(e) {
    this.carousel.isScrollable
      ? super.onButtonClicked(e)
      : (this.carousel.cells[e]?.scrollIntoView({ block: 'start', behavior: 'smooth' }),
        this.onNavigationChange(e),
        __privateSet(this, _hasProgrammaticScroll, !0),
        'onscrollend' in window
          ? window.addEventListener(
              'scrollend',
              () => {
                __privateSet(this, _hasProgrammaticScroll, !1);
              },
              { once: !0 },
            )
          : setTimeout(() => {
              __privateSet(this, _hasProgrammaticScroll, !1);
            }, 1e3));
  }
};
((_intersectionObserver = new WeakMap()),
  (_hasProgrammaticScroll = new WeakMap()),
  (_scrollDirection = new WeakMap()),
  (_lastScrollPosition = new WeakMap()),
  (_onMediaObserve = new WeakSet()),
  (onMediaObserve_fn = function (e) {
    if (this.carousel.isScrollable) return;
    const t = e.find((e) => e.isIntersecting && e.intersectionRatio >= 0.5);
    if (!t || __privateGet(this, _hasProgrammaticScroll)) return;
    const i = this.items.find((e) => 'true' === e.getAttribute('aria-current')),
      n = this.items.find((e) => e.getAttribute('data-media-id') === t.target.getAttribute('data-media-id'));
    (('bottom' === __privateGet(this, _scrollDirection) &&
      parseInt(n.getAttribute('data-media-position')) > parseInt(i.getAttribute('data-media-position'))) ||
      ('top' === __privateGet(this, _scrollDirection) &&
        parseInt(n.getAttribute('data-media-position')) < parseInt(i.getAttribute('data-media-position')))) &&
      (i.setAttribute('aria-current', 'false'), n.setAttribute('aria-current', 'true'));
  }));
var OpenLightBoxButton = class extends HTMLButtonElement {
  constructor() {
    (super(),
      this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: !0 }))));
  }
};
(window.customElements.get('product-gallery') || window.customElements.define('product-gallery', ProductGallery),
  window.customElements.get('product-gallery-navigation') ||
    window.customElements.define('product-gallery-navigation', ProductGalleryNavigation),
  window.customElements.get('open-lightbox-button') ||
    window.customElements.define('open-lightbox-button', OpenLightBoxButton, { extends: 'button' }));
import { inView as inView6, animate as animate9, stagger } from 'vendor';
var ProductList = class extends HTMLElement {
  connectedCallback() {
    matchesMediaQuery('motion-safe') &&
      this.querySelectorAll('product-card[reveal-on-scroll="true"]').length > 0 &&
      inView6(this, this.reveal.bind(this));
  }
  reveal() {
    animate9(
      this.querySelectorAll('product-card[reveal-on-scroll="true"]'),
      { opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0)'] },
      { duration: 0.2, easing: 'ease-in-out', delay: stagger(0.05, { start: 0.4, easing: 'ease-out' }) },
    );
  }
};
window.customElements.get('product-list') || window.customElements.define('product-list', ProductList);
var _onAfterHide,
  onAfterHide_fn,
  _abortController7,
  _onOptionChanged,
  onOptionChanged_fn,
  _onMasterSelectorChanged,
  onMasterSelectorChanged_fn,
  _getVariantById,
  getVariantById_fn,
  _getVariantFromOptions,
  getVariantFromOptions_fn,
  _isVariantSelectable,
  isVariantSelectable_fn,
  _getFirstMatchingAvailableOrSelectableVariant,
  getFirstMatchingAvailableOrSelectableVariant_fn,
  _getSelectedOptionValues,
  getSelectedOptionValues_fn,
  _updateDisableSelectors,
  updateDisableSelectors_fn,
  _updateDisableSelectorsForOptionLevel,
  updateDisableSelectorsForOptionLevel_fn,
  loadedProducts = {},
  ProductLoader = class {
    static load(e) {
      if (e)
        return (
          loadedProducts[e] ||
            (loadedProducts[e] = new Promise(async (t, i) => {
              const n = await fetch(`${Shopify.routes.root}products/${e}.js`);
              if (n.ok) {
                t(await n.json());
              } else
                i(
                  `\n          Attempted to load information for product with handle ${e}, but this product is in "draft" mode. You won't be able to\n          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status\n          to "active".\n        `,
                );
            })),
          loadedProducts[e]
        );
    }
  },
  QuickBuyModal = class extends Modal {
    constructor() {
      (super(),
        __privateAdd(this, _onAfterHide),
        'drawer' === window.themeVariables.settings.cartType &&
          document.addEventListener('variant:add', this.hide.bind(this)),
        this.addEventListener('dialog:after-hide', __privateMethod(this, _onAfterHide, onAfterHide_fn).bind(this)));
    }
    async show() {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: !0 }));
      const e = await (
        await cachedFetch(`${window.Shopify.routes.root}products/${this.getAttribute('handle')}`)
      ).text();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: !0 }));
      const t = new DOMParser().parseFromString(e, 'text/html').getElementById('quick-buy-content').content;
      return (
        Array.from(t.querySelectorAll('noscript')).forEach((e) => e.remove()),
        this.replaceChildren(document.importNode(t, !0)),
        Shopify?.PaymentButton?.init(),
        super.show()
      );
    }
  };
((_onAfterHide = new WeakSet()),
  (onAfterHide_fn = function () {
    this.innerHTML = '';
  }),
  window.customElements.get('quick-buy-modal') || window.customElements.define('quick-buy-modal', QuickBuyModal));
var _onVariantChangedListener13,
  _onVariantChanged12,
  onVariantChanged_fn12,
  VariantPicker = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onOptionChanged),
        __privateAdd(this, _onMasterSelectorChanged),
        __privateAdd(this, _getVariantById),
        __privateAdd(this, _getVariantFromOptions),
        __privateAdd(this, _isVariantSelectable),
        __privateAdd(this, _getFirstMatchingAvailableOrSelectableVariant),
        __privateAdd(this, _getSelectedOptionValues),
        __privateAdd(this, _updateDisableSelectors),
        __privateAdd(this, _updateDisableSelectorsForOptionLevel),
        __privateAdd(this, _abortController7, void 0));
    }
    async connectedCallback() {
      (__privateSet(this, _abortController7, new AbortController()),
        (this.masterSelector = document.forms[this.getAttribute('form')].id),
        (this.optionSelectors = Array.from(this.querySelectorAll('[data-option-selector]'))),
        this.masterSelector
          ? ((this.product = await ProductLoader.load(this.productHandle)),
            this.optionSelectors.forEach((e) => {
              e.addEventListener('change', __privateMethod(this, _onOptionChanged, onOptionChanged_fn).bind(this), {
                signal: __privateGet(this, _abortController7).signal,
              });
            }),
            this.masterSelector.addEventListener(
              'change',
              __privateMethod(this, _onMasterSelectorChanged, onMasterSelectorChanged_fn).bind(this),
              { signal: __privateGet(this, _abortController7).signal },
            ),
            __privateMethod(this, _updateDisableSelectors, updateDisableSelectors_fn).call(this),
            this.selectVariant(this.selectedVariant.id))
          : console.warn(
              `The variant selector for product with handle ${this.productHandle} is not linked to any product form.`,
            ));
    }
    disconnectedCallback() {
      __privateGet(this, _abortController7).abort();
    }
    get selectedVariant() {
      return __privateMethod(this, _getVariantById, getVariantById_fn).call(this, parseInt(this.masterSelector.value));
    }
    get productHandle() {
      return this.getAttribute('handle');
    }
    get hideSoldOutVariants() {
      return this.hasAttribute('hide-sold-out-variants');
    }
    get updateUrl() {
      return this.hasAttribute('update-url');
    }
    selectVariant(e) {
      __privateMethod(this, _isVariantSelectable, isVariantSelectable_fn).call(
        this,
        __privateMethod(this, _getVariantById, getVariantById_fn).call(this, e),
      ) ||
        (e = __privateMethod(
          this,
          _getFirstMatchingAvailableOrSelectableVariant,
          getFirstMatchingAvailableOrSelectableVariant_fn,
        ).call(this).id);
      const t = this.selectedVariant;
      if (!t || t.id !== e) {
        if (
          ((this.masterSelector.value = e),
          this.masterSelector.dispatchEvent(new Event('change', { bubbles: !0 })),
          this.updateUrl && history.replaceState)
        ) {
          const t = new URL(window.location.href);
          (e ? t.searchParams.set('variant', e) : t.searchParams.delete('variant'),
            window.history.replaceState({ path: t.toString() }, '', t.toString()));
        }
        (__privateMethod(this, _updateDisableSelectors, updateDisableSelectors_fn).call(this),
          this.masterSelector.form.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: !0,
              detail: { product: this.product, variant: this.selectedVariant, previousVariant: t },
            }),
          ));
      }
    }
  };
((_abortController7 = new WeakMap()),
  (_onOptionChanged = new WeakSet()),
  (onOptionChanged_fn = function (e) {
    e.target.name.startsWith('option') &&
      this.selectVariant(__privateMethod(this, _getVariantFromOptions, getVariantFromOptions_fn).call(this)?.id);
  }),
  (_onMasterSelectorChanged = new WeakSet()),
  (onMasterSelectorChanged_fn = function () {
    (this.selectedVariant?.options || []).forEach((e, t) => {
      let i = this.optionSelectors[t].querySelector(
          `input[type="radio"][name="option${t + 1}"][value="${CSS.escape(e)}"], input[type="hidden"][name="option${t + 1}"], select[name="option${t + 1}"]`,
        ),
        n = !1;
      ('SELECT' === i.tagName || ('INPUT' === i.tagName && 'hidden' === i.type)
        ? ((n = i.value !== e), (i.value = e))
        : 'INPUT' === i.tagName &&
          'radio' === i.type &&
          ((n = !i.checked && i.value === e), (i.checked = i.value === e)),
        n && i.dispatchEvent(new Event('change', { bubbles: !0 })));
    });
  }),
  (_getVariantById = new WeakSet()),
  (getVariantById_fn = function (e) {
    return this.product.variants.find((t) => t.id === e);
  }),
  (_getVariantFromOptions = new WeakSet()),
  (getVariantFromOptions_fn = function () {
    const e = __privateMethod(this, _getSelectedOptionValues, getSelectedOptionValues_fn).call(this);
    return this.product.variants.find((t) => t.options.every((t, i) => t === e[i]));
  }),
  (_isVariantSelectable = new WeakSet()),
  (isVariantSelectable_fn = function (e) {
    return !!e && (e.available || (!this.hideSoldOutVariants && !e.available));
  }),
  (_getFirstMatchingAvailableOrSelectableVariant = new WeakSet()),
  (getFirstMatchingAvailableOrSelectableVariant_fn = function () {
    let e = __privateMethod(this, _getSelectedOptionValues, getSelectedOptionValues_fn).call(this),
      t = null,
      i = 0;
    do {
      (e.pop(),
        (i += 1),
        (t = this.product.variants.find((t) =>
          this.hideSoldOutVariants
            ? t.available && t.options.slice(0, t.options.length - i).every((t, i) => t === e[i])
            : t.options.slice(0, t.options.length - i).every((t, i) => t === e[i]),
        )));
    } while (!t && e.length > 0);
    return t;
  }),
  (_getSelectedOptionValues = new WeakSet()),
  (getSelectedOptionValues_fn = function () {
    return this.optionSelectors.map(
      (e) =>
        e.querySelector('input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]')
          .value,
    );
  }),
  (_updateDisableSelectors = new WeakSet()),
  (updateDisableSelectors_fn = function () {
    const e = this.selectedVariant;
    e &&
      __privateMethod(this, _updateDisableSelectorsForOptionLevel, updateDisableSelectorsForOptionLevel_fn).call(
        this,
        0,
        e,
      );
  }),
  (_updateDisableSelectorsForOptionLevel = new WeakSet()),
  (updateDisableSelectorsForOptionLevel_fn = function (e, t) {
    if (!this.optionSelectors[e]) return;
    const i = (e, t, i, n) => {
        const a = Array.from(e.querySelectorAll('[data-option-value]'))[t];
        (a.toggleAttribute('hidden', !n),
          this.hideSoldOutVariants ? a.toggleAttribute('hidden', !i) : a.classList.toggle('is-disabled', !i));
      },
      n = (e, t, i, n) =>
        Array.from({ length: t + 1 }, (a, r) =>
          r === t ? e[`option${t + 1}`] === i : e[`option${r + 1}`] === n[`option${r + 1}`],
        ).every((e) => e);
    this.product.options[e].values.forEach((a, r) => {
      const o = this.product.variants.some((i) => n(i, e, a, t) && i),
        s = this.product.variants.some((i) => n(i, e, a, t) && i.available);
      (i(this.optionSelectors[e], r, s, o),
        __privateMethod(this, _updateDisableSelectorsForOptionLevel, updateDisableSelectorsForOptionLevel_fn).call(
          this,
          e + 1,
          t,
        ));
    });
  }));
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onVariantChanged12),
      __privateAdd(
        this,
        _onVariantChangedListener13,
        __privateMethod(this, _onVariantChanged12, onVariantChanged_fn12).bind(this),
      ));
  }
  connectedCallback() {
    document.forms[this.getAttribute('form')]?.addEventListener(
      'variant:change',
      __privateGet(this, _onVariantChangedListener13),
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute('form')]?.removeEventListener(
      'variant:change',
      __privateGet(this, _onVariantChangedListener13),
    );
  }
};
((_onVariantChangedListener13 = new WeakMap()),
  (_onVariantChanged12 = new WeakSet()),
  (onVariantChanged_fn12 = function (e) {
    this.innerHTML = e.detail.variant[this.getAttribute('for')];
  }),
  window.customElements.get('variant-picker') || window.customElements.define('variant-picker', VariantPicker),
  window.customElements.get('variant-option-value') ||
    window.customElements.define('variant-option-value', VariantOptionValue));
import { inView as inView7 } from 'vendor';
var BaseMedia = class extends HTMLElement {
    static get observedAttributes() {
      return ['playing'];
    }
    connectedCallback() {
      ((this._abortController = new AbortController()),
        this.hasAttribute('autoplay') && inView7(this, this.play.bind(this), { margin: '0px 0px 0px 0px' }));
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get playing() {
      return this.hasAttribute('playing');
    }
    get player() {
      return (this._playerProxy =
        this._playerProxy ||
        new Proxy(this._playerTarget(), {
          get: (e, t) => async () => {
            ((e = await e), this._playerHandler(e, t));
          },
        }));
    }
    play() {
      this.playing || this.player.play();
    }
    pause() {
      this.playing && this.player.pause();
    }
    attributeChangedCallback(e, t, i) {
      'playing' === e &&
        (null === t && '' === i
          ? (this.dispatchEvent(new CustomEvent('media:play', { bubbles: !0 })),
            this.hasAttribute('group') &&
              Array.from(document.querySelectorAll(`[group="${this.getAttribute('group')}"]`))
                .filter((e) => e !== this)
                .forEach((e) => {
                  e.pause();
                }))
          : null === i && this.dispatchEvent(new CustomEvent('media:pause', { bubbles: !0 })));
    }
  },
  ModelMedia = class extends BaseMedia {
    connectedCallback() {
      (super.connectedCallback(), this.player);
    }
    _playerTarget() {
      return new Promise((e) => {
        (this.setAttribute('loaded', ''),
          window.Shopify.loadFeatures([
            { name: 'shopify-xr', version: '1.0', onLoad: this._setupShopifyXr.bind(this) },
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: () => {
                const t = this.querySelector('model-viewer');
                (t.addEventListener('shopify_model_viewer_ui_toggle_play', () => this.setAttribute('playing', '')),
                  t.addEventListener('shopify_model_viewer_ui_toggle_pause', () => this.removeAttribute('playing')),
                  e(new window.Shopify.ModelViewerUI(t, { focusOnPlay: !0 })));
              },
            },
          ]));
      });
    }
    _playerHandler(e, t) {
      e[t]();
    }
    async _setupShopifyXr() {
      if (window.ShopifyXR) {
        const e = (await ProductLoader.load(this.getAttribute('handle'))).media.filter((e) => 'model' === e.media_type);
        (window.ShopifyXR.addModels(e), window.ShopifyXR.setupXRElements());
      } else document.addEventListener('shopify_xr_initialized', this._setupShopifyXr.bind(this));
    }
  };
window.customElements.get('model-media') || window.customElements.define('model-media', ModelMedia);
import { inView as inView8 } from 'vendor';
var _onSummaryClickedListener,
  _onSummaryClicked,
  onSummaryClicked_fn,
  onYouTubePromise = new Promise((e) => {
    window.onYouTubeIframeAPIReady = () => e();
  }),
  VideoMedia = class extends BaseMedia {
    #t = !1;
    connectedCallback() {
      (super.connectedCallback(),
        this.hasAttribute('autoplay') ||
          this.addEventListener('click', this.play, { once: !0, signal: this._abortController.signal }),
        this.hasAttribute('show-play-button') &&
          !this.shadowRoot &&
          this.attachShadow({ mode: 'open' }).appendChild(
            document.getElementById('video-media-default-template').content.cloneNode(!0),
          ),
        'video' === this.getAttribute('type') &&
          inView8(
            this,
            () => {
              this.querySelector('video')?.setAttribute('preload', 'metadata');
            },
            { margin: '800px' },
          ));
    }
    _playerTarget() {
      if (this.hasAttribute('host'))
        return (
          this.setAttribute('loaded', ''),
          new Promise(async (e) => {
            const t = this.querySelector('template');
            t && t.replaceWith(t.content.firstElementChild.cloneNode(!0));
            const i = this.hasAttribute('autoplay') || matchesMediaQuery('md-max'),
              n = document.createElement('script');
            if (((n.type = 'text/javascript'), 'youtube' === this.getAttribute('host'))) {
              ((window.YT && window.YT.Player) ||
                ((n.src = 'https://www.youtube.com/iframe_api'),
                document.head.appendChild(n),
                await new Promise((e) => {
                  n.onload = e;
                })),
                await onYouTubePromise);
              const t = new YT.Player(this.querySelector('iframe'), {
                events: {
                  onReady: () => {
                    (i && t.mute(), e(t));
                  },
                  onStateChange: (e) => {
                    e.data === YT.PlayerState.PLAYING
                      ? this.setAttribute('playing', '')
                      : (e.data !== YT.PlayerState.ENDED && e.data !== YT.PlayerState.PAUSED) ||
                        this.removeAttribute('playing');
                  },
                },
              });
            }
            if ('vimeo' === this.getAttribute('host')) {
              (window.Vimeo && window.Vimeo.Player) ||
                ((n.src = 'https://player.vimeo.com/api/player.js'),
                document.head.appendChild(n),
                await new Promise((e) => {
                  n.onload = e;
                }));
              const t = new Vimeo.Player(this.querySelector('iframe'));
              (i && t.setMuted(!0),
                t.on('play', () => {
                  this.setAttribute('playing', '');
                }),
                t.on('pause', () => this.removeAttribute('playing')),
                t.on('ended', () => this.removeAttribute('playing')),
                e(t));
            }
          })
        );
      {
        const e = this.querySelector('video');
        return (
          this.setAttribute('loaded', ''),
          e.addEventListener('play', () => {
            (this.setAttribute('playing', ''), this.removeAttribute('suspended'), this.#t && (e.controls = !1));
          }),
          e.addEventListener('pause', () => {
            !e.seeking && e.paused && this.removeAttribute('playing');
          }),
          e
        );
      }
    }
    _playerHandler(e, t) {
      'youtube' === this.getAttribute('host')
        ? 'play' === t
          ? e.playVideo()
          : e.pauseVideo()
        : 'play' !== t || this.hasAttribute('host')
          ? e[t]()
          : e.play().catch((t) => {
              'NotAllowedError' === t.name &&
                (this.setAttribute('suspended', ''),
                this.hasAttribute('controls') || ((this.#t = !0), (e.controls = !0)));
            });
    }
  };
window.customElements.get('video-media') || window.customElements.define('video-media', VideoMedia);
import { timeline as timeline5 } from 'vendor';
var CustomDetails = class extends HTMLDetailsElement {
  constructor() {
    (super(),
      __privateAdd(this, _onSummaryClicked),
      __privateAdd(
        this,
        _onSummaryClickedListener,
        __privateMethod(this, _onSummaryClicked, onSummaryClicked_fn).bind(this),
      ),
      Shopify.designMode &&
        (this.addEventListener('shopify:block:select', (e) => this.toggle(!0, !e.detail.load)),
        this.addEventListener('shopify:block:deselect', (e) => this.toggle(!1, !e.detail.load))));
  }
  static get observedAttributes() {
    return ['open', 'aria-expanded'];
  }
  connectedCallback() {
    (this.setAttribute('aria-expanded', this.open ? 'true' : 'false'),
      this.summaryElement.addEventListener('click', __privateGet(this, _onSummaryClickedListener)));
  }
  disconnectedCallback() {
    this.summaryElement.removeEventListener('click', __privateGet(this, _onSummaryClickedListener));
  }
  get summaryElement() {
    return this.firstElementChild;
  }
  get contentElement() {
    return this.lastElementChild;
  }
  toggle(e = void 0, t = !0) {
    const i = 'boolean' == typeof e ? e : !('true' === this.getAttribute('aria-expanded'));
    (i && this.setAttribute('open', t ? '' : 'immediate'), this.setAttribute('aria-expanded', i ? 'true' : 'false'));
  }
  attributeChangedCallback(e, t, i) {
    switch (e) {
      case 'open':
        this.setAttribute('aria-expanded', null !== i ? 'true' : 'false');
        break;
      case 'aria-expanded':
        if (t === i || !this.isConnected) return;
        if ('false' === i && this.open)
          this.createHideAnimationControls()?.finished.then((e) => {
            void 0 !== e && this.removeAttribute('open');
          });
        else if ('true' === i) {
          const e = this.createShowAnimationControls();
          'immediate' === this.getAttribute('open') && e.finish();
        }
    }
  }
  createShowAnimationControls() {}
  createHideAnimationControls() {}
};
((_onSummaryClickedListener = new WeakMap()),
  (_onSummaryClicked = new WeakSet()),
  (onSummaryClicked_fn = function (e) {
    if (this.open && this.summaryElement.hasAttribute('data-follow-link'))
      return (window.location.href = this.summaryElement.getAttribute('data-follow-link'));
    (e.preventDefault(), this.toggle());
  }));
var _hoverTimer,
  _detectClickOutsideListener,
  _detectEscKeyboardListener,
  _detectFocusOutListener,
  _detectHoverOutsideListener,
  _detectHoverListener,
  _detectClickOutside,
  detectClickOutside_fn,
  _detectHover,
  detectHover_fn,
  _detectHoverOutside,
  detectHoverOutside_fn,
  _detectEscKeyboard,
  detectEscKeyboard_fn,
  _detectFocusOut,
  detectFocusOut_fn,
  AccordionDisclosure = class extends CustomDetails {
    createShowAnimationControls() {
      this.style.overflow = 'hidden';
      const e = timeline5([
        [
          this,
          { height: [`${this.summaryElement.clientHeight}px`, `${this.scrollHeight}px`] },
          { duration: 0.25, easing: 'ease' },
        ],
        [
          this.contentElement,
          { opacity: [0, 1], transform: ['translateY(4px)', 'translateY(0)'] },
          { duration: 0.15, at: '-0.1' },
        ],
      ]);
      return (
        e.finished.then(() => {
          ((this.style.height = null), (this.style.overflow = null));
        }),
        e
      );
    }
    createHideAnimationControls() {
      const e = timeline5([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [
          this,
          { height: [`${this.clientHeight}px`, `${this.summaryElement.clientHeight}px`] },
          { duration: 0.25, at: '<', easing: 'ease' },
        ],
      ]);
      return (
        e.finished.then(() => {
          this.style.height = null;
        }),
        e
      );
    }
  };
window.customElements.get('accordion-disclosure') ||
  window.customElements.define('accordion-disclosure', AccordionDisclosure, { extends: 'details' });
var _MenuDisclosure = class extends CustomDetails {
  constructor() {
    (super(),
      __privateAdd(this, _detectClickOutside),
      __privateAdd(this, _detectHover),
      __privateAdd(this, _detectHoverOutside),
      __privateAdd(this, _detectEscKeyboard),
      __privateAdd(this, _detectFocusOut),
      __privateAdd(this, _hoverTimer, void 0),
      __privateAdd(
        this,
        _detectClickOutsideListener,
        __privateMethod(this, _detectClickOutside, detectClickOutside_fn).bind(this),
      ),
      __privateAdd(
        this,
        _detectEscKeyboardListener,
        __privateMethod(this, _detectEscKeyboard, detectEscKeyboard_fn).bind(this),
      ),
      __privateAdd(this, _detectFocusOutListener, __privateMethod(this, _detectFocusOut, detectFocusOut_fn).bind(this)),
      __privateAdd(
        this,
        _detectHoverOutsideListener,
        __privateMethod(this, _detectHoverOutside, detectHoverOutside_fn).bind(this),
      ),
      __privateAdd(this, _detectHoverListener, __privateMethod(this, _detectHover, detectHover_fn).bind(this)),
      this.addEventListener('mouseover', __privateGet(this, _detectHoverListener)),
      this.addEventListener('mouseout', __privateGet(this, _detectHoverListener)));
  }
  get trigger() {
    return window.matchMedia('screen and (pointer: fine)').matches ? this.getAttribute('trigger') : 'click';
  }
  get mouseOverDelayTolerance() {
    return 250;
  }
  attributeChangedCallback(e, t, i) {
    if ((super.attributeChangedCallback(e, t, i), 'aria-expanded' === e)) {
      if (t === i) return;
      'false' === i
        ? (document.removeEventListener('click', __privateGet(this, _detectClickOutsideListener)),
          document.removeEventListener('keydown', __privateGet(this, _detectEscKeyboardListener)),
          document.removeEventListener('focusout', __privateGet(this, _detectFocusOutListener)),
          document.removeEventListener('mouseover', __privateGet(this, _detectHoverOutsideListener)))
        : (document.addEventListener('click', __privateGet(this, _detectClickOutsideListener)),
          document.addEventListener('keydown', __privateGet(this, _detectEscKeyboardListener)),
          document.addEventListener('focusout', __privateGet(this, _detectFocusOutListener)),
          document.addEventListener('mouseover', __privateGet(this, _detectHoverOutsideListener)));
    }
  }
};
((_hoverTimer = new WeakMap()),
  (_detectClickOutsideListener = new WeakMap()),
  (_detectEscKeyboardListener = new WeakMap()),
  (_detectFocusOutListener = new WeakMap()),
  (_detectHoverOutsideListener = new WeakMap()),
  (_detectHoverListener = new WeakMap()),
  (_detectClickOutside = new WeakSet()),
  (detectClickOutside_fn = function (e) {
    'click' === this.trigger &&
      (this.contains(e.target) || e.target.closest('details') instanceof _MenuDisclosure || this.toggle(!1));
  }),
  (_detectHover = new WeakSet()),
  (detectHover_fn = function (e) {
    'hover' === this.trigger &&
      ('mouseover' === e.type
        ? (clearTimeout(__privateGet(this, _hoverTimer)), this.toggle(!0))
        : 'mouseout' === e.type &&
          __privateSet(
            this,
            _hoverTimer,
            setTimeout(() => this.toggle(!1), this.mouseOverDelayTolerance),
          ));
  }),
  (_detectHoverOutside = new WeakSet()),
  (detectHoverOutside_fn = function (e) {
    if ('hover' !== this.trigger) return;
    const t = e.target.closest('details');
    t instanceof _MenuDisclosure &&
      t !== this &&
      !t.contains(this) &&
      !this.contains(t) &&
      (clearTimeout(__privateGet(this, _hoverTimer)), this.toggle(!1));
  }),
  (_detectEscKeyboard = new WeakSet()),
  (detectEscKeyboard_fn = function (e) {
    if ('Escape' === e.code) {
      const t = e.target.closest('details[open]');
      t && t instanceof _MenuDisclosure && (t.toggle(!1), e.stopPropagation());
    }
  }),
  (_detectFocusOut = new WeakSet()),
  (detectFocusOut_fn = function (e) {
    e.relatedTarget && !this.contains(e.relatedTarget) && this.toggle(!1);
  }));
var _componentID,
  _buttons,
  _panels,
  _delegate4,
  _setupComponent,
  setupComponent_fn,
  _onButtonClicked,
  onButtonClicked_fn,
  _onSlotChange,
  onSlotChange_fn,
  _handleKeyboard,
  handleKeyboard_fn,
  MenuDisclosure = _MenuDisclosure;
import { Delegate as Delegate5, animate as animate10, timeline as timeline6 } from 'vendor';
var _listenersAbortController2,
  _fetchAbortController,
  _searchForm,
  _queryInput,
  _onInputChanged2,
  onInputChanged_fn2,
  _onFormSubmitted2,
  onFormSubmitted_fn2,
  _doPredictiveSearch,
  doPredictiveSearch_fn,
  _onSearchCleared,
  onSearchCleared_fn,
  Tabs = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _setupComponent),
        __privateAdd(this, _onButtonClicked),
        __privateAdd(this, _onSlotChange),
        __privateAdd(this, _handleKeyboard),
        __privateAdd(this, _componentID, crypto.randomUUID ? crypto.randomUUID() : Math.floor(1e4 * Math.random())),
        __privateAdd(this, _buttons, []),
        __privateAdd(this, _panels, []),
        __privateAdd(this, _delegate4, new Delegate5(this)),
        this.shadowRoot ||
          this.attachShadow({ mode: 'open' }).appendChild(this.querySelector('template').content.cloneNode(!0)),
        Shopify.designMode &&
          this.addEventListener(
            'shopify:block:select',
            (e) => (this.selectedIndex = __privateGet(this, _buttons).indexOf(e.target)),
          ),
        __privateGet(this, _delegate4).on(
          'click',
          'button[role="tab"]',
          __privateMethod(this, _onButtonClicked, onButtonClicked_fn).bind(this),
        ),
        this.shadowRoot.addEventListener(
          'slotchange',
          __privateMethod(this, _onSlotChange, onSlotChange_fn).bind(this),
        ),
        this.addEventListener('keydown', __privateMethod(this, _handleKeyboard, handleKeyboard_fn)));
    }
    static get observedAttributes() {
      return ['selected-index'];
    }
    connectedCallback() {
      (__privateMethod(this, _setupComponent, setupComponent_fn).call(this), (this.selectedIndex = this.selectedIndex));
    }
    disconnectedCallback() {
      __privateGet(this, _delegate4).destroy();
    }
    get animationDuration() {
      return this.hasAttribute('animation-duration') ? parseFloat(this.getAttribute('animation-duration')) : 0.3;
    }
    get selectedIndex() {
      return parseInt(this.getAttribute('selected-index')) || 0;
    }
    set selectedIndex(e) {
      (this.setAttribute(
        'selected-index',
        Math.min(Math.max(e, 0), __privateGet(this, _buttons).length - 1).toString(),
      ),
        this.style.setProperty('--selected-index', this.selectedIndex.toString()));
    }
    attributeChangedCallback(e, t, i) {
      (__privateGet(this, _buttons).forEach((e, t) =>
        e.setAttribute('aria-selected', t === parseInt(i) ? 'true' : 'false'),
      ),
        'selected-index' === e &&
          null !== t &&
          t !== i &&
          this.transition(__privateGet(this, _panels)[parseInt(t)], __privateGet(this, _panels)[parseInt(i)]));
    }
    async transition(e, t) {
      const i = this.clientHeight;
      (await animate10(
        e,
        { transform: ['translateY(0px)', 'translateY(10px)'], opacity: [1, 0] },
        { duration: this.animationDuration },
      ).finished,
        (e.hidden = !0),
        (t.hidden = !1),
        await timeline6([
          [
            this,
            { height: [`${i}px`, `${this.clientHeight}px`], overflow: ['hidden', 'visible'] },
            { duration: 0.15, easing: [0.85, 0, 0.15, 1] },
          ],
          [
            t,
            { transform: ['translateY(10px)', 'translateY(0px)'], opacity: [0, 1] },
            { duration: this.animationDuration, at: '+0.1' },
          ],
        ]).finished,
        this.style.removeProperty('height'));
    }
  };
((_componentID = new WeakMap()),
  (_buttons = new WeakMap()),
  (_panels = new WeakMap()),
  (_delegate4 = new WeakMap()),
  (_setupComponent = new WeakSet()),
  (setupComponent_fn = function () {
    (__privateSet(
      this,
      _buttons,
      Array.from(
        this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(),
        (e) => (e.matches('button') && e) || e.querySelector('button'),
      ),
    ),
      __privateSet(this, _panels, Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes())),
      __privateGet(this, _buttons).forEach((e, t) => {
        (e.setAttribute('role', 'tab'),
          e.setAttribute('aria-controls', `tab-panel-${__privateGet(this, _componentID)}-${t}`),
          (e.id = `tab-${__privateGet(this, _componentID)}-${t}`));
      }),
      __privateGet(this, _panels).forEach((e, t) => {
        (e.setAttribute('role', 'tabpanel'),
          e.setAttribute('aria-labelledby', `tab-${__privateGet(this, _componentID)}-${t}`),
          (e.id = `tab-panel-${__privateGet(this, _componentID)}-${t}`),
          (e.hidden = t !== this.selectedIndex));
      }),
      this.style.setProperty('--item-count', __privateGet(this, _buttons).length.toString()));
  }),
  (_onButtonClicked = new WeakSet()),
  (onButtonClicked_fn = function (e, t) {
    this.selectedIndex = __privateGet(this, _buttons).indexOf(t);
  }),
  (_onSlotChange = new WeakSet()),
  (onSlotChange_fn = function () {
    __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
  }),
  (_handleKeyboard = new WeakSet()),
  (handleKeyboard_fn = function (e) {
    -1 !== __privateGet(this, _buttons).indexOf(document.activeElement) &&
      ['ArrowLeft', 'ArrowRight'].includes(e.key) &&
      ('ArrowLeft' === e.key
        ? (this.selectedIndex =
            (this.selectedIndex - 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length)
        : (this.selectedIndex =
            (this.selectedIndex + 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length),
      __privateGet(this, _buttons)[this.selectedIndex].focus());
  }),
  window.customElements.get('x-tabs') || window.customElements.define('x-tabs', Tabs));
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    (super(),
      __privateAdd(this, _onInputChanged2),
      __privateAdd(this, _onFormSubmitted2),
      __privateAdd(this, _doPredictiveSearch),
      __privateAdd(this, _onSearchCleared),
      __privateAdd(this, _listenersAbortController2, void 0),
      __privateAdd(this, _fetchAbortController, void 0),
      __privateAdd(this, _searchForm, void 0),
      __privateAdd(this, _queryInput, void 0),
      this.attachShadow({ mode: 'open' }),
      this.shadowRoot.appendChild(document.createRange().createContextualFragment('<slot name="results"></slot>')));
  }
  connectedCallback() {
    (__privateSet(this, _listenersAbortController2, new AbortController()),
      __privateSet(this, _searchForm, document.querySelector(`[aria-owns="${this.id}"]`)),
      __privateSet(this, _queryInput, __privateGet(this, _searchForm).elements.q),
      __privateGet(this, _searchForm).addEventListener(
        'submit',
        __privateMethod(this, _onFormSubmitted2, onFormSubmitted_fn2).bind(this),
        { signal: __privateGet(this, _listenersAbortController2).signal },
      ),
      __privateGet(this, _searchForm).addEventListener(
        'reset',
        __privateMethod(this, _onSearchCleared, onSearchCleared_fn).bind(this),
        { signal: __privateGet(this, _listenersAbortController2).signal },
      ),
      __privateGet(this, _queryInput).addEventListener(
        'input',
        debounce(__privateMethod(this, _onInputChanged2, onInputChanged_fn2).bind(this), this.autoCompleteDelay, {
          signal: __privateGet(this, _listenersAbortController2).signal,
        }),
      ));
  }
  disconnectedCallback() {
    __privateGet(this, _listenersAbortController2).abort();
  }
  get autoCompleteDelay() {
    return 280;
  }
  supportsPredictiveApi() {
    return JSON.parse(document.getElementById('shopify-features').innerHTML).predictiveSearch;
  }
};
((_listenersAbortController2 = new WeakMap()),
  (_fetchAbortController = new WeakMap()),
  (_searchForm = new WeakMap()),
  (_queryInput = new WeakMap()),
  (_onInputChanged2 = new WeakSet()),
  (onInputChanged_fn2 = function () {
    if ('' === __privateGet(this, _queryInput).value)
      return __privateMethod(this, _onSearchCleared, onSearchCleared_fn).call(this);
    (__privateGet(this, _fetchAbortController)?.abort(),
      __privateSet(this, _fetchAbortController, new AbortController()));
    try {
      return __privateMethod(this, _doPredictiveSearch, doPredictiveSearch_fn).call(this);
    } catch (e) {
      if ('AbortError' !== e.name) throw e;
    }
  }),
  (_onFormSubmitted2 = new WeakSet()),
  (onFormSubmitted_fn2 = function (e) {
    if ('' === __privateGet(this, _queryInput).value) return e.preventDefault();
  }),
  (_doPredictiveSearch = new WeakSet()),
  (doPredictiveSearch_fn = async function () {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: !0 }));
    const e = `${window.Shopify.routes.root}search${this.supportsPredictiveApi() ? '/suggest' : ''}`,
      t = `q=${__privateGet(this, _queryInput).value}&section_id=predictive-search&resources[limit]=10&resources[limit_scope]=each`,
      i = new DOMParser().parseFromString(
        await (await cachedFetch(`${e}?${t}`, { signal: __privateGet(this, _fetchAbortController).signal })).text(),
        'text/html',
      );
    (this.querySelector('[slot="results"]').replaceChildren(
      ...document.importNode(i.querySelector('.shopify-section'), !0).children,
    ),
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: !0 })));
  }),
  (_onSearchCleared = new WeakSet()),
  (onSearchCleared_fn = function () {
    (__privateGet(this, _fetchAbortController)?.abort(),
      __privateGet(this, _queryInput).focus(),
      (this.querySelector('[slot="results"]').innerHTML = ''));
  }),
  window.customElements.get('predictive-search') ||
    window.customElements.define('predictive-search', PredictiveSearch));
import { animate as animate11 } from 'vendor';
var _onPointerMoveListener,
  _onTouchMoveListener,
  _touchStartTimestamp,
  _onPointerDown,
  onPointerDown_fn,
  _onPointerMove,
  onPointerMove_fn,
  _onTouchMove,
  onTouchMove_fn,
  _onPointerUp,
  onPointerUp_fn,
  _onKeyboardNavigation2,
  onKeyboardNavigation_fn2,
  _calculatePosition,
  calculatePosition_fn,
  _animateInitialPosition,
  animateInitialPosition_fn,
  AnnouncementBarCarousel = class extends EffectCarousel {
    createOnChangeAnimationControls(e, t) {
      return {
        leaveControls: () =>
          animate11(
            e,
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-10px)'] },
            { duration: 0.25, easing: [0.55, 0.055, 0.675, 0.19] },
          ),
        enterControls: () =>
          animate11(
            t,
            { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0px)'] },
            { duration: 0.4, easing: [0.215, 0.61, 0.355, 1] },
          ),
      };
    }
  };
window.customElements.get('announcement-bar-carousel') ||
  window.customElements.define('announcement-bar-carousel', AnnouncementBarCarousel);
import { animate as animate12, inView as inView9 } from 'vendor';
var _reveal,
  reveal_fn,
  BeforeAfter = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _onPointerDown),
        __privateAdd(this, _onPointerMove),
        __privateAdd(this, _onTouchMove),
        __privateAdd(this, _onPointerUp),
        __privateAdd(this, _onKeyboardNavigation2),
        __privateAdd(this, _calculatePosition),
        __privateAdd(this, _animateInitialPosition),
        __privateAdd(this, _onPointerMoveListener, __privateMethod(this, _onPointerMove, onPointerMove_fn).bind(this)),
        __privateAdd(this, _onTouchMoveListener, __privateMethod(this, _onTouchMove, onTouchMove_fn).bind(this)),
        __privateAdd(this, _touchStartTimestamp, 0),
        this.addEventListener('pointerdown', __privateMethod(this, _onPointerDown, onPointerDown_fn)),
        this.addEventListener('keydown', __privateMethod(this, _onKeyboardNavigation2, onKeyboardNavigation_fn2)));
    }
    connectedCallback() {
      inView9(this, __privateMethod(this, _animateInitialPosition, animateInitialPosition_fn).bind(this));
    }
  };
((_onPointerMoveListener = new WeakMap()),
  (_onTouchMoveListener = new WeakMap()),
  (_touchStartTimestamp = new WeakMap()),
  (_onPointerDown = new WeakSet()),
  (onPointerDown_fn = function (e) {
    if ('A' !== e.target.tagName)
      if (
        (document.addEventListener('pointerup', __privateMethod(this, _onPointerUp, onPointerUp_fn).bind(this), {
          once: !0,
        }),
        matchesMediaQuery('supports-hover'))
      )
        (document.addEventListener('pointermove', __privateGet(this, _onPointerMoveListener)),
          __privateMethod(this, _calculatePosition, calculatePosition_fn).call(this, e));
      else {
        const t = this.querySelector('.before-after__cursor');
        e.target === t || t.contains(e.target)
          ? (document.addEventListener('pointermove', __privateGet(this, _onPointerMoveListener)),
            this.addEventListener('touchmove', __privateGet(this, _onTouchMoveListener), { passive: !1 }))
          : __privateSet(this, _touchStartTimestamp, e.timeStamp);
      }
  }),
  (_onPointerMove = new WeakSet()),
  (onPointerMove_fn = function (e) {
    __privateMethod(this, _calculatePosition, calculatePosition_fn).call(this, e);
  }),
  (_onTouchMove = new WeakSet()),
  (onTouchMove_fn = function (e) {
    e.preventDefault();
  }),
  (_onPointerUp = new WeakSet()),
  (onPointerUp_fn = function (e) {
    (this.removeEventListener('touchmove', __privateGet(this, _onTouchMoveListener)),
      document.removeEventListener('pointermove', __privateGet(this, _onPointerMoveListener)),
      matchesMediaQuery('supports-hover') ||
        (e.timeStamp - __privateGet(this, _touchStartTimestamp) <= 250 &&
          __privateMethod(this, _calculatePosition, calculatePosition_fn).call(this, e)));
  }),
  (_onKeyboardNavigation2 = new WeakSet()),
  (onKeyboardNavigation_fn2 = function (e) {
    if (
      !e.target.classList.contains('before-after__cursor') ||
      (!this.hasAttribute('vertical') && 'ArrowLeft' !== e.code && 'ArrowRight' !== e.code) ||
      (this.hasAttribute('vertical') && 'ArrowUp' !== e.code && 'ArrowDown' !== e.code)
    )
      return;
    e.preventDefault();
    let t,
      i = parseInt(this.style.getPropertyValue('--before-after-cursor-position'));
    (Number.isNaN(i) &&
      (i = parseInt(getComputedStyle(this).getPropertyValue('--before-after-initial-cursor-position'))),
      (t = this.hasAttribute('vertical')
        ? 'ArrowUp' === e.code
          ? i - 1
          : i + 1
        : 'ArrowLeft' === e.code
          ? i - 1
          : i + 1),
      this.style.setProperty('--before-after-cursor-position', `${Math.min(Math.max(t, 0), 100)}%`));
  }),
  (_calculatePosition = new WeakSet()),
  (calculatePosition_fn = function (e) {
    let t,
      i = this.getBoundingClientRect();
    (this.hasAttribute('vertical')
      ? (t = ((e.clientY - i.top) / this.clientHeight) * 100)
      : ((t = ((e.clientX - i.left) / this.clientWidth) * 100), (t = 'rtl' === document.dir ? 100 - t : t)),
      this.style.setProperty('--before-after-cursor-position', `${Math.min(Math.max(t, 0), 100)}%`));
  }),
  (_animateInitialPosition = new WeakSet()),
  (animateInitialPosition_fn = function () {
    animate12(
      (e) => {
        this.style.setProperty(
          '--before-after-cursor-position',
          `calc(var(--before-after-initial-cursor-position) * ${e})`,
        );
      },
      { duration: 0.6, easing: [0.85, 0, 0.15, 1] },
    );
  }),
  window.customElements.get('before-after') || window.customElements.define('before-after', BeforeAfter));
import { animate as animate13, stagger as stagger2, inView as inView10 } from 'vendor';
var _sectionId,
  _onBundleSection,
  onBundleSection_fn,
  _onCartChange,
  onCartChange_fn,
  _onBeforeShow,
  onBeforeShow_fn,
  _onPageShow,
  onPageShow_fn,
  _refreshCart,
  refreshCart_fn,
  _replaceContent,
  replaceContent_fn,
  BlogPosts = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _reveal),
        this.hasAttribute('reveal-on-scroll') &&
          matchesMediaQuery('motion-safe') &&
          inView10(this, __privateMethod(this, _reveal, reveal_fn).bind(this), { margin: '-50px 0px' }));
    }
  };
((_reveal = new WeakSet()),
  (reveal_fn = function () {
    ((this.style.opacity = '1'),
      animate13(
        this.children,
        { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
        { duration: 0.25, delay: stagger2(0.1, { easing: 'ease-out' }), easing: 'ease' },
      ));
  }),
  window.customElements.get('blog-posts') || window.customElements.define('blog-posts', BlogPosts));
import { animate as animate14, timeline as timeline7 } from 'vendor';
var CartDrawer = class extends Drawer {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onBundleSection),
      __privateAdd(this, _onCartChange),
      __privateAdd(this, _onBeforeShow),
      __privateAdd(this, _onPageShow),
      __privateAdd(this, _refreshCart),
      __privateAdd(this, _replaceContent),
      __privateAdd(this, _sectionId, void 0));
  }
  connectedCallback() {
    (super.connectedCallback(),
      __privateGet(this, _sectionId) ?? __privateSet(this, _sectionId, extractSectionId(this)),
      document.addEventListener(
        'cart:prepare-bundled-sections',
        __privateMethod(this, _onBundleSection, onBundleSection_fn).bind(this),
        { signal: this.abortController.signal },
      ),
      document.addEventListener('cart:change', __privateMethod(this, _onCartChange, onCartChange_fn).bind(this), {
        signal: this.abortController.signal,
      }),
      document.addEventListener('cart:refresh', __privateMethod(this, _refreshCart, refreshCart_fn).bind(this), {
        signal: this.abortController.signal,
      }),
      window.addEventListener('pageshow', __privateMethod(this, _onPageShow, onPageShow_fn).bind(this), {
        signal: this.abortController.signal,
      }),
      this.addEventListener('dialog:before-show', __privateMethod(this, _onBeforeShow, onBeforeShow_fn)));
  }
};
((_sectionId = new WeakMap()),
  (_onBundleSection = new WeakSet()),
  (onBundleSection_fn = function (e) {
    e.detail.sections.push(__privateGet(this, _sectionId));
  }),
  (_onCartChange = new WeakSet()),
  (onCartChange_fn = async function (e) {
    (__privateMethod(this, _replaceContent, replaceContent_fn).call(
      this,
      e.detail.cart.sections[__privateGet(this, _sectionId)],
    ),
      ('drawer' !== window.themeVariables.settings.cartType && 'force_open_drawer' !== e.detail.onSuccessDo) ||
        'variant:add' !== e.detail.baseEvent ||
        this.show());
  }),
  (_onBeforeShow = new WeakSet()),
  (onBeforeShow_fn = async function () {
    const e = this.shadowRoot.querySelector('[part="footer"]');
    e &&
      ((e.style.opacity = '0'),
      await waitForEvent(this, 'dialog:after-show'),
      animate14(
        e,
        { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
        { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] },
      ));
  }),
  (_onPageShow = new WeakSet()),
  (onPageShow_fn = async function (e) {
    e.persisted && __privateMethod(this, _refreshCart, refreshCart_fn).call(this);
  }),
  (_refreshCart = new WeakSet()),
  (refreshCart_fn = async function () {
    __privateMethod(this, _replaceContent, replaceContent_fn).call(
      this,
      await (await fetch(`${Shopify.routes.root}?section_id=${__privateGet(this, _sectionId)}`)).text(),
    );
  }),
  (_replaceContent = new WeakSet()),
  (replaceContent_fn = async function (e) {
    const t = new DOMParser().parseFromString(e, 'text/html'),
      i = document
        .createRange()
        .createContextualFragment(
          t.getElementById(`shopify-section-${__privateGet(this, _sectionId)}`).querySelector('cart-drawer').innerHTML,
        ),
      n = (await fetchCart).item_count;
    if (0 === n) {
      const e = timeline7([
        [this.getShadowPartByName('body'), { opacity: [1, 0] }, { duration: 0.15, easing: 'ease-in' }],
        [
          this.getShadowPartByName('footer'),
          { opacity: [1, 0], transform: ['translateY(0)', 'translateY(30px)'] },
          { duration: 0.15, at: '<', easing: 'ease-in' },
        ],
      ]);
      (await e.finished,
        this.replaceChildren(...i.children),
        animate14(
          this.getShadowPartByName('body'),
          { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
          { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] },
        ));
    } else this.replaceChildren(...i.children);
    this.classList.toggle('drawer--center-body', 0 === n);
  }));
var _reveal2,
  reveal_fn2,
  CartNoteDialog = class extends DialogElement {
    createEnterAnimationControls() {
      return animate14(
        this,
        { transform: ['translateY(100%)', 'translateY(0)'] },
        { duration: 0.2, easing: 'ease-in' },
      );
    }
    createLeaveAnimationControls() {
      return animate14(
        this,
        { transform: ['translateY(0)', 'translateY(100%)'] },
        { duration: 0.2, easing: 'ease-in' },
      );
    }
  };
(window.customElements.get('cart-drawer') || window.customElements.define('cart-drawer', CartDrawer),
  window.customElements.get('cart-note-dialog') || window.customElements.define('cart-note-dialog', CartNoteDialog));
import { timeline as timeline8, inView as inView11, Delegate as Delegate6 } from 'vendor';
var _delegate5,
  _onLayoutSwitch,
  onLayoutSwitch_fn,
  _setCartAttribute,
  setCartAttribute_fn,
  CollectionBanner = class extends HTMLElement {
    constructor() {
      (super(...arguments), __privateAdd(this, _reveal2));
    }
    connectedCallback() {
      this.hasAttribute('reveal-on-scroll') &&
        matchesMediaQuery('motion-safe') &&
        inView11(this, __privateMethod(this, _reveal2, reveal_fn2).bind(this));
    }
  };
((_reveal2 = new WeakSet()),
  (reveal_fn2 = async function () {
    const e = this.querySelector('.content-over-media > picture img'),
      t = this.querySelector('.content-over-media > .prose');
    await imageLoaded(e);
    const i =
      'image-parallax' === e.getAttribute('is')
        ? ['scale(1.5) translateY(-11.538461538461538%)', 'scale(1.3) translateY(-11.538461538461538%)']
        : ['scale(1.2)', 'scale(1)'];
    return timeline8([
      [this, { opacity: 1 }, { duration: 0, easing: [0.25, 0.46, 0.45, 0.94] }],
      [e, { opacity: [0, 1], transform: i }, { duration: 0.8, delay: 0.25, at: '<', easing: [0.25, 0.46, 0.45, 0.94] }],
      [
        t,
        { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
        { duration: 0.6, at: '-0.4', easing: [0.215, 0.61, 0.355, 1] },
      ],
    ]);
  }));
var _flips,
  _expirationDate,
  _interval,
  _isVisible,
  _recalculateFlips,
  recalculateFlips_fn,
  CollectionLayoutSwitch = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onLayoutSwitch),
        __privateAdd(this, _setCartAttribute),
        __privateAdd(this, _delegate5, new Delegate6(this)));
    }
    connectedCallback() {
      __privateGet(this, _delegate5).on(
        'click',
        'button[type="button"]',
        __privateMethod(this, _onLayoutSwitch, onLayoutSwitch_fn).bind(this),
      );
    }
    get controlledList() {
      return document.getElementById(this.getAttribute('aria-controls'));
    }
  };
((_delegate5 = new WeakMap()),
  (_onLayoutSwitch = new WeakSet()),
  (onLayoutSwitch_fn = function (e, t) {
    t.classList.contains('is-active') ||
      (this.controlledList.setAttribute(`collection-${this.getAttribute('device')}-layout`, t.value),
      Array.from(this.querySelectorAll('button')).forEach((e) => e.classList.toggle('is-active', e === t)),
      this.controlledList.reveal(),
      __privateMethod(this, _setCartAttribute, setCartAttribute_fn).call(this, t.value));
  }),
  (_setCartAttribute = new WeakSet()),
  (setCartAttribute_fn = function (e) {
    const t = `products_${this.getAttribute('device')}_grid_mode`;
    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [t]: e } }),
      keepalive: !0,
    });
  }),
  window.customElements.get('collection-banner') || window.customElements.define('collection-banner', CollectionBanner),
  window.customElements.get('collection-layout-switch') ||
    window.customElements.define('collection-layout-switch', CollectionLayoutSwitch));
import { animate as animate15, inView as inView12 } from 'vendor';
var CountdownTimer = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _recalculateFlips),
      __privateAdd(this, _flips, void 0),
      __privateAdd(this, _expirationDate, void 0),
      __privateAdd(this, _interval, void 0),
      __privateAdd(this, _isVisible, void 0));
  }
  connectedCallback() {
    __privateSet(this, _flips, Array.from(this.querySelectorAll('countdown-timer-flip')));
    const e = this.getAttribute('expires-at');
    ('' !== e &&
      (__privateSet(this, _expirationDate, new Date(e)),
      __privateSet(
        this,
        _interval,
        setInterval(__privateMethod(this, _recalculateFlips, recalculateFlips_fn).bind(this), 1e3),
      ),
      __privateMethod(this, _recalculateFlips, recalculateFlips_fn).call(this)),
      inView12(this, () => (__privateSet(this, _isVisible, !0), () => __privateSet(this, _isVisible, !1)), {
        margin: '500px',
      }));
  }
  disconnectedCallback() {
    clearInterval(__privateGet(this, _interval));
  }
  get daysFlip() {
    return __privateGet(this, _flips).find((e) => 'days' === e.getAttribute('type'));
  }
  get hoursFlip() {
    return __privateGet(this, _flips).find((e) => 'hours' === e.getAttribute('type'));
  }
  get minutesFlip() {
    return __privateGet(this, _flips).find((e) => 'minutes' === e.getAttribute('type'));
  }
  get secondsFlip() {
    return __privateGet(this, _flips).find((e) => 'seconds' === e.getAttribute('type'));
  }
};
((_flips = new WeakMap()),
  (_expirationDate = new WeakMap()),
  (_interval = new WeakMap()),
  (_isVisible = new WeakMap()),
  (_recalculateFlips = new WeakSet()),
  (recalculateFlips_fn = function () {
    const e = new Date();
    if (__privateGet(this, _expirationDate) < e) {
      if ('hide' !== this.getAttribute('expiration-behavior')) return clearInterval(__privateGet(this, _interval));
      this.closest('.shopify-section').remove();
    }
    if (!__privateGet(this, _isVisible)) return;
    let t = Math.abs(__privateGet(this, _expirationDate) - e) / 1e3;
    const i = Math.floor(t / 86400);
    t -= 86400 * i;
    const n = Math.floor(t / 3600) % 24;
    t -= 3600 * n;
    const a = Math.floor(t / 60) % 60;
    t -= 60 * a;
    const r = Math.floor(t % 60);
    (this.daysFlip?.updateValue(i),
      this.hoursFlip?.updateValue(n),
      this.minutesFlip?.updateValue(a),
      this.secondsFlip?.updateValue(r));
  }));
var _loginForm,
  loginForm_get,
  _recoverForm,
  recoverForm_get,
  _switchForm,
  switchForm_fn,
  CountdownTimerFlip = class extends HTMLElement {
    constructor() {
      (super(), this.attachShadow({ mode: 'open' }));
      let e = [...this.textContent].map(
        () =>
          `<countdown-timer-flip-digit part="digit" ${this.hasAttribute('animate') ? 'animate' : ''} style="display: inline-block">0</countdown-timer-flip-digit>`,
      );
      this.shadowRoot.appendChild(document.createRange().createContextualFragment(e.join('')));
    }
    updateValue(e) {
      ((this.textContent = Math.min(99, e).toString().padStart(2, '0')),
        [...this.textContent].forEach((e, t) => {
          this.shadowRoot.children[t].setAttribute('number', e);
        }));
    }
  },
  CountdownTimerFlipDigit = class extends HTMLElement {
    static observedAttributes = ['number'];
    constructor() {
      (super(),
        this.attachShadow({ mode: 'open' }).appendChild(
          document.createRange().createContextualFragment('<div><slot></slot></div>'),
        ));
    }
    async attributeChangedCallback(e, t, i) {
      if (null === t || t === i || !this.hasAttribute('animate')) return (this.textContent = i);
      (await animate15(
        this.shadowRoot.firstElementChild,
        { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-8px)'] },
        { duration: 0.3, easing: [0.64, 0, 0.78, 0] },
      ).finished,
        (this.textContent = i),
        animate15(
          this.shadowRoot.firstElementChild,
          { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0px)'] },
          { duration: 0.3, easing: [0.22, 1, 0.36, 1] },
        ));
    }
  };
(window.customElements.get('countdown-timer') || window.customElements.define('countdown-timer', CountdownTimer),
  window.customElements.get('countdown-timer-flip') ||
    window.customElements.define('countdown-timer-flip', CountdownTimerFlip),
  window.customElements.get('countdown-timer-flip-digit') ||
    window.customElements.define('countdown-timer-flip-digit', CountdownTimerFlipDigit));
import { animate as animate16 } from 'vendor';
var _observer,
  _onObserve,
  onObserve_fn,
  AccountLogin = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _loginForm),
        __privateAdd(this, _recoverForm),
        __privateAdd(this, _switchForm),
        window.addEventListener('hashchange', __privateMethod(this, _switchForm, switchForm_fn).bind(this)),
        '#recover' === window.location.hash &&
          ((__privateGet(this, _loginForm, loginForm_get).hidden = !0),
          (__privateGet(this, _recoverForm, recoverForm_get).hidden = !1)));
    }
  };
((_loginForm = new WeakSet()),
  (loginForm_get = function () {
    return this.querySelector('#login');
  }),
  (_recoverForm = new WeakSet()),
  (recoverForm_get = function () {
    return this.querySelector('#recover');
  }),
  (_switchForm = new WeakSet()),
  (switchForm_fn = async function () {
    const e =
        '#recover' === window.location.hash
          ? __privateGet(this, _loginForm, loginForm_get)
          : __privateGet(this, _recoverForm, recoverForm_get),
      t =
        '#recover' === window.location.hash
          ? __privateGet(this, _recoverForm, recoverForm_get)
          : __privateGet(this, _loginForm, loginForm_get);
    (await animate16(
      e,
      { transform: ['translateY(0)', 'translateY(30px)'], opacity: [1, 0] },
      { duration: 0.6, easing: 'ease' },
    ).finished,
      (e.hidden = !0),
      (t.hidden = !1),
      await animate16(
        t,
        { transform: ['translateY(30px)', 'translateY(0)'], opacity: [0, 1] },
        { duration: 0.6, easing: 'ease' },
      ));
  }),
  window.customElements.get('account-login') || window.customElements.define('account-login', AccountLogin));
var FaqToc = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onObserve),
      __privateAdd(
        this,
        _observer,
        new IntersectionObserver(__privateMethod(this, _onObserve, onObserve_fn).bind(this), {
          rootMargin: '0px 0px -70% 0px',
        }),
      ));
  }
  connectedCallback() {
    this.anchoredElements.forEach((e) => __privateGet(this, _observer).observe(e));
  }
  disconnectedCallback() {
    __privateGet(this, _observer).disconnect();
  }
  get anchorLinks() {
    return Array.from(this.querySelectorAll('a[href^="#"]'));
  }
  get anchoredElements() {
    return this.anchorLinks.map((e) => document.querySelector(e.getAttribute('href')));
  }
};
((_observer = new WeakMap()),
  (_onObserve = new WeakSet()),
  (onObserve_fn = function (e) {
    for (const t of e) {
      const e = this.anchorLinks.find((e) => e.getAttribute('href') === `#${t.target.id}`);
      (!t.isIntersecting && e.classList.contains('is-active')) ||
        (t.isIntersecting && this.anchorLinks.forEach((t) => t.classList.toggle('is-active', t === e)));
    }
  }),
  window.customElements.get('faq-toc') || window.customElements.define('faq-toc', FaqToc));
import { animate as animate17 } from 'vendor';
var _headerTrackerIntersectionObserver,
  _abortController8,
  _scrollYTrackingPosition,
  _isVisible2,
  _onHeaderTrackerIntersection,
  onHeaderTrackerIntersection_fn,
  _detectMousePosition,
  detectMousePosition_fn,
  _detectScrollDirection,
  detectScrollDirection_fn,
  _setVisibility,
  setVisibility_fn,
  FeaturedCollectionsCarousel = class extends EffectCarousel {
    createOnChangeAnimationControls(e, t) {
      return {
        leaveControls: () =>
          animate17(
            e,
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(15px)'] },
            { duration: 0.3, easing: 'ease-in' },
          ),
        enterControls: () =>
          animate17(
            t,
            { opacity: [0, 1], transform: ['translateY(15px)', 'translateY(0)'] },
            { duration: 0.2, delay: 0.2, easing: 'ease-out' },
          ),
      };
    }
  };
window.customElements.get('featured-collections-carousel') ||
  window.customElements.define('featured-collections-carousel', FeaturedCollectionsCarousel);
import { animate as animate18, timeline as timeline9, stagger as stagger3, Delegate as Delegate7 } from 'vendor';
var Header = class extends HTMLElement {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _onHeaderTrackerIntersection),
      __privateAdd(this, _detectMousePosition),
      __privateAdd(this, _detectScrollDirection),
      __privateAdd(this, _setVisibility),
      __privateAdd(
        this,
        _headerTrackerIntersectionObserver,
        new IntersectionObserver(
          __privateMethod(this, _onHeaderTrackerIntersection, onHeaderTrackerIntersection_fn).bind(this),
        ),
      ),
      __privateAdd(this, _abortController8, void 0),
      __privateAdd(this, _scrollYTrackingPosition, 0),
      __privateAdd(this, _isVisible2, !0));
  }
  connectedCallback() {
    (__privateSet(this, _abortController8, new AbortController()),
      __privateGet(this, _headerTrackerIntersectionObserver).observe(document.getElementById('header-scroll-tracker')),
      this.hasAttribute('hide-on-scroll') &&
        (window.addEventListener(
          'scroll',
          __privateMethod(this, _detectScrollDirection, detectScrollDirection_fn).bind(this),
          { signal: __privateGet(this, _abortController8).signal },
        ),
        window.addEventListener(
          'pointermove',
          __privateMethod(this, _detectMousePosition, detectMousePosition_fn).bind(this),
          { signal: __privateGet(this, _abortController8).signal },
        )));
  }
  disconnectedCallback() {
    __privateGet(this, _abortController8).abort();
  }
};
((_headerTrackerIntersectionObserver = new WeakMap()),
  (_abortController8 = new WeakMap()),
  (_scrollYTrackingPosition = new WeakMap()),
  (_isVisible2 = new WeakMap()),
  (_onHeaderTrackerIntersection = new WeakSet()),
  (onHeaderTrackerIntersection_fn = function (e) {
    this.classList.toggle('is-solid', !e[0].isIntersecting);
  }),
  (_detectMousePosition = new WeakSet()),
  (detectMousePosition_fn = function (e) {
    e.clientY < 100 &&
      window.matchMedia('screen and (pointer: fine)').matches &&
      (__privateMethod(this, _setVisibility, setVisibility_fn).call(this, !0),
      __privateSet(this, _scrollYTrackingPosition, 0));
  }),
  (_detectScrollDirection = new WeakSet()),
  (detectScrollDirection_fn = function () {
    let e;
    (window.scrollY > __privateGet(this, _scrollYTrackingPosition) &&
    window.scrollY - __privateGet(this, _scrollYTrackingPosition) > 100
      ? ((e = !1), __privateSet(this, _scrollYTrackingPosition, window.scrollY))
      : window.scrollY < __privateGet(this, _scrollYTrackingPosition) &&
        (__privateSet(this, _scrollYTrackingPosition, window.scrollY), (e = !0)),
      void 0 !== e && __privateMethod(this, _setVisibility, setVisibility_fn).call(this, e));
  }),
  (_setVisibility = new WeakSet()),
  (setVisibility_fn = function (e) {
    if (e !== __privateGet(this, _isVisible2)) {
      if (!e && this.querySelectorAll('[open]').length > 0) return;
      (__privateSet(this, _isVisible2, e),
        document.documentElement.style.setProperty('--header-is-visible', e ? '1' : '0'),
        this.classList.toggle('is-hidden', !e));
    }
  }));
var _calculateMaxHeight,
  calculateMaxHeight_fn,
  _collapsiblePanel,
  _buttonElements,
  _openCollapsiblePanel,
  openCollapsiblePanel_fn,
  _onSidebarBeforeShow,
  onSidebarBeforeShow_fn,
  _onSidebarAfterShow,
  onSidebarAfterShow_fn,
  _onSidebarBeforeHide,
  onSidebarBeforeHide_fn,
  _onSidebarAfterHide,
  onSidebarAfterHide_fn,
  DropdownMenuDisclosure = class extends MenuDisclosure {
    createShowAnimationControls() {
      let e = [];
      return (
        window.themeVariables.settings.staggerMenuApparition &&
          (e = [
            this.contentElement.querySelectorAll(':scope > li'),
            { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0)'] },
            { duration: 0.15, at: '-0.15', delay: stagger3(0.1) },
          ]),
        timeline9([[this.contentElement, { opacity: [0, 1] }, { duration: 0.25 }], e])
      );
    }
    createHideAnimationControls() {
      return timeline9([[this.contentElement, { opacity: [1, 0] }, { duration: 0.15 }]]);
    }
  },
  MegaMenuDisclosure = class extends MenuDisclosure {
    createShowAnimationControls() {
      const e = Array.from(this.contentElement.querySelectorAll('.mega-menu__linklist > li'));
      let t = [];
      return (
        window.themeVariables.settings.staggerMenuApparition &&
          (t = [
            { name: 'content', at: '-0.5' },
            [
              e,
              { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0)'] },
              { duration: 0.3, at: 'content', delay: stagger3(0.1) },
            ],
            [
              this.contentElement.querySelector('.mega-menu__promo'),
              { opacity: [0, 1] },
              { duration: 0.3, at: '-0.15' },
            ],
          ]),
        timeline9([[this.contentElement, { opacity: [0, 1] }, { duration: 0.25 }], ...t])
      );
    }
    createHideAnimationControls() {
      return timeline9([[this.contentElement, { opacity: [1, 0] }, { duration: 0.15 }]]);
    }
  },
  HeaderSearch = class extends DialogElement {
    constructor() {
      (super(),
        __privateAdd(this, _calculateMaxHeight),
        this.addEventListener(
          'dialog:before-show',
          __privateMethod(this, _calculateMaxHeight, calculateMaxHeight_fn).bind(this),
        ));
    }
    get shadowDomTemplate() {
      return 'header-search-default-template';
    }
    get shouldLock() {
      return !0;
    }
    createEnterAnimationControls() {
      return timeline9([
        [this.getShadowPartByName('overlay'), { opacity: [0, 1] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }],
        [
          this.getShadowPartByName('content'),
          { opacity: [0, 1], transform: ['translateY(calc(-1 * var(--header-height)))', 'translateY(0)'] },
          { duration: 0.2, at: '<', easing: [0.645, 0.045, 0.355, 1] },
        ],
      ]);
    }
    createLeaveAnimationControls() {
      return timeline9([
        [this.getShadowPartByName('overlay'), { opacity: [1, 0] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }],
        [
          this.getShadowPartByName('content'),
          { opacity: [1, 0], transform: ['translateY(0)', 'translateY(calc(-1 * var(--header-height)))'] },
          { duration: 0.2, at: '<', easing: [0.645, 0.045, 0.355, 1] },
        ],
      ]);
    }
  };
((_calculateMaxHeight = new WeakSet()),
  (calculateMaxHeight_fn = function () {
    const e = this.getBoundingClientRect(),
      t = window.innerHeight - e.top;
    this.style.setProperty('--header-search-max-height', `${t}px`);
  }));
var _sidebarDelegate,
  _closePanel,
  closePanel_fn,
  _switchPanel,
  switchPanel_fn,
  HeaderSidebar = class extends Drawer {
    constructor() {
      (super(),
        __privateAdd(this, _openCollapsiblePanel),
        __privateAdd(this, _onSidebarBeforeShow),
        __privateAdd(this, _onSidebarAfterShow),
        __privateAdd(this, _onSidebarBeforeHide),
        __privateAdd(this, _onSidebarAfterHide),
        __privateAdd(this, _collapsiblePanel, void 0),
        __privateAdd(this, _buttonElements, void 0),
        this.addEventListener(
          'dialog:before-show',
          __privateMethod(this, _onSidebarBeforeShow, onSidebarBeforeShow_fn),
        ),
        this.addEventListener('dialog:after-show', __privateMethod(this, _onSidebarAfterShow, onSidebarAfterShow_fn)),
        this.addEventListener(
          'dialog:before-hide',
          __privateMethod(this, _onSidebarBeforeHide, onSidebarBeforeHide_fn),
        ),
        this.addEventListener('dialog:after-hide', __privateMethod(this, _onSidebarAfterHide, onSidebarAfterHide_fn)));
    }
    connectedCallback() {
      (super.connectedCallback(),
        __privateSet(this, _collapsiblePanel, this.querySelector('[slot="collapsible-panel"]')),
        __privateSet(
          this,
          _buttonElements,
          Array.from(this.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist [aria-controls]')),
        ),
        __privateGet(this, _buttonElements).forEach((e) =>
          e.addEventListener(
            'click',
            __privateMethod(this, _openCollapsiblePanel, openCollapsiblePanel_fn).bind(this),
            { signal: this.abortController.signal },
          ),
        ));
    }
    revealItems(e = !1) {
      return timeline9([
        [
          this.querySelector('.header-sidebar__main-panel'),
          { opacity: 1, transform: 'translateX(0)' },
          { duration: 0, delay: e ? 0.5 : 0 },
        ],
        [
          this.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist li'),
          { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0)'] },
          {
            duration: 0.15,
            at: '-0.15',
            delay: window.themeVariables.settings.staggerMenuApparition ? stagger3(0.1) : 0,
          },
        ],
        [
          this.querySelector('.header-sidebar__footer'),
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.3 },
        ],
      ]);
    }
  };
((_collapsiblePanel = new WeakMap()),
  (_buttonElements = new WeakMap()),
  (_openCollapsiblePanel = new WeakSet()),
  (openCollapsiblePanel_fn = function (e) {
    (__privateGet(this, _buttonElements).forEach((t) =>
      t.setAttribute('aria-expanded', t === e.currentTarget ? 'true' : 'false'),
    ),
      __privateGet(this, _collapsiblePanel)?.setAttribute(
        'aria-activedescendant',
        e.currentTarget.getAttribute('aria-controls'),
      ),
      matchesMediaQuery('md-max') &&
        animate18(
          this.querySelector('.header-sidebar__main-panel'),
          { opacity: [1, 0], transform: ['translateX(0)', 'translateX(-10px)'] },
          { duration: 0.25 },
        ));
  }),
  (_onSidebarBeforeShow = new WeakSet()),
  (onSidebarBeforeShow_fn = function () {
    animate18(
      this.querySelector('.header-sidebar__main-panel'),
      { opacity: 0, transform: 'translateX(0)' },
      { duration: 0 },
    );
  }),
  (_onSidebarAfterShow = new WeakSet()),
  (onSidebarAfterShow_fn = function () {
    this.revealItems();
  }),
  (_onSidebarBeforeHide = new WeakSet()),
  (onSidebarBeforeHide_fn = function () {
    matchesMediaQuery('md') &&
      (__privateGet(this, _collapsiblePanel)?.removeAttribute('aria-activedescendant'),
      __privateGet(this, _buttonElements).forEach((e) => e.setAttribute('aria-expanded', 'false')));
  }),
  (_onSidebarAfterHide = new WeakSet()),
  (onSidebarAfterHide_fn = function () {
    (matchesMediaQuery('md-max') &&
      (__privateGet(this, _collapsiblePanel)?.removeAttribute('aria-activedescendant'),
      __privateGet(this, _buttonElements).forEach((e) => e.setAttribute('aria-expanded', 'false'))),
      Array.from(this.querySelectorAll('details')).forEach((e) => (e.open = !1)));
  }));
var _onBecameVisible,
  onBecameVisible_fn,
  HeaderSidebarCollapsiblePanel = class extends DialogElement {
    constructor() {
      (super(),
        __privateAdd(this, _closePanel),
        __privateAdd(this, _switchPanel),
        __privateAdd(this, _sidebarDelegate, new Delegate7(this)),
        __privateGet(this, _sidebarDelegate).on(
          'click',
          '[data-action="close-panel"]',
          __privateMethod(this, _closePanel, closePanel_fn).bind(this),
        ));
    }
    static get observedAttributes() {
      return [...super.observedAttributes, 'aria-activedescendant'];
    }
    hideForOutsideClickTarget(e) {
      return !1;
    }
    allowOutsideClickForTarget(e) {
      return void 0 !== e.closest('.header-sidebar');
    }
    createEnterAnimationControls() {
      return matchesMediaQuery('md-max')
        ? timeline9([[this, { opacity: [0, 1], transform: 'translateX(0)' }, { duration: 0.3 }]])
        : timeline9([
            [
              this,
              {
                opacity: [0, 1],
                transform: ['translateX(0)', 'translateX(calc(var(--transform-logical-flip) * 100%)'],
              },
              { duration: 0.3 },
            ],
          ]);
    }
    createLeaveAnimationControls() {
      return matchesMediaQuery('md-max')
        ? timeline9([[this, { opacity: [1, 0], transform: ['translateX(0)', 'translateX(10px)'] }, { duration: 0.3 }]])
        : timeline9([
            [
              this,
              {
                opacity: [1, 0],
                transform: ['translateX(calc(var(--transform-logical-flip) * 100%))', 'translateX(0)'],
              },
              { duration: 0.3 },
            ],
          ]);
    }
    async attributeChangedCallback(e, t, i) {
      if ((super.attributeChangedCallback(e, t, i), 'aria-activedescendant' === e)) {
        if (t === i) return;
        null !== i
          ? __privateMethod(this, _switchPanel, switchPanel_fn).call(
              this,
              this.querySelector(`#${t}`),
              this.querySelector(`#${i}`),
            )
          : (await this.hide(),
            Array.from(this.querySelectorAll('.header-sidebar__sub-panel')).forEach((e) => (e.hidden = !0)));
      }
    }
  };
((_sidebarDelegate = new WeakMap()),
  (_closePanel = new WeakSet()),
  (closePanel_fn = function () {
    (this.removeAttribute('aria-activedescendant'), this.closest('header-sidebar').revealItems(!0));
  }),
  (_switchPanel = new WeakSet()),
  (switchPanel_fn = async function (e, t) {
    (this.open || (await this.show()),
      e &&
        (await animate18(e, { opacity: [1, 0] }, { duration: 0.15 }).finished,
        (e.hidden = !0),
        Array.from(e.querySelectorAll('details')).forEach((e) => (e.open = !1))),
      (t.hidden = !1));
    const i = matchesMediaQuery('md-max')
      ? '.header-sidebar__back-button, .header-sidebar__linklist li'
      : '.header-sidebar__linklist li';
    timeline9([
      [t, { opacity: 1 }, { duration: 0 }],
      [
        t.querySelectorAll(i),
        { opacity: [0, 1], transform: ['translateY(8px)', 'translateY(0)'] },
        {
          duration: 0.15,
          at: '-0.15',
          delay: window.themeVariables.settings.staggerMenuApparition ? stagger3(0.1) : 0,
        },
      ],
      [t.querySelector('.header-sidebar__promo'), { opacity: [0, 1] }, { duration: 0.45 }],
    ]);
  }),
  window.customElements.get('x-header') || window.customElements.define('x-header', Header),
  window.customElements.get('dropdown-menu-disclosure') ||
    window.customElements.define('dropdown-menu-disclosure', DropdownMenuDisclosure, { extends: 'details' }),
  window.customElements.get('mega-menu-disclosure') ||
    window.customElements.define('mega-menu-disclosure', MegaMenuDisclosure, { extends: 'details' }),
  window.customElements.get('header-search') || window.customElements.define('header-search', HeaderSearch),
  window.customElements.get('header-sidebar') || window.customElements.define('header-sidebar', HeaderSidebar),
  window.customElements.get('header-sidebar-collapsible-panel') ||
    window.customElements.define('header-sidebar-collapsible-panel', HeaderSidebarCollapsiblePanel));
import { animate as animate19, inView as inView13 } from 'vendor';
var _preventInitialTransition2,
  _onBecameVisible2,
  onBecameVisible_fn2,
  ImageWithText = class extends HTMLElement {
    constructor() {
      (super(...arguments), __privateAdd(this, _onBecameVisible));
    }
    connectedCallback() {
      matchesMediaQuery('motion-safe') &&
        inView13(
          this.querySelector('[reveal-on-scroll="true"]'),
          ({ target: e }) => __privateMethod(this, _onBecameVisible, onBecameVisible_fn).call(this, e),
          { margin: '-200px 0px 0px 0px' },
        );
    }
  };
((_onBecameVisible = new WeakSet()),
  (onBecameVisible_fn = async function (e) {
    await imageLoaded(e);
    const t =
      ('rtl' === window.direction ? -1 : 1) *
      (matchesMediaQuery('md-max') ? 0.6 : 1) *
      (this.classList.contains('image-with-text--reverse') ? 25 : -25);
    animate19(
      e,
      { opacity: 1, transform: [`translateX(${t}px)`, 'translateX(0)'] },
      { easing: [0.215, 0.61, 0.355, 1] },
      { duration: 0.8 },
    );
  }),
  window.customElements.get('image-with-text') || window.customElements.define('image-with-text', ImageWithText));
import { timeline as timeline10, inView as inView14 } from 'vendor';
var _itemElements,
  _imageElements,
  _textElements,
  _visibleImageElement,
  _setupScrollObservers,
  setupScrollObservers_fn,
  _onBreakpointChanged,
  onBreakpointChanged_fn,
  ImageWithTextOverlay = class extends HTMLElement {
    constructor() {
      (super(),
        __privateAdd(this, _onBecameVisible2),
        __privateAdd(this, _preventInitialTransition2, !1),
        Shopify.designMode &&
          this.closest('.shopify-section').addEventListener('shopify:section:select', (e) =>
            __privateSet(this, _preventInitialTransition2, e.detail.load),
          ));
    }
    connectedCallback() {
      matchesMediaQuery('motion-safe') &&
        'true' === this.getAttribute('reveal-on-scroll') &&
        inView14(this, ({ target: e }) => __privateMethod(this, _onBecameVisible2, onBecameVisible_fn2).call(this, e), {
          amount: 0.05,
        });
    }
  };
((_preventInitialTransition2 = new WeakMap()),
  (_onBecameVisible2 = new WeakSet()),
  (onBecameVisible_fn2 = async function (e) {
    const t = e.querySelector('.content-over-media > picture img, .content-over-media > svg'),
      i = e.querySelector('.content-over-media > :not(picture, svg)');
    await imageLoaded(t);
    const n = timeline10([
      [e, { opacity: 1 }],
      [t, { opacity: [0, 1], scale: [1.1, 1], easing: [0.215, 0.61, 0.355, 1], duration: 0.8 }],
      [i, { opacity: [0, 1], duration: 0.8 }],
    ]);
    __privateGet(this, _preventInitialTransition2) && n.finish();
  }),
  window.customElements.get('image-with-text-overlay') ||
    window.customElements.define('image-with-text-overlay', ImageWithTextOverlay));
import {
  timeline as timeline11,
  animate as animate20,
  inView as inView15,
  scroll as scroll2,
  ScrollOffset,
} from 'vendor';
var ImagesWithTextScroll = class extends EffectCarousel {
  constructor() {
    (super(...arguments),
      __privateAdd(this, _setupScrollObservers),
      __privateAdd(this, _onBreakpointChanged),
      __privateAdd(this, _itemElements, void 0),
      __privateAdd(this, _imageElements, void 0),
      __privateAdd(this, _textElements, void 0),
      __privateAdd(this, _visibleImageElement, void 0));
  }
  connectedCallback() {
    (super.connectedCallback(),
      __privateSet(this, _itemElements, Array.from(this.querySelectorAll('.images-with-text-scroll__item'))),
      __privateSet(this, _imageElements, Array.from(this.querySelectorAll('.images-with-text-scroll__image'))),
      __privateSet(this, _textElements, Array.from(this.querySelectorAll('.images-with-text-scroll__text'))),
      __privateSet(this, _visibleImageElement, __privateGet(this, _imageElements)[0]),
      inView15(this, () => {
        __privateGet(this, _imageElements).forEach((e) => e.setAttribute('loading', 'eager'));
      }),
      matchesMediaQuery('md') && __privateMethod(this, _setupScrollObservers, setupScrollObservers_fn).call(this),
      mediaQueryListener('md', __privateMethod(this, _onBreakpointChanged, onBreakpointChanged_fn).bind(this)));
  }
  get cellSelector() {
    return '.images-with-text-scroll__item';
  }
  get allowSwipe() {
    return matchesMediaQuery('md-max');
  }
  createOnChangeAnimationControls(e, t, { direction: i } = {}) {
    let n = [],
      a = t.querySelector('.images-with-text-scroll__image');
    return (
      a &&
        a !== __privateGet(this, _visibleImageElement) &&
        (n.push(
          [__privateGet(this, _visibleImageElement), { opacity: [1, 0] }, { duration: 0.8, delay: 0.4 }],
          [a, { opacity: [0, 1] }, { duration: 0.8, at: '<', delay: 0.4 }],
        ),
        __privateSet(this, _visibleImageElement, a)),
      timeline11([
        ...n,
        [
          e.querySelector('.images-with-text-scroll__text'),
          { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-15px)'] },
          { duration: 0.4, at: '<', easing: [0.55, 0.055, 0.675, 0.19] },
        ],
        [
          t.querySelector('.images-with-text-scroll__text'),
          { opacity: [0, 1], transform: ['translateY(15px)', 'translateY(0)'] },
          { duration: 0.4, at: '+0.4', easing: [0.25, 0.46, 0.45, 0.94] },
        ],
      ])
    );
  }
};
((_itemElements = new WeakMap()),
  (_imageElements = new WeakMap()),
  (_textElements = new WeakMap()),
  (_visibleImageElement = new WeakMap()),
  (_setupScrollObservers = new WeakSet()),
  (setupScrollObservers_fn = function () {
    (__privateGet(this, _textElements).forEach((e) => {
      scroll2(animate20(e, { opacity: [0, 0.25, 1, 0.25, 0] }), { target: e, offset: ScrollOffset.Any });
    }),
      scroll2(
        (e) => {
          const t = Math.min(
              Math.floor(e.y.progress / (1 / __privateGet(this, _itemElements).length)),
              __privateGet(this, _itemElements).length - 1,
            ),
            i = __privateGet(this, _itemElements)[t].querySelector('.images-with-text-scroll__image');
          i &&
            i !== __privateGet(this, _visibleImageElement) &&
            (timeline11([
              [__privateGet(this, _visibleImageElement), { opacity: [1, 0] }, { duration: 0.25 }],
              [i, { opacity: [0, 1] }, { duration: 0.25, at: '<' }],
            ]),
            __privateSet(this, _visibleImageElement, i));
        },
        { target: this, offset: ['start center', 'end center'] },
      ));
  }),
  (_onBreakpointChanged = new WeakSet()),
  (onBreakpointChanged_fn = function (e) {
    e.matches
      ? (__privateGet(this, _imageElements).forEach((e) => (e.style = null)),
        __privateGet(this, _textElements).forEach((e) => (e.style = null)),
        __privateMethod(this, _setupScrollObservers, setupScrollObservers_fn).call(this))
      : this.getAnimations({ subtree: !0 }).forEach((e) => e.cancel());
  }),
  window.customElements.get('images-with-text-scroll') ||
    window.customElements.define('images-with-text-scroll', ImagesWithTextScroll));
import { scroll as scroll3 } from 'vendor';
var _onReveal,
  onReveal_fn,
  ArticleToolbar = class extends HTMLElement {
    connectedCallback() {
      window.matchMedia('(prefers-reduced-motion: no-preference)').matches &&
        scroll3(
          (e) => {
            this.classList.toggle('is-visible', e.y.progress > 0 && e.y.progress < 1);
          },
          { target: this.closest('.shopify-section'), offset: ['100px start', 'end start'] },
        );
    }
  };
window.customElements.get('article-toolbar') || window.customElements.define('article-toolbar', ArticleToolbar);
import { animate as animate21, inView as inView16 } from 'vendor';
var MediaGrid = class extends HTMLElement {
  constructor() {
    (super(...arguments), __privateAdd(this, _onReveal));
  }
  connectedCallback() {
    matchesMediaQuery('motion-safe') &&
      inView16(
        this.querySelectorAll('[reveal-on-scroll="true"]'),
        __privateMethod(this, _onReveal, onReveal_fn).bind(this),
        { margin: '-200px 0px 0px 0px' },
      );
  }
};
((_onReveal = new WeakSet()),
  (onReveal_fn = async function (e) {
    (await imageLoaded(e.target.querySelector(':scope > img')),
      animate21(e.target, { opacity: [0, 1] }, { duration: 0.35, easing: 'ease' }));
  }),
  window.customElements.get('media-grid') || window.customElements.define('media-grid', MediaGrid));
var _preventInitialTransition3,
  _onBecameVisible3,
  onBecameVisible_fn3,
  MultiColumn = class extends HTMLElement {
    constructor() {
      (super(),
        Shopify.designMode &&
          this.addEventListener('shopify:block:select', (e) => {
            e.target.scrollIntoView({
              inline: 'center',
              block: 'nearest',
              behavior: e.detail.load ? 'auto' : 'smooth',
            });
          }));
    }
  };
window.customElements.get('multi-column') || window.customElements.define('multi-column', MultiColumn);
import { timeline as timeline12, inView as inView17 } from 'vendor';
var MultipleMediaWithText = class extends HTMLElement {
  constructor() {
    (super(),
      __privateAdd(this, _onBecameVisible3),
      __privateAdd(this, _preventInitialTransition3, !1),
      Shopify.designMode &&
        this.closest('.shopify-section').addEventListener('shopify:section:select', (e) =>
          __privateSet(this, _preventInitialTransition3, e.detail.load),
        ));
  }
  connectedCallback() {
    matchesMediaQuery('motion-safe') &&
      this.hasAttribute('reveal-on-scroll') &&
      inView17(this, __privateMethod(this, _onBecameVisible3, onBecameVisible_fn3).bind(this), { margin: '-10% 0px' });
  }
};
((_preventInitialTransition3 = new WeakMap()),
  (_onBecameVisible3 = new WeakSet()),
  (onBecameVisible_fn3 = function () {
    const e = timeline12([
      [this, { opacity: 1 }, { duration: 0 }],
      'media',
      ...Array.from(this.querySelectorAll('.multiple-media-with-text__media-wrapper > *'), (e) => [
        e,
        { opacity: [0, 1], transform: ['rotate(0deg)', `rotate(${e.style.getPropertyValue('--media-rotate')})`] },
        { duration: 0.5, at: 'media' },
      ]),
      [
        this.querySelector('.multiple-media-with-text__content-wrapper'),
        { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
        { duration: 0.5 },
      ],
    ]);
    __privateGet(this, _preventInitialTransition3) && e.finish();
  }),
  window.customElements.get('multiple-media-with-text') ||
    window.customElements.define('multiple-media-with-text', MultipleMediaWithText));
var _delegate6,
  _onConsentLibraryLoaded,
  onConsentLibraryLoaded_fn,
  _acceptPolicy,
  acceptPolicy_fn,
  _declinePolicy,
  declinePolicy_fn,
  NewsletterPopup = class extends PopIn {
    connectedCallback() {
      (super.connectedCallback(),
        this.shouldAppearAutomatically && setTimeout(() => this.show(), this.apparitionDelay));
    }
    get apparitionDelay() {
      return 1e3 * parseInt(this.getAttribute('apparition-delay') || 0);
    }
    get shouldAppearAutomatically() {
      return !(
        'true' === localStorage.getItem('theme:popup-filled') ||
        (this.hasAttribute('only-once') && 'true' === localStorage.getItem('theme:popup-appeared'))
      );
    }
    attributeChangedCallback(e, t, i) {
      (super.attributeChangedCallback(e, t, i),
        'open' === e && this.open && localStorage.setItem('theme:popup-appeared', 'true'));
    }
  };
window.customElements.get('newsletter-popup') || window.customElements.define('newsletter-popup', NewsletterPopup);
import { Delegate as Delegate8 } from 'vendor';
var _intersectionObserver2,
  _formElement,
  _footerElement,
  _latestFooterCondition,
  _latestFormCondition,
  _onFormVisibilityChange,
  onFormVisibilityChange_fn,
  PrivacyBanner = class extends PopIn {
    constructor() {
      (super(),
        __privateAdd(this, _onConsentLibraryLoaded),
        __privateAdd(this, _acceptPolicy),
        __privateAdd(this, _declinePolicy),
        __privateAdd(this, _delegate6, new Delegate8(this)),
        window.Shopify.loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1',
            onLoad: __privateMethod(this, _onConsentLibraryLoaded, onConsentLibraryLoaded_fn).bind(this),
          },
        ]));
    }
    connectedCallback() {
      (super.connectedCallback(),
        __privateGet(this, _delegate6).on(
          'click',
          '[data-action="accept"]',
          __privateMethod(this, _acceptPolicy, acceptPolicy_fn).bind(this),
        ),
        __privateGet(this, _delegate6).on(
          'click',
          '[data-action="decline"]',
          __privateMethod(this, _declinePolicy, declinePolicy_fn).bind(this),
        ));
    }
    disconnectedCallback() {
      __privateGet(this, _delegate6).off();
    }
  };
((_delegate6 = new WeakMap()),
  (_onConsentLibraryLoaded = new WeakSet()),
  (onConsentLibraryLoaded_fn = function () {
    window.Shopify.customerPrivacy?.shouldShowBanner() && this.show();
  }),
  (_acceptPolicy = new WeakSet()),
  (acceptPolicy_fn = function () {
    window.Shopify.customerPrivacy?.setTrackingConsent(!0, this.hide.bind(this));
  }),
  (_declinePolicy = new WeakSet()),
  (declinePolicy_fn = function () {
    window.Shopify.customerPrivacy?.setTrackingConsent(!1, this.hide.bind(this));
  }),
  window.customElements.get('privacy-banner') || window.customElements.define('privacy-banner', PrivacyBanner));
var _isLoaded,
  _loadRecommendations,
  loadRecommendations_fn,
  ProductStickyBar = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _onFormVisibilityChange),
        __privateAdd(
          this,
          _intersectionObserver2,
          new IntersectionObserver(
            __privateMethod(this, _onFormVisibilityChange, onFormVisibilityChange_fn).bind(this),
          ),
        ),
        __privateAdd(this, _formElement, void 0),
        __privateAdd(this, _footerElement, void 0),
        __privateAdd(this, _latestFooterCondition, !1),
        __privateAdd(this, _latestFormCondition, !1));
    }
    connectedCallback() {
      (__privateSet(this, _formElement, document.forms[this.getAttribute('form')]),
        __privateSet(this, _footerElement, document.querySelector('.shopify-section--footer')),
        __privateGet(this, _formElement) &&
          (__privateGet(this, _intersectionObserver2).observe(__privateGet(this, _formElement)),
          __privateGet(this, _intersectionObserver2).observe(__privateGet(this, _footerElement))));
    }
  };
((_intersectionObserver2 = new WeakMap()),
  (_formElement = new WeakMap()),
  (_footerElement = new WeakMap()),
  (_latestFooterCondition = new WeakMap()),
  (_latestFormCondition = new WeakMap()),
  (_onFormVisibilityChange = new WeakSet()),
  (onFormVisibilityChange_fn = function (e) {
    const [t, i] = [
      e.find((e) => e.target === __privateGet(this, _formElement)),
      e.find((e) => e.target === __privateGet(this, _footerElement)),
    ];
    (t && __privateSet(this, _latestFormCondition, !t.isIntersecting && t.boundingClientRect.bottom < 0),
      i && __privateSet(this, _latestFooterCondition, !i.isIntersecting),
      this.classList.toggle(
        'is-visible',
        __privateGet(this, _latestFooterCondition) && __privateGet(this, _latestFormCondition),
      ));
  }),
  window.customElements.get('product-sticky-bar') ||
    window.customElements.define('product-sticky-bar', ProductStickyBar));
var _isLoaded2,
  _searchQueryString,
  searchQueryString_get,
  _loadProducts,
  loadProducts_fn,
  ProductRecommendations = class extends HTMLElement {
    constructor() {
      (super(...arguments), __privateAdd(this, _loadRecommendations), __privateAdd(this, _isLoaded, !1));
    }
    connectedCallback() {
      __privateMethod(this, _loadRecommendations, loadRecommendations_fn).call(this);
    }
  };
((_isLoaded = new WeakMap()),
  (_loadRecommendations = new WeakSet()),
  (loadRecommendations_fn = async function () {
    if (__privateGet(this, _isLoaded)) return;
    __privateSet(this, _isLoaded, !0);
    const e = this.closest('.shopify-section'),
      t = this.getAttribute('intent') || 'related',
      i = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute('product')}&limit=${this.getAttribute('limit') || 4}&section_id=${extractSectionId(e)}&intent=${t}`,
      n = await fetch(i, { priority: 'related' === t ? 'low' : 'auto' }),
      a = new DOMParser().parseFromString(await n.text(), 'text/html').querySelector('product-recommendations');
    a.childElementCount > 0
      ? (this.replaceChildren(...document.importNode(a, !0).childNodes), (this.hidden = !1))
      : this.remove();
  }),
  window.customElements.get('product-recommendations') ||
    window.customElements.define('product-recommendations', ProductRecommendations));
var _controlledPopover,
  _selectedHotSpot,
  _setInitialPosition,
  setInitialPosition_fn,
  _onSpotSelected,
  onSpotSelected_fn,
  _onUpdateHotSpotPosition,
  onUpdateHotSpotPosition_fn,
  _onLookChanged,
  onLookChanged_fn,
  _changeLookFocalPoint,
  changeLookFocalPoint_fn,
  _restorePosition,
  restorePosition_fn,
  RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
      (super(...arguments),
        __privateAdd(this, _searchQueryString),
        __privateAdd(this, _loadProducts),
        __privateAdd(this, _isLoaded2, !1));
    }
    connectedCallback() {
      __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
    }
  };
((_isLoaded2 = new WeakMap()),
  (_searchQueryString = new WeakSet()),
  (searchQueryString_get = function () {
    const e = new Set(JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'));
    return (
      this.hasAttribute('exclude-id') && e.delete(parseInt(this.getAttribute('exclude-id'))),
      Array.from(e.values(), (e) => `id:${e}`)
        .slice(0, parseInt(this.getAttribute('products-count')))
        .join(' OR ')
    );
  }),
  (_loadProducts = new WeakSet()),
  (loadProducts_fn = async function () {
    if (__privateGet(this, _isLoaded2)) return;
    __privateSet(this, _isLoaded2, !0);
    const e = this.closest('.shopify-section'),
      t = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(e)}`,
      i = await fetch(t, { priority: 'low' }),
      n = new DOMParser().parseFromString(await i.text(), 'text/html').querySelector('recently-viewed-products');
    n.childElementCount > 0 ? this.replaceChildren(...document.importNode(n, !0).childNodes) : e.remove();
  }),
  window.customElements.get('recently-viewed-products') ||
    window.customElements.define('recently-viewed-products', RecentlyViewedProducts));
import { animate as animate22, timeline as timeline13 } from 'vendor';
var _updateButtonLink,
  updateButtonLink_fn,
  ShopTheLookMobileCarousel = class extends ScrollCarousel {
    constructor() {
      (super(),
        __privateAdd(this, _setInitialPosition),
        __privateAdd(this, _onSpotSelected),
        __privateAdd(this, _onUpdateHotSpotPosition),
        __privateAdd(this, _onLookChanged),
        __privateAdd(this, _changeLookFocalPoint),
        __privateAdd(this, _restorePosition),
        __privateAdd(this, _controlledPopover, void 0),
        __privateAdd(this, _selectedHotSpot, void 0),
        this.addEventListener('carousel:change', __privateMethod(this, _onLookChanged, onLookChanged_fn)),
        Array.from(this.querySelectorAll('.shop-the-look__hot-spot-list')).forEach((e) => {
          (e.carousel.addEventListener(
            'carousel:select',
            __privateMethod(this, _onSpotSelected, onSpotSelected_fn).bind(this),
          ),
            e.carousel.addEventListener('carousel:change', () =>
              __privateMethod(this, _onUpdateHotSpotPosition, onUpdateHotSpotPosition_fn).call(this, e),
            ));
        }),
        Array.from(this.querySelectorAll('.shop-the-look__popover')).forEach((e) => {
          (e.addEventListener(
            'dialog:before-show',
            __privateMethod(this, _changeLookFocalPoint, changeLookFocalPoint_fn).bind(this),
          ),
            e.addEventListener(
              'dialog:before-hide',
              __privateMethod(this, _restorePosition, restorePosition_fn).bind(this),
            ));
        }));
    }
    connectedCallback() {
      (super.connectedCallback(), __privateMethod(this, _setInitialPosition, setInitialPosition_fn).call(this));
    }
    get isExpanded() {
      return this.classList.contains('is-expanded');
    }
  };
((_controlledPopover = new WeakMap()),
  (_selectedHotSpot = new WeakMap()),
  (_setInitialPosition = new WeakSet()),
  (setInitialPosition_fn = function () {
    (__privateSet(
      this,
      _selectedHotSpot,
      this.selectedCell.querySelector('.shop-the-look__hot-spot[aria-current="true"]'),
    ),
      __privateMethod(this, _onLookChanged, onLookChanged_fn).call(this));
  }),
  (_onSpotSelected = new WeakSet()),
  (onSpotSelected_fn = function () {
    this.isExpanded || document.getElementById(this.selectedCell.getAttribute('data-popover-id')).show();
  }),
  (_onUpdateHotSpotPosition = new WeakSet()),
  (onUpdateHotSpotPosition_fn = function (e) {
    (__privateSet(this, _selectedHotSpot, e.querySelector('.shop-the-look__hot-spot[aria-current="true"]')),
      this.isExpanded && __privateMethod(this, _changeLookFocalPoint, changeLookFocalPoint_fn).call(this));
  }),
  (_onLookChanged = new WeakSet()),
  (onLookChanged_fn = function () {
    const e = this.selectedCell.getAttribute('data-popover-id');
    (__privateSet(this, _controlledPopover, document.getElementById(e)),
      this.nextElementSibling.setAttribute('aria-controls', e));
  }),
  (_changeLookFocalPoint = new WeakSet()),
  (changeLookFocalPoint_fn = function () {
    const e = window.innerWidth / this.selectedCell.clientWidth,
      t =
        window.innerHeight -
        __privateGet(this, _controlledPopover).shadowRoot.querySelector('[part="base"]').clientHeight,
      i = Math.round(this.selectedCell.querySelector('.shop-the-look__image-wrapper').clientHeight * e),
      n = Math.max(i - t, 0),
      a = i - n,
      r = Math.round(
        (__privateGet(this, _selectedHotSpot).offsetTop + __privateGet(this, _selectedHotSpot).clientHeight / 2) * e,
      ),
      o = Math.round(r - a / 2),
      s = Math.round(-(this.parentElement.getBoundingClientRect().top - (i - this.selectedCell.offsetHeight) / 2)),
      l = Math.round(s - n),
      d = Math.min(Math.max(s - o, l), s);
    (this.isExpanded
      ? animate22(this, { transform: `translateY(${d}px) scale(${e})` }, { duration: 0.4, easing: 'ease-in-out' })
      : (animate22(
          this,
          { transform: ['translateY(0) scale(1)', `translateY(${d}px) scale(${e})`] },
          { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] },
        ),
        document.documentElement.style.setProperty('--hide-header-group', '1')),
      this.classList.add('is-expanded'));
  }),
  (_restorePosition = new WeakSet()),
  (restorePosition_fn = function () {
    (animate22(
      this,
      { transform: 'translateY(0) scale(1)' },
      { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] },
    ).finished.then(() => {
      this.style.transform = null;
    }),
      this.classList.remove('is-expanded'),
      document.documentElement.style.removeProperty('--hide-header-group'));
  }));
var ShopTheLookProductListCarousel = class extends EffectCarousel {
  constructor() {
    (super(),
      __privateAdd(this, _updateButtonLink),
      this.addEventListener(
        'carousel:change',
        __privateMethod(this, _updateButtonLink, updateButtonLink_fn).bind(this),
      ));
  }
};
((_updateButtonLink = new WeakSet()),
  (updateButtonLink_fn = function (e) {
    const t = e.detail.cell.querySelector('.product-card');
    t.hasAttribute('handle') &&
      (this.nextElementSibling.href = `${Shopify.routes.root}products/${t.getAttribute('handle')}`);
  }));
var _delegate7,
  _onVideoEndedListener,
  _autoplayPauseOnVideo,
  autoplayPauseOnVideo_get,
  _getSlideEnteringSequence,
  getSlideEnteringSequence_fn,
  _getSlideLeavingSequence,
  getSlideLeavingSequence_fn,
  _muteVideo,
  muteVideo_fn,
  _unmuteVideo,
  unmuteVideo_fn,
  _onVolumeChange,
  onVolumeChange_fn,
  _onSlideSettle,
  onSlideSettle_fn,
  _onVideoEnded,
  onVideoEnded_fn,
  _onNextButtonClicked,
  onNextButtonClicked_fn,
  _handleAutoplayProgress,
  handleAutoplayProgress_fn,
  ShopTheLookDesktopCarousel = class extends EffectCarousel {
    createOnBecameVisibleAnimationControls(e) {
      return animate22(
        e.querySelectorAll('.shop-the-look__item-content'),
        { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
        { duration: 0.5 },
      );
    }
    createOnChangeAnimationControls(e, t) {
      return timeline13([
        [e.querySelectorAll('.shop-the-look__item-content'), { opacity: [1, 0] }, { duration: 0.3 }],
        [
          e.querySelectorAll('.shop-the-look__image-wrapper > *'),
          { opacity: [1, 0], transform: ['translateX(0)', 'translateX(-15px)'] },
          { duration: 0.5, at: '<', easing: [0.645, 0.045, 0.355, 1] },
        ],
        [
          t.querySelectorAll('.shop-the-look__image-wrapper > *'),
          { opacity: [0, 1], transform: ['translateX(-15px)', 'translateX(0)'] },
          { duration: 0.5, at: '<' },
        ],
        [
          t.querySelectorAll('.shop-the-look__item-content'),
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.5, at: '-0.1' },
        ],
      ]);
    }
  },
  ShopTheLookPopover = class extends Popover {
    hideForOutsideClickTarget(e) {
      return !1;
    }
    allowOutsideClickForTarget(e) {
      return e.classList.contains('shop-the-look__hot-spot');
    }
  };
(window.customElements.get('shop-the-look-mobile-carousel') ||
  window.customElements.define('shop-the-look-mobile-carousel', ShopTheLookMobileCarousel),
  window.customElements.get('shop-the-look-product-list-carousel') ||
    window.customElements.define('shop-the-look-product-list-carousel', ShopTheLookProductListCarousel),
  window.customElements.get('shop-the-look-desktop-carousel') ||
    window.customElements.define('shop-the-look-desktop-carousel', ShopTheLookDesktopCarousel),
  window.customElements.get('shop-the-look-popover') ||
    window.customElements.define('shop-the-look-popover', ShopTheLookPopover));
import { timeline as timeline14, Delegate as Delegate9 } from 'vendor';
var SlideshowCarousel = class extends EffectCarousel {
  constructor() {
    (super(),
      __privateAdd(this, _autoplayPauseOnVideo),
      __privateAdd(this, _getSlideEnteringSequence),
      __privateAdd(this, _getSlideLeavingSequence),
      __privateAdd(this, _muteVideo),
      __privateAdd(this, _unmuteVideo),
      __privateAdd(this, _onVolumeChange),
      __privateAdd(this, _onSlideSettle),
      __privateAdd(this, _onVideoEnded),
      __privateAdd(this, _onNextButtonClicked),
      __privateAdd(this, _handleAutoplayProgress),
      __privateAdd(this, _delegate7, new Delegate9(this)),
      __privateAdd(this, _onVideoEndedListener, __privateMethod(this, _onVideoEnded, onVideoEnded_fn).bind(this)),
      __privateGet(this, _delegate7).on(
        'click',
        '[data-action="navigate-next"]',
        __privateMethod(this, _onNextButtonClicked, onNextButtonClicked_fn).bind(this),
      ),
      __privateGet(this, _delegate7).on(
        'click',
        '[data-action="unmute"]',
        __privateMethod(this, _unmuteVideo, unmuteVideo_fn).bind(this),
      ),
      __privateGet(this, _delegate7).on(
        'click',
        '[data-action="mute"]',
        __privateMethod(this, _muteVideo, muteVideo_fn).bind(this),
      ),
      this.addEventListener('volumechange', __privateMethod(this, _onVolumeChange, onVolumeChange_fn), { capture: !0 }),
      this.addEventListener('carousel:settle', __privateMethod(this, _onSlideSettle, onSlideSettle_fn)),
      this.hasAttribute('autoplay') &&
        this.player &&
        (this.player.addEventListener(
          'player:start',
          __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this),
        ),
        this.player.addEventListener(
          'player:stop',
          __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this),
        ),
        this.player.addEventListener(
          'player:visibility-pause',
          __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this),
        ),
        this.player.addEventListener(
          'player:visibility-resume',
          __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this),
        )));
  }
  disconnectedCallback() {
    __privateGet(this, _delegate7).destroy();
  }
  async createOnBecameVisibleAnimationControls(e) {
    return (
      'image' === e.getAttribute('media-type')
        ? await imageLoaded(e.querySelectorAll('img'))
        : await videoLoaded(e.querySelectorAll('video')),
      e.hasAttribute('reveal-on-scroll')
        ? timeline14([...__privateMethod(this, _getSlideEnteringSequence, getSlideEnteringSequence_fn).call(this, e)])
        : { finished: Promise.resolve() }
    );
  }
  createOnChangeAnimationControls(e, t, { direction: i } = {}) {
    const n = Array.from(e.querySelectorAll('video')),
      a = Array.from(t.querySelectorAll('video')).filter((e) => e.offsetParent);
    return (
      e.removeEventListener('ended', __privateGet(this, _onVideoEndedListener), { capture: !0 }),
      n.forEach((e) => {
        ((e.muted = !0), e.pause());
      }),
      a.forEach((e) => {
        ((e.muted = !0), (e.currentTime = 0), e.play());
      }),
      {
        leaveControls: () =>
          timeline14(__privateMethod(this, _getSlideLeavingSequence, getSlideLeavingSequence_fn).call(this, e)),
        enterControls: () =>
          timeline14(__privateMethod(this, _getSlideEnteringSequence, getSlideEnteringSequence_fn).call(this, t)),
      }
    );
  }
};
((_delegate7 = new WeakMap()),
  (_onVideoEndedListener = new WeakMap()),
  (_autoplayPauseOnVideo = new WeakSet()),
  (autoplayPauseOnVideo_get = function () {
    return this.hasAttribute('autoplay-pause-on-video');
  }),
  (_getSlideEnteringSequence = new WeakSet()),
  (getSlideEnteringSequence_fn = function (e) {
    const t = e.querySelector('.slideshow__slide-content');
    return t.classList.contains('slideshow__slide-content--boxed')
      ? [
          [e, { opacity: [0, 1] }, { duration: 0.8, easing: [0.25, 0.46, 0.45, 0.94] }],
          [
            e.querySelectorAll('.content-over-media > :is(video-media, svg), .content-over-media > picture img'),
            { opacity: [0, 1], transform: ['scale(1.2)', 'scale(1)'] },
            { duration: 0.8, at: '<', easing: [0.25, 0.46, 0.45, 0.94] },
          ],
          [
            t,
            { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
            { duration: 0.6, at: '-0.4', easing: [0.215, 0.61, 0.355, 1] },
          ],
        ]
      : [
          [e, { opacity: [0, 1] }, { duration: 0.8, easing: [0.25, 0.46, 0.45, 0.94] }],
          [
            e.querySelectorAll('.content-over-media > :is(video-media, svg), .content-over-media > picture img'),
            { opacity: [0, 1], transform: ['scale(1.2)', 'scale(1)'] },
            { duration: 0.8, at: '<', easing: [0.25, 0.46, 0.45, 0.94] },
          ],
          [
            t.querySelector('.prose'),
            { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
            { duration: 0.6, at: '-0.4', easing: [0.215, 0.61, 0.355, 1] },
          ],
          [
            t.querySelector('.button-group'),
            { opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0)'] },
            { duration: 0.6, at: '-0.4', easing: [0.215, 0.61, 0.355, 1] },
          ],
        ];
  }),
  (_getSlideLeavingSequence = new WeakSet()),
  (getSlideLeavingSequence_fn = function (e) {
    const t = e.querySelector('.slideshow__slide-content');
    return t.classList.contains('slideshow__slide-content--boxed')
      ? [
          [
            t,
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(20px)'] },
            { duration: 0.25, at: 'leaving', easing: [0.55, 0.055, 0.675, 0.19] },
          ],
          [
            e.querySelectorAll('.content-over-media > :is(video-media, svg), .content-over-media > picture img'),
            { opacity: [1, 0] },
            { duration: 0.2, at: '-0.1', easing: [0.55, 0.055, 0.675, 0.19] },
          ],
        ]
      : [
          [
            t.querySelector('.prose'),
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(10px)'] },
            { duration: 0.25, at: 'leaving', easing: [0.55, 0.055, 0.675, 0.19] },
          ],
          [
            t.querySelector('.button-group'),
            { opacity: [1, 0], transform: ['translateY(0)', 'translateY(20px)'] },
            { duration: 0.25, at: '<', easing: [0.55, 0.055, 0.675, 0.19] },
          ],
          [
            e.querySelectorAll('.content-over-media > :is(video-media, svg), .content-over-media > picture img'),
            { opacity: [1, 0] },
            { duration: 0.2, at: '-0.1', easing: [0.55, 0.055, 0.675, 0.19] },
          ],
        ];
  }),
  (_muteVideo = new WeakSet()),
  (muteVideo_fn = function (e) {
    (e.preventDefault(),
      Array.from(this.selectedCell.querySelectorAll('video'))
        .filter((e) => e.offsetParent)
        .forEach((e) => (e.muted = !0)));
  }),
  (_unmuteVideo = new WeakSet()),
  (unmuteVideo_fn = function (e) {
    (e.preventDefault(),
      Array.from(this.selectedCell.querySelectorAll('video'))
        .filter((e) => e.offsetParent)
        .forEach((e) => (e.muted = !1)));
  }),
  (_onVolumeChange = new WeakSet()),
  (onVolumeChange_fn = function (e) {
    const t = e.target.closest('.slideshow__slide').querySelector('.slideshow__volume-control');
    t &&
      ((t.querySelector('[data-action="unmute"]').hidden = !e.target.muted),
      (t.querySelector('[data-action="mute"]').hidden = e.target.muted));
  }),
  (_onSlideSettle = new WeakSet()),
  (onSlideSettle_fn = function (e) {
    const t = Array.from(e.detail.cell.querySelectorAll('video'));
    __privateGet(this, _autoplayPauseOnVideo, autoplayPauseOnVideo_get) &&
      this.cells.length > 1 &&
      t.length > 0 &&
      (this.player?.pause(),
      t.forEach((e) => (e.loop = !1)),
      e.detail.cell.addEventListener('ended', __privateGet(this, _onVideoEndedListener), { capture: !0, once: !0 }));
  }),
  (_onVideoEnded = new WeakSet()),
  (onVideoEnded_fn = function () {
    this.next();
  }),
  (_onNextButtonClicked = new WeakSet()),
  (onNextButtonClicked_fn = function () {
    this.closest('.shopify-section').nextElementSibling?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }),
  (_handleAutoplayProgress = new WeakSet()),
  (handleAutoplayProgress_fn = function (e) {
    switch (e.type) {
      case 'player:start':
        let e = this.getAttribute('autoplay');
        if (
          __privateGet(this, _autoplayPauseOnVideo, autoplayPauseOnVideo_get) &&
          'video' === this.selectedCell.getAttribute('media-type')
        ) {
          const t = Array.from(this.selectedCell.querySelectorAll('video'))
            .filter((e) => e.offsetParent)
            .pop();
          t && (e = t.duration);
        }
        (this.style.setProperty('--slideshow-progress-duration', `${e}s`),
          this.style.setProperty('--slideshow-progress-play-state', 'running'));
        break;
      case 'player:stop':
        (this.style.setProperty('--slideshow-progress-duration', '0s'),
          this.style.setProperty('--slideshow-progress-play-state', 'paused'));
        break;
      case 'player:visibility-pause':
        this.style.setProperty('--slideshow-progress-play-state', 'paused');
        break;
      case 'player:visibility-resume':
        this.style.setProperty('--slideshow-progress-play-state', 'running');
    }
  }),
  window.customElements.get('slideshow-carousel') ||
    window.customElements.define('slideshow-carousel', SlideshowCarousel));
import { animate as animate23 } from 'vendor';
var TestimonialCarousel = class extends EffectCarousel {
  createOnChangeAnimationControls(e, t, { direction: i }) {
    return {
      leaveControls: () =>
        animate23(
          e,
          { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-15px)'] },
          { duration: 0.4, easing: [0.55, 0.055, 0.675, 0.19] },
        ),
      enterControls: () =>
        animate23(
          t,
          { opacity: [0, 1], transform: ['translateY(15px)', 'translateY(0)'] },
          { duration: 0.4, delay: 0, easing: [0.25, 0.46, 0.45, 0.94] },
        ),
    };
  }
};
window.customElements.get('testimonial-carousel') ||
  window.customElements.define('testimonial-carousel', TestimonialCarousel);
import { animate as animate24 } from 'vendor';
var TextWithIconsCarousel = class extends EffectCarousel {
  createOnChangeAnimationControls(e, t) {
    return {
      leaveControls: () =>
        animate24(
          e,
          { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-10px)'] },
          { duration: 0.3, easing: 'ease-in' },
        ),
      enterControls: () =>
        animate24(
          t,
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0px)'] },
          { duration: 0.3, delay: 0.2, easing: 'ease-out' },
        ),
    };
  }
};
window.customElements.get('text-with-icons-carousel') ||
  window.customElements.define('text-with-icons-carousel', TextWithIconsCarousel);
import { animate as animate25, timeline as timeline15 } from 'vendor';
var TimelineCarousel = class extends EffectCarousel {
  createOnBecameVisibleAnimationControls(e) {
    return animate25(
      e.querySelectorAll('.timeline__item-content'),
      { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
      { duration: 0.5 },
    );
  }
  createOnChangeAnimationControls(e, t) {
    return timeline15([
      [e.querySelectorAll('.timeline__item-content'), { opacity: [1, 0] }, { duration: 0.3 }],
      [
        e.querySelector('.timeline__item-image-wrapper :is(img, svg)'),
        { opacity: [1, 0], transform: ['translateX(0)', 'translateX(-15px)'] },
        { duration: 0.5, at: '<', easing: [0.645, 0.045, 0.355, 1] },
      ],
      [
        t.querySelector('.timeline__item-image-wrapper :is(img, svg)'),
        { opacity: [0, 1], transform: ['translateX(-15px)', 'translateX(0)'] },
        { duration: 0.5, at: '<' },
      ],
      [
        t.querySelectorAll('.timeline__item-content'),
        { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
        { duration: 0.5, at: '-0.1' },
      ],
    ]);
  }
};
window.customElements.get('timeline-carousel') || window.customElements.define('timeline-carousel', TimelineCarousel);
import { animate as animate26, Delegate as Delegate10 } from 'vendor';
(() => {
  const e = new Delegate10(document.documentElement);
  (window.themeVariables.settings.showPageTransition &&
    window.matchMedia('(prefers-reduced-motion: no-preference)').matches &&
    e.on('click', 'a:not([target="_blank"])', async (e, t) => {
      e.defaultPrevented ||
        e.ctrlKey ||
        e.metaKey ||
        (t.hostname === window.location.hostname &&
          t.pathname !== window.location.pathname &&
          (e.preventDefault(),
          await animate26(document.body, { opacity: 0 }, { duration: 0.2 }).finished,
          (window.location = t.href)));
    }),
    e.on('click', 'a[href*="#"]', (e, t) => {
      if (
        e.defaultPrevented ||
        t.matches('[allow-hash-change]') ||
        t.pathname !== window.location.pathname ||
        t.search !== window.location.search
      )
        return;
      const i = new URL(t.href);
      if ('' === i.hash) return;
      const n = document.querySelector(i.hash);
      n &&
        (e.preventDefault(),
        n.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto',
        }),
        document.documentElement.dispatchEvent(
          new CustomEvent('hashchange:simulate', { bubbles: !0, detail: { hash: i.hash } }),
        ));
    }),
    navigator.platform &&
      /iPad|iPhone|iPod/.test(navigator.platform) &&
      (document.head.querySelector('meta[name="viewport"]').content =
        'width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0'),
    Array.from(document.querySelectorAll('.prose table')).forEach((e) => {
      e.outerHTML = '<div class="table-scroller">' + e.outerHTML + '</div>';
    }));
})();
export {
  AccordionDisclosure,
  AccountLogin,
  AnnouncementBarCarousel,
  ArticleToolbar,
  BadgeList,
  BeforeAfter,
  BlogPosts,
  BuyButtons,
  CarouselNavigation,
  CarouselNextButton,
  CarouselPrevButton,
  CartCount,
  CartDot,
  CartDrawer,
  CartNote,
  CollectionBanner,
  CollectionLayoutSwitch,
  CompareAtPrice,
  ConfirmButton,
  CopyButton,
  CountdownTimer,
  CountdownTimerFlip,
  CountdownTimerFlipDigit,
  CountrySelector,
  CustomDetails,
  DialogCloseButton,
  DialogElement,
  Drawer,
  EffectCarousel,
  FacetLink,
  FacetsDrawer,
  FacetsForm,
  FacetsSortPopover,
  FaqToc,
  FeaturedCollectionsCarousel,
  FreeShippingBar,
  GestureArea,
  GiftCardRecipient,
  Header,
  HeightObserver,
  ImageParallax,
  ImageWithText,
  ImageWithTextOverlay,
  ImagesWithTextScroll,
  LineItemQuantity,
  Listbox,
  LoadingBar,
  MarqueeText,
  MediaGrid,
  MenuDisclosure,
  Modal,
  ModelMedia,
  MultiColumn,
  MultipleMediaWithText,
  NewsletterPopup,
  OnSaleBadge,
  OpenLightBoxButton,
  PaymentTerms,
  PickupAvailability,
  Player,
  PopIn,
  Popover,
  PredictiveSearch,
  PriceRange,
  PrivacyBanner,
  ProductCard,
  ProductForm,
  ProductGallery,
  ProductGalleryNavigation,
  ProductList,
  ProductLoader,
  ProductRecommendations,
  ProductStickyBar,
  ProgressBar,
  QrCode,
  QuantityInput,
  QuantitySelector,
  QuickBuyModal,
  RecentlyViewedProducts,
  ResizableTextarea,
  SafeSticky,
  SalePrice,
  ScrollCarousel,
  ShareButton,
  ShippingEstimator,
  ShopTheLookDesktopCarousel,
  ShopTheLookMobileCarousel,
  ShopTheLookPopover,
  ShopTheLookProductListCarousel,
  SlideshowCarousel,
  SoldOutBadge,
  Tabs,
  TestimonialCarousel,
  TextWithIconsCarousel,
  TimelineCarousel,
  UnitPrice,
  VariantInventory,
  VariantMedia,
  VariantPicker,
  VariantSku,
  VideoMedia,
  cachedFetch,
  createMediaImg,
  debounce,
  extractSectionId,
  fetchCart,
  formatMoney,
  generateSrcset,
  imageLoaded,
  matchesMediaQuery,
  mediaQueryListener,
  throttle,
  videoLoaded,
  waitForEvent,
};
